// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"ljrb6":[function(require,module,exports,__globalThis) {
/**
 * This is the main script file for the theme.
 * All the other scripts are loaded here.
 *
 * This file is deferred, so it will be downloaded asynchronously,
 * but only executed when DOM is ready. You do not need to wait
 * for the DOM to be ready in these scripts.
 *
 * You should make use of custom events in the DOM to wait
 * for parts of the application to be loaded.
 * Example: document.addEventListener('swiperReady', () => {
 *   new Swiper('.swiper-container', {.. etc});
 * });
 *
 * Please comment out any modules you are not using
 * in order to keep the theme lightweight.
 *
 * Remember to keep your code clean, readable and maintainable.
 * Keep your code DRY. https://codinglead.co/javascript/what-is-DRY-code
 * Write code for humans. Parcel will build it for machines.
 * Use the linter. $ npm run lint
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _mainScss = require("../css/main.scss");
var _geoJs = require("./framework/_geo.js");
var _swatchesJs = require("./framework/_swatches.js");
var _recentlyViewedJs = require("./framework/_recently-viewed.js");
var _cartJs = require("./framework/_cart.js");
var _minicartJs = require("./framework/_minicart.js");
// import './framework/_filter.js';
var _wishlistJs = require("./framework/_wishlist.js");
var _quickshopJs = require("./framework/_quickshop.js");
// import './framework/_predictive-search.js';
var _productRecommendationsJs = require("./framework/_product-recommendations.js");
var _bundlesJs = require("./framework/_bundles.js");
// Expose any required utilities to the window
var _utilsJs = require("./framework/utils.js");
// Custom modules
var _countdownTimerJs = require("./custom/_countdown-timer.js");
var _detectOsJs = require("./custom/_detect-os.js");
var _uwpfilters = require("./custom/uwpfilters");
var _quickSearch = require("./custom/_quick-search");
var _faqFiltersJs = require("./custom/_faq-filters.js");
var _productDescriptionJs = require("./custom/_product-description.js");
var _searchPromptsJs = require("./custom/_search-prompts.js");
var _productRedirectJs = require("./custom/_product-redirect.js");
var _productRedirectJsDefault = parcelHelpers.interopDefault(_productRedirectJs);
var _cartJs1 = require("./custom/_cart.js");
var _cartJsDefault = parcelHelpers.interopDefault(_cartJs1);
var _findInStoreJs = require("./custom/_find-in-store.js");
var _findInStoreJsDefault = parcelHelpers.interopDefault(_findInStoreJs);
var _giftCardFormJs = require("./custom/_gift-card-form.js");
var _giftCardFormJsDefault = parcelHelpers.interopDefault(_giftCardFormJs);
var _pdpKlarnaStylerJs = require("./custom/_pdp-klarna-styler.js");
/*
 * **************************
 *
 *         Swiper
 *
 * **************************
 */ var _swiperEsmJs = require("swiper/swiper.esm.js");
var _swiperBundleCss = require("swiper/swiper-bundle.css");
/*
 * **************************
 *
 *     Framework Modules
 *
 * **************************
 */ const ThemeVars = window.ThemeVars;
window.toMoneyString = (0, _utilsJs.toMoneyString);
(function() {
    document.addEventListener('DOMContentLoaded', function() {
        if (window.location.href.indexOf('/products/') > -1) scrollToReviews.init();
    });
})();
window.addEventListener('load', (event)=>{
    (0, _cartJsDefault.default).init();
    (0, _findInStoreJsDefault.default).init();
    if (document.querySelector('gift-card-form')) (0, _giftCardFormJsDefault.default)();
});
if (window.storePage == 'pdp') (0, _productRedirectJsDefault.default).init();
(0, _swiperEsmJs.Swiper).use([
    (0, _swiperEsmJs.Navigation),
    (0, _swiperEsmJs.Pagination),
    (0, _swiperEsmJs.Autoplay),
    (0, _swiperEsmJs.Thumbs)
]);
window.Swiper = (0, _swiperEsmJs.Swiper);
document.dispatchEvent(new CustomEvent('swiperReady'));
/*
 * **************************
 *
 *    Preview Bar Toggle
 *
 * **************************
 */ const previewToggleEnabled = true;
// Only show the toggle if the theme is not the live theme. Note: This property is deprecated and may lose support, that's why we use the opposite of checking if the theme is live.
if (previewToggleEnabled && ThemeVars && (ThemeVars.theme.role == 'unpublished' || ThemeVars.theme.role == 'demo' || ThemeVars.theme.role == 'development')) {
    const previewBarToggle = document.createElement('div');
    previewBarToggle.classList.add('preview-bar-toggle');
    previewBarToggle.innerHTML = `<span class="preview-bar-toggle__icon">
      <?xml version="1.0" ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><polyline fill="none" points="   649,137.999 675,137.999 675,155.999 661,155.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   653,155.999 649,155.999 649,141.999  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/><polyline fill="none" points="   661,156 653,162 653,156  " stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"/></g><g><g><path d="M16,25c-4.265,0-8.301-1.807-11.367-5.088c-0.377-0.403-0.355-1.036,0.048-1.413c0.404-0.377,1.036-0.355,1.414,0.048    C8.778,21.419,12.295,23,16,23c4.763,0,9.149-2.605,11.84-7c-2.69-4.395-7.077-7-11.84-7c-4.938,0-9.472,2.801-12.13,7.493    c-0.272,0.481-0.884,0.651-1.363,0.377c-0.481-0.272-0.649-0.882-0.377-1.363C5.147,10.18,10.333,7,16,7    c5.668,0,10.853,3.18,13.87,8.507c0.173,0.306,0.173,0.68,0,0.985C26.853,21.819,21.668,25,16,25z"/></g><g><path d="M16,21c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S18.757,21,16,21z M16,13c-1.654,0-3,1.346-3,3s1.346,3,3,3    s3-1.346,3-3S17.654,13,16,13z"/></g></g></svg>
    </span>`;
    previewBarToggle.addEventListener('click', ()=>{
        const previewBar = document.querySelector('#preview-bar-iframe');
        previewBar && previewBar.classList.toggle('closed');
        previewBar && previewBarToggle.classList.toggle('open');
        previewBarToggle.style.bottom = previewBar && previewBarToggle.classList.contains('open') ? `calc(${previewBar.offsetHeight}px + 1rem)` : '';
    });
    document.body.appendChild(previewBarToggle);
    // Use a mutation observer to wait for an element with id "preview-bar-iframe" to be added to the DOM
    const observer = new MutationObserver((mutations)=>{
        mutations.forEach((mutation)=>{
            if (mutation.type == 'childList' && mutation.addedNodes.length > 0) {
                const previewBar = document.querySelector('#preview-bar-iframe');
                if (previewBar) previewBar.classList.add('closed');
            }
        });
    });
    observer.observe(document.body, {
        childList: true
    });
    // If the preview bar is already in the DOM, add the class "closed" to it
    const previewBar = document.querySelector('#preview-bar-iframe');
    if (previewBar) previewBar.classList.add('closed');
}

},{"../css/main.scss":"hlRaE","./framework/_geo.js":"e5B4p","./framework/_swatches.js":"a8RC8","./framework/_recently-viewed.js":"iUmrV","./framework/_cart.js":"bFxGc","./framework/_minicart.js":"bzIp9","./framework/_wishlist.js":"9JRvR","./framework/_quickshop.js":"5g71u","./framework/_product-recommendations.js":"93gCs","./framework/_bundles.js":"jIqS0","./framework/utils.js":"juuyl","./custom/_countdown-timer.js":"7T43G","./custom/_detect-os.js":"bBZQF","./custom/uwpfilters":"lQ6yl","./custom/_quick-search":"2URCC","./custom/_faq-filters.js":"abkBw","./custom/_product-description.js":"5IgLD","./custom/_search-prompts.js":"o81LV","./custom/_product-redirect.js":"4Csm5","./custom/_cart.js":"gts0w","./custom/_find-in-store.js":"4RK03","./custom/_gift-card-form.js":"2CjGR","./custom/_pdp-klarna-styler.js":"erudU","swiper/swiper.esm.js":"8onRr","swiper/swiper-bundle.css":"lb26F","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hlRaE":[function() {},{}],"e5B4p":[function(require,module,exports,__globalThis) {
/**
 * This file contains geolocation code. 
 * It's primary function is to return location data,
 * not to actually perform any redirection etc.
 * You should consume this data and perform your own actions.
 */ var _utils = require("./utils");
const lookup = require("1b8cbde7e97dd1c6");
const Geo = {
    /**
   * Gets data about the users location.
   * @returns {object} Information about the users location.
   */ getUserLocationData: async function() {
        const userData = await this.getUserData();
        if (userData == null || userData === '') {
            console.warn('Geo.getUserLocationData() : userData is unavailable.');
            return undefined;
        }
        const countryCode = userData.loc;
        const locationData = lookup.byIso(countryCode);
        return locationData;
    },
    /**
   * Returns the user data from storage if available.
   * If not, returns user data from the API and also stores it in storage.
   * @returns {object} The user data.
   */ getUserData: async function() {
        let userData = await this.getUserDataFromStorage();
        if (!userData || (0, _utils.isEmpty)(userData)) {
            console.log('No user data found in storage, fetching from API instead...');
            userData = await this.getUserDataFromAPI();
            window.localStorage.setItem('userData', JSON.stringify(userData));
        }
        return userData;
    },
    /**
   * Returns the user data from storage if available.
   * @returns {object} The user data.
   */ getUserDataFromStorage: async function() {
        let userData = localStorage.getItem('userData');
        if (userData) userData = JSON.parse(userData);
        return userData;
    },
    /**
   * Returns the user data from the API.
   * @returns {object} The user data.
   */ getUserDataFromAPI: async function() {
        // We can use cloudflare because Shopify is already using Cloudflare's CDN.
        const userData = await fetch('https://www.cloudflare.com/cdn-cgi/trace').then((res)=>res.text());
        const userDataArray = userData.split('\n');
        const userDataObject = {};
        userDataArray.forEach(function(line) {
            const lineArray = line.split('=');
            userDataObject[lineArray[0]] = lineArray[1];
        });
        return userDataObject;
    }
};
window.Geo = Geo;
document.dispatchEvent(new Event('geoReady'));

},{"./utils":"juuyl","1b8cbde7e97dd1c6":"lWSTS"}],"juuyl":[function(require,module,exports,__globalThis) {
/*
 * You need to import utility functions yourself
 * e.g. at the top of your file:
 *    import {makeArrayUnique, handleize} from './_utils.js';
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Removes duplicates from an array and returns the result.
 * @param {Array} array - The array containing duplicates.
 * @returns {Array} A unique array.
 * @example
 * makeArrayUnique([1, 2, 3, 3, 4, 5, 5, 6, 7, 7, 7, 8, 9, 9, 9, 10]);
 * // [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
 */ parcelHelpers.export(exports, "makeArrayUnique", ()=>makeArrayUnique);
/**
 * Converts a string to a valid URL slug.
 * @param {String} string - The string to convert.
 * @returns {String} A URL slug.
 * @example
 * handleize('This is a test!');
 * // this-is-a-test
 */ parcelHelpers.export(exports, "handleize", ()=>handleize);
/**
 * Gets an object representing destructured form data using name and value attributes.
 * @param {HTMLFormElement} form - The form to get data from.
 * @returns {Object} An object containing the form data.
 * @example
 * getParamsFromForm(document.querySelector('form'));
 * // {
 * //   id: '12345',
 * //   quantity: 1,
 * //   properties: {
 * //     'Gift Message': 'Happy Birthday!'
 * //   }
 * // }
 */ parcelHelpers.export(exports, "getParamsFromForm", ()=>getParamsFromForm);
/**
 * Gets a query string representing destructured form data.
 * @param {HTMLFormElement} form - The form to get data from.
 * @param {String} prefix - OPTIONAL: A prefix to prepend to the query string.
 * @returns {String} A query string.
 * @example
 * getQueryStringFromForm(document.querySelector('form'));
 * // id=12345&quantity=1&properties[Gift%20Message]=Happy%20Birthday!
 */ parcelHelpers.export(exports, "getQueryFromForm", ()=>getQueryFromForm);
/**
 * Gets a query string representing a destructured object.
 * @param {Object} object - The object to get data from.
 * @param {String} prefix - OPTIONAL: A prefix to prepend to the query string.
 * @returns {String} A query string.
 * @example
 * getQueryStringFromObject({
 *  id: '12345',
 *  quantity: 1
 * });
 * // id=12345&quantity=1
 */ parcelHelpers.export(exports, "objectToQueryString", ()=>objectToQueryString);
/**
 * Converts an amount into cents (or pennies etc).
 * @param {String|Number} amount - The amount to convert.
 * @returns {Integer} The amount in cents.
 * @example
 * toCents('$1.00');
 * // 100
 */ parcelHelpers.export(exports, "toCents", ()=>toCents);
/**
 * Converts an amount into a money formatted string.
 * @param {String|Number} amount - The amount to convert.
 * @param {Boolean} cents - OPTIONAL: Whether or not the amount is already in cents. Default: true.
 * @returns {String} The amount in money formatted string.
 * @example
 * toMoneyString(100);
 * // '$1.00'
 * toMoneyString(100, false);
 * // '$100.00'
 */ parcelHelpers.export(exports, "toMoneyString", ()=>toMoneyString);
/**
 * Generates a modal window with a given outer class and inner content.
 * @param {String} outerClass - The outer class to add to the modal.
 * @param {String} innerContent - The inner content to add to the modal.
 * @returns {String} The modal window markup.
 */ parcelHelpers.export(exports, "generateModal", ()=>generateModal);
/**
 * Removes and re-adds script tags from an element so they are loaded again.
 * @param {HTMLElement} element - The element to remove and re-add script tags from.
 * @returns {Boolean} Whether or not the element was valid (and thus any script tags were removed and re-added).
 */ parcelHelpers.export(exports, "reloadScripts", ()=>reloadScripts);
/**
 * Capitalizes the first letter in each word of a string.
 * @param {String} string - The string to titleize.
 * @returns {String} A titleized string.
 * @example
 * titleize('hello world');
 * // Hello World
 */ parcelHelpers.export(exports, "titleize", ()=>titleize);
/**
 * Remove keys from an object that are null, undefined, or empty strings/arrays/objects.
 * @param {Object} object - The object to remove keys from.
 * @returns {Object} The object with keys removed.
 * @example
 * removeEmptyKeys({ a: 'Lorem ipsum', b: [1, 2, 3], c: null, d: undefined, e: '', f: [], g: {} });
 * // { a: 'Lorem ipsum', b: [1, 2, 3] }
 */ parcelHelpers.export(exports, "removeEmptyKeys", ()=>removeEmptyKeys);
/**
 * Checks if a passed string/array/object is empty.
 * @param {String|Array|Object} value - The value to check.
 * @returns {Boolean} Whether or not the value is empty.
 * @example
 * isEmpty([]);
 * // true
 * isEmpty('hello');
 * // false
 */ parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
/**
 * Strips whitespace (except single space between words) from a passed in string.
 * @param {String} string - The string to strip.
 * @returns {String} The stripped string.
 * @example
 * stripWhitespace('  hello world  ');
 * // 'hello world'
 */ parcelHelpers.export(exports, "stripWhitespace", ()=>stripWhitespace);
/**
 * Strips all HTML tags from a passed in string.
 * @param {String} string - The string to strip.
 * @returns {String} The stripped string.
 * @example
 * stripHTML('<p>hello world</p>');
 * // 'hello world'
 */ parcelHelpers.export(exports, "stripHTML", ()=>stripHTML);
const ThemeVars = window.ThemeVars;
function makeArrayUnique(array) {
    return array.filter((item, index)=>array.indexOf(item) === index);
}
function handleize(string) {
    return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
function getParamsFromForm(form) {
    const formData = new FormData(form);
    const params = {};
    for (let [key, value] of formData.entries())if (key.includes('[]')) {
        const arrayKey = key.replace('[]', '');
        if (!params[arrayKey]) params[arrayKey] = [];
        params[arrayKey].push(value);
    } else params[key] = value;
    return params;
}
function getQueryFromForm(form, prefix = '') {
    const params = getParamsFromForm(form);
    const queryString = Object.keys(params).map((key)=>{
        const value = params[key];
        if (Array.isArray(value)) return value.map((item)=>`${key}[]=${item}`).join('&');
        else if (typeof value === 'object') return Object.keys(value).map((subKey)=>`${key}[${subKey}]=${value[subKey]}`).join('&');
        else return `${key}=${value}`;
    }).join('&');
    return `${prefix}${queryString}`;
}
function objectToQueryString(object, prefix = '') {
    return prefix + Object.keys(object).map((key)=>`${key}=${object[key]}`).join('&');
}
function toCents(amount) {
    amount = amount.toString().replace(/[^0-9.]/g, '');
    if (amount.includes('.')) {
        amount = parseFloat(amount);
        amount *= 100;
        return Math.round(amount);
    }
    return parseInt(amount * 100);
}
function toMoneyString(amount, cents = true) {
    if (!cents) amount = toCents(amount);
    const moneyAmount = (parseFloat(amount) / 100).toFixed(2);
    const moneyFormat = ThemeVars.moneyFormat || '${{amount}}';
    const parts = moneyFormat.split('{{amount');
    const start = parts[0];
    const end = parts[1].split('}}')[1];
    return `${start}${moneyAmount}${end}`;
}
function generateModal(outerClass, innerContent) {
    return `
  <div class="${outerClass}">
    <div class="${outerClass}__inner">
      ${innerContent}
    </div>
    <style>
      body {
        overflow: hidden;
      }
      .${outerClass} {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 9999999999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .${outerClass}__inner {
        width: 800px;
        max-width: 96%;
        max-height: 100%;
        min-height: 250px;
        background-color: #fff;
        border-radius: 4px;
        overflow-y: auto;
        overflow-x: hidden;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
      }
    </style>
  </div>
`;
}
function reloadScripts(element) {
    if (!element || !(element instanceof HTMLElement)) return false;
    const scriptTags = element.querySelectorAll('script');
    scriptTags.forEach((oldScriptTag)=>{
        const newScriptTag = document.createElement('script');
        newScriptTag.textContent = oldScriptTag.textContent;
        oldScriptTag.remove();
        element.appendChild(newScriptTag);
    });
    return true;
}
function titleize(string) {
    return string.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
function removeEmptyKeys(object) {
    const keys = Object.keys(object);
    keys.forEach((key)=>{
        if (object[key] === null || object[key] === undefined || isEmpty(object[key])) delete object[key];
    });
    return object;
}
function isEmpty(value) {
    if (Array.isArray(value)) return value.length === 0;
    else if (typeof value === 'object') return Object.keys(value).length === 0;
    else return value === '';
}
function stripWhitespace(string) {
    return string.replace(/\s{2,}/g, ' ').trim();
}
function stripHTML(string) {
    return string.replace(/<[^>]*>/g, '');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8mNUT":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"lWSTS":[function(require,module,exports,__globalThis) {
module.exports.byFips = function(code) {
    return search('fips', code.toUpperCase());
};
module.exports.byIso = function(code) {
    if (!isNaN(parseInt(code))) return search('isoNo', ("00" + parseInt(code).toString()).slice(-3));
    if (code.length === 2) return search('iso2', code.toUpperCase());
    if (code.length === 3) return search('iso3', code.toUpperCase());
    throw new Error('cannot determine ISO code type');
};
module.exports.byInternet = function(code) {
    return search('internet', code.toUpperCase());
};
module.exports.byCountry = function(country) {
    return search('country', country);
};
function search(field, code) {
    for(var i = 0; i < countries.length; i++){
        if (countries[i][field] === code) return countries[i];
    }
    return null;
}
var countries = [
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Afghanistan',
        capital: 'Kabul',
        fips: 'AF',
        iso2: 'AF',
        iso3: 'AFG',
        isoNo: '004',
        internet: 'AF'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Albania',
        capital: 'Tirana',
        fips: 'AL',
        iso2: 'AL',
        iso3: 'ALB',
        isoNo: '008',
        internet: 'AL'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Algeria',
        capital: 'Algiers',
        fips: 'AG',
        iso2: 'DZ',
        iso3: 'DZA',
        isoNo: '012',
        internet: 'DZ'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'American Samoa',
        capital: 'Pago Pago',
        fips: 'AQ',
        iso2: 'AS',
        iso3: 'ASM',
        isoNo: '016',
        internet: 'AS'
    },
    {
        continent: 'Europe',
        region: 'South West Europe',
        country: 'Andorra',
        capital: 'Andorra la Vella',
        fips: 'AN',
        iso2: 'AD',
        iso3: 'AND',
        isoNo: '020',
        internet: 'AD'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Angola',
        capital: 'Luanda',
        fips: 'AO',
        iso2: 'AO',
        iso3: 'AGO',
        isoNo: '024',
        internet: 'AO'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Anguilla',
        capital: 'The Valley',
        fips: 'AV',
        iso2: 'AI',
        iso3: 'AIA',
        isoNo: '660',
        internet: 'AI'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Antigua and Barbuda',
        capital: "Saint John's",
        fips: 'AC',
        iso2: 'AG',
        iso3: 'ATG',
        isoNo: '028',
        internet: 'AG'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Argentina',
        capital: 'Buenos Aires',
        fips: 'AR',
        iso2: 'AR',
        iso3: 'ARG',
        isoNo: '032',
        internet: 'AR'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Armenia',
        capital: 'Yerevan',
        fips: 'AM',
        iso2: 'AM',
        iso3: 'ARM',
        isoNo: '051',
        internet: 'AM'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Aruba',
        capital: 'Oranjestad',
        fips: 'AA',
        iso2: 'AW',
        iso3: 'ABW',
        isoNo: '533',
        internet: 'AW'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Australia',
        capital: 'Canberra',
        fips: 'AS',
        iso2: 'AU',
        iso3: 'AUS',
        isoNo: '036',
        internet: 'AU'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Austria',
        capital: 'Vienna',
        fips: 'AU',
        iso2: 'AT',
        iso3: 'AUT',
        isoNo: '040',
        internet: 'AT'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Azerbaijan',
        capital: 'Baku (Baki)',
        fips: 'AJ',
        iso2: 'AZ',
        iso3: 'AZE',
        isoNo: '031',
        internet: 'AZ'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'The Bahamas',
        capital: 'Nassau',
        fips: 'BF',
        iso2: 'BS',
        iso3: 'BHS',
        isoNo: '044',
        internet: 'BS'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Bahrain',
        capital: 'Manama',
        fips: 'BA',
        iso2: 'BH',
        iso3: 'BHR',
        isoNo: '048',
        internet: 'BH'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Bangladesh',
        capital: 'Dhaka',
        fips: 'BG',
        iso2: 'BD',
        iso3: 'BGD',
        isoNo: '050',
        internet: 'BD'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Barbados',
        capital: 'Bridgetown',
        fips: 'BB',
        iso2: 'BB',
        iso3: 'BRB',
        isoNo: '052',
        internet: 'BB'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Belarus',
        capital: 'Minsk',
        fips: 'BO',
        iso2: 'BY',
        iso3: 'BLR',
        isoNo: '112',
        internet: 'BY'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Belgium',
        capital: 'Brussels',
        fips: 'BE',
        iso2: 'BE',
        iso3: 'BEL',
        isoNo: '056',
        internet: 'BE'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Belize',
        capital: 'Belmopan',
        fips: 'BH',
        iso2: 'BZ',
        iso3: 'BLZ',
        isoNo: '084',
        internet: 'BZ'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Benin',
        capital: 'Porto-Novo',
        fips: 'BN',
        iso2: 'BJ',
        iso3: 'BEN',
        isoNo: '204',
        internet: 'BJ'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Bermuda',
        capital: 'Hamilton',
        fips: 'BD',
        iso2: 'BM',
        iso3: 'BMU',
        isoNo: '060',
        internet: 'BM'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Bhutan',
        capital: 'Thimphu',
        fips: 'BT',
        iso2: 'BT',
        iso3: 'BTN',
        isoNo: '064',
        internet: 'BT'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Bolivia',
        capital: 'La Paz / Sucre',
        fips: 'BL',
        iso2: 'BO',
        iso3: 'BOL',
        isoNo: '068',
        internet: 'BO'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Bosnia and Herzegovina',
        capital: 'Sarajevo',
        fips: 'BK',
        iso2: 'BA',
        iso3: 'BIH',
        isoNo: '070',
        internet: 'BA'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Botswana',
        capital: 'Gaborone',
        fips: 'BC',
        iso2: 'BW',
        iso3: 'BWA',
        isoNo: '072',
        internet: 'BW'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Brazil',
        capital: 'Brasilia',
        fips: 'BR',
        iso2: 'BR',
        iso3: 'BRA',
        isoNo: '076',
        internet: 'BR'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'British Virgin Islands',
        capital: 'Road Town',
        fips: 'VI',
        iso2: 'VG',
        iso3: 'VGB',
        isoNo: '092',
        internet: 'VG'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Brunei',
        capital: 'Bandar Seri Begawan',
        fips: 'BX',
        iso2: 'BN',
        iso3: 'BRN',
        isoNo: '096',
        internet: 'BN'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Bulgaria',
        capital: 'Sofia',
        fips: 'BU',
        iso2: 'BG',
        iso3: 'BGR',
        isoNo: '100',
        internet: 'BG'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Burkina Faso',
        capital: 'Ouagadougou',
        fips: 'UV',
        iso2: 'BF',
        iso3: 'BFA',
        isoNo: '854',
        internet: 'BF'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Burundi',
        capital: 'Bujumbura',
        fips: 'BY',
        iso2: 'BI',
        iso3: 'BDI',
        isoNo: '108',
        internet: 'BI'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Cambodia',
        capital: 'Phnom Penh',
        fips: 'CB',
        iso2: 'KH',
        iso3: 'KHM',
        isoNo: '116',
        internet: 'KH'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Cameroon',
        capital: 'Yaounde',
        fips: 'CM',
        iso2: 'CM',
        iso3: 'CMR',
        isoNo: '120',
        internet: 'CM'
    },
    {
        continent: 'Americas',
        region: 'North America',
        country: 'Canada',
        capital: 'Ottawa',
        fips: 'CA',
        iso2: 'CA',
        iso3: 'CAN',
        isoNo: '124',
        internet: 'CA'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Cape Verde',
        capital: 'Praia',
        fips: 'CV',
        iso2: 'CV',
        iso3: 'CPV',
        isoNo: '132',
        internet: 'CV'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Cayman Islands',
        capital: 'George Town',
        fips: 'CJ',
        iso2: 'KY',
        iso3: 'CYM',
        isoNo: '136',
        internet: 'KY'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Central African Republic',
        capital: 'Bangui',
        fips: 'CT',
        iso2: 'CF',
        iso3: 'CAF',
        isoNo: '140',
        internet: 'CF'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Chad',
        capital: "N'Djamena",
        fips: 'CD',
        iso2: 'TD',
        iso3: 'TCD',
        isoNo: '148',
        internet: 'TD'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Chile',
        capital: 'Santiago',
        fips: 'CI',
        iso2: 'CL',
        iso3: 'CHL',
        isoNo: '152',
        internet: 'CL'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'China',
        capital: 'Beijing',
        fips: 'CH',
        iso2: 'CN',
        iso3: 'CHN',
        isoNo: '156',
        internet: 'CN'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Christmas Island',
        capital: 'The Settlement',
        fips: 'KT',
        iso2: 'CX',
        iso3: 'CXR',
        isoNo: '162',
        internet: 'CX'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Cocos (Keeling) Islands',
        capital: 'West Island',
        fips: 'CK',
        iso2: 'CC',
        iso3: 'CCK',
        isoNo: '166',
        internet: 'CC'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Colombia',
        capital: 'Bogota',
        fips: 'CO',
        iso2: 'CO',
        iso3: 'COL',
        isoNo: '170',
        internet: 'CO'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Comoros',
        capital: 'Moroni',
        fips: 'CN',
        iso2: 'KM',
        iso3: 'COM',
        isoNo: '174',
        internet: 'KM'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Republic of the Congo',
        capital: 'Brazzaville',
        fips: 'CF',
        iso2: 'CG',
        iso3: 'COG',
        isoNo: '178',
        internet: 'CG'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Cook Islands',
        capital: 'Avarua',
        fips: 'CW',
        iso2: 'CK',
        iso3: 'COK',
        isoNo: '184',
        internet: 'CK'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Costa Rica',
        capital: 'San Jose',
        fips: 'CS',
        iso2: 'CR',
        iso3: 'CRI',
        isoNo: '188',
        internet: 'CR'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: "Cote d'Ivoire",
        capital: 'Yamoussoukro',
        fips: 'IV',
        iso2: 'CI',
        iso3: 'CIV',
        isoNo: '384',
        internet: 'CI'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Croatia',
        capital: 'Zagreb',
        fips: 'HR',
        iso2: 'HR',
        iso3: 'HRV',
        isoNo: '191',
        internet: 'HR'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Cuba',
        capital: 'Havana',
        fips: 'CU',
        iso2: 'CU',
        iso3: 'CUB',
        isoNo: '192',
        internet: 'CU'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Cyprus',
        capital: 'Nicosia',
        fips: 'CY',
        iso2: 'CY',
        iso3: 'CYP',
        isoNo: '196',
        internet: 'CY'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Czechia',
        capital: 'Prague',
        fips: 'EZ',
        iso2: 'CZ',
        iso3: 'CZE',
        isoNo: '203',
        internet: 'CZ'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Denmark',
        capital: 'Copenhagen',
        fips: 'DA',
        iso2: 'DK',
        iso3: 'DNK',
        isoNo: '208',
        internet: 'DK'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Djibouti',
        capital: 'Djibouti',
        fips: 'DJ',
        iso2: 'DJ',
        iso3: 'DJI',
        isoNo: '262',
        internet: 'DJ'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Dominica',
        capital: 'Roseau',
        fips: 'DO',
        iso2: 'DM',
        iso3: 'DMA',
        isoNo: '212',
        internet: 'DM'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Dominican Republic',
        capital: 'Santo Domingo',
        fips: 'DR',
        iso2: 'DO',
        iso3: 'DOM',
        isoNo: '214',
        internet: 'DO'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Ecuador',
        capital: 'Quito',
        fips: 'EC',
        iso2: 'EC',
        iso3: 'ECU',
        isoNo: '218',
        internet: 'EC'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Egypt',
        capital: 'Cairo',
        fips: 'EG',
        iso2: 'EG',
        iso3: 'EGY',
        isoNo: '818',
        internet: 'EG'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'El Salvador',
        capital: 'San Salvador',
        fips: 'ES',
        iso2: 'SV',
        iso3: 'SLV',
        isoNo: '222',
        internet: 'SV'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Equatorial Guinea',
        capital: 'Malabo',
        fips: 'EK',
        iso2: 'GQ',
        iso3: 'GNQ',
        isoNo: '226',
        internet: 'GQ'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Eritrea',
        capital: 'Asmara',
        fips: 'ER',
        iso2: 'ER',
        iso3: 'ERI',
        isoNo: '232',
        internet: 'ER'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Estonia',
        capital: 'Tallinn',
        fips: 'EN',
        iso2: 'EE',
        iso3: 'EST',
        isoNo: '233',
        internet: 'EE'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Ethiopia',
        capital: 'Addis Ababa',
        fips: 'ET',
        iso2: 'ET',
        iso3: 'ETH',
        isoNo: '231',
        internet: 'ET'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Falkland Islands (Islas Malvinas)',
        capital: 'Stanley',
        fips: 'FA',
        iso2: 'FK',
        iso3: 'FLK',
        isoNo: '238',
        internet: 'FK'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Faroe Islands',
        capital: 'Torshavn',
        fips: 'FO',
        iso2: 'FO',
        iso3: 'FRO',
        isoNo: '234',
        internet: 'FO'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Fiji',
        capital: 'Suva',
        fips: 'FJ',
        iso2: 'FJ',
        iso3: 'FJI',
        isoNo: '242',
        internet: 'FJ'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Finland',
        capital: 'Helsinki',
        fips: 'FI',
        iso2: 'FI',
        iso3: 'FIN',
        isoNo: '246',
        internet: 'FI'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'France',
        capital: 'Paris',
        fips: 'FR',
        iso2: 'FR',
        iso3: 'FRA',
        isoNo: '250',
        internet: 'FR'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'French Guiana',
        capital: 'Cayenne',
        fips: 'FG',
        iso2: 'GF',
        iso3: 'GUF',
        isoNo: '254',
        internet: 'GF'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'French Polynesia',
        capital: 'Papeete',
        fips: 'FP',
        iso2: 'PF',
        iso3: 'PYF',
        isoNo: '258',
        internet: 'PF'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Gabon',
        capital: 'Libreville',
        fips: 'GB',
        iso2: 'GA',
        iso3: 'GAB',
        isoNo: '266',
        internet: 'GA'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'The Gambia',
        capital: 'Banjul',
        fips: 'GA',
        iso2: 'GM',
        iso3: 'GMB',
        isoNo: '270',
        internet: 'GM'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Georgia',
        capital: "T'bilisi",
        fips: 'GG',
        iso2: 'GE',
        iso3: 'GEO',
        isoNo: '268',
        internet: 'GE'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Germany',
        capital: 'Berlin',
        fips: 'GM',
        iso2: 'DE',
        iso3: 'DEU',
        isoNo: '276',
        internet: 'DE'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Ghana',
        capital: 'Accra',
        fips: 'GH',
        iso2: 'GH',
        iso3: 'GHA',
        isoNo: '288',
        internet: 'GH'
    },
    {
        continent: 'Europe',
        region: 'South West Europe',
        country: 'Gibraltar',
        capital: 'Gibraltar',
        fips: 'GI',
        iso2: 'GI',
        iso3: 'GIB',
        isoNo: '292',
        internet: 'GI'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Greece',
        capital: 'Athens',
        fips: 'GR',
        iso2: 'GR',
        iso3: 'GRC',
        isoNo: '300',
        internet: 'GR'
    },
    {
        continent: 'Americas',
        region: 'North America',
        country: 'Greenland',
        capital: 'Nuuk (Godthab)',
        fips: 'GL',
        iso2: 'GL',
        iso3: 'GRL',
        isoNo: '304',
        internet: 'GL'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Grenada',
        capital: "Saint George's",
        fips: 'GJ',
        iso2: 'GD',
        iso3: 'GRD',
        isoNo: '308',
        internet: 'GD'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Guadeloupe',
        capital: 'Basse-Terre',
        fips: 'GP',
        iso2: 'GP',
        iso3: 'GLP',
        isoNo: '312',
        internet: 'GP'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Guam',
        capital: 'Hagatna (Agana)',
        fips: 'GQ',
        iso2: 'GU',
        iso3: 'GUM',
        isoNo: '316',
        internet: 'GU'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Guatemala',
        capital: 'Guatemala',
        fips: 'GT',
        iso2: 'GT',
        iso3: 'GTM',
        isoNo: '320',
        internet: 'GT'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Guinea',
        capital: 'Conakry',
        fips: 'GV',
        iso2: 'GN',
        iso3: 'GIN',
        isoNo: '324',
        internet: 'GN'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Guinea-Bissau',
        capital: 'Bissau',
        fips: 'PU',
        iso2: 'GW',
        iso3: 'GNB',
        isoNo: '624',
        internet: 'GW'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Guyana',
        capital: 'Georgetown',
        fips: 'GY',
        iso2: 'GY',
        iso3: 'GUY',
        isoNo: '328',
        internet: 'GY'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Haiti',
        capital: 'Port-au-Prince',
        fips: 'HA',
        iso2: 'HT',
        iso3: 'HTI',
        isoNo: '332',
        internet: 'HT'
    },
    {
        continent: 'Europe',
        region: 'Southern Europe',
        country: 'Holy See (Vatican City)',
        capital: 'Vatican City',
        fips: 'VT',
        iso2: 'VA',
        iso3: 'VAT',
        isoNo: '336',
        internet: 'VA'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Honduras',
        capital: 'Tegucigalpa',
        fips: 'HO',
        iso2: 'HN',
        iso3: 'HND',
        isoNo: '340',
        internet: 'HN'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Hungary',
        capital: 'Budapest',
        fips: 'HU',
        iso2: 'HU',
        iso3: 'HUN',
        isoNo: '348',
        internet: 'HU'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Iceland',
        capital: 'Reykjavik',
        fips: 'IC',
        iso2: 'IS',
        iso3: 'ISL',
        isoNo: '352',
        internet: 'IS'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'India',
        capital: 'New Delhi',
        fips: 'IN',
        iso2: 'IN',
        iso3: 'IND',
        isoNo: '356',
        internet: 'IN'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Indonesia',
        capital: 'Jakarta',
        fips: 'ID',
        iso2: 'ID',
        iso3: 'IDN',
        isoNo: '360',
        internet: 'ID'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Iran',
        capital: 'Tehran',
        fips: 'IR',
        iso2: 'IR',
        iso3: 'IRN',
        isoNo: '364',
        internet: 'IR'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Iraq',
        capital: 'Baghdad',
        fips: 'IZ',
        iso2: 'IQ',
        iso3: 'IRQ',
        isoNo: '368',
        internet: 'IQ'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Ireland',
        capital: 'Dublin',
        fips: 'EI',
        iso2: 'IE',
        iso3: 'IRL',
        isoNo: '372',
        internet: 'IE'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Israel',
        capital: 'Jerusalem',
        fips: 'IS',
        iso2: 'IL',
        iso3: 'ISR',
        isoNo: '376',
        internet: 'IL'
    },
    {
        continent: 'Europe',
        region: 'Southern Europe',
        country: 'Italy',
        capital: 'Rome',
        fips: 'IT',
        iso2: 'IT',
        iso3: 'ITA',
        isoNo: '380',
        internet: 'IT'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Jamaica',
        capital: 'Kingston',
        fips: 'JM',
        iso2: 'JM',
        iso3: 'JAM',
        isoNo: '388',
        internet: 'JM'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'Japan',
        capital: 'Tokyo',
        fips: 'JA',
        iso2: 'JP',
        iso3: 'JPN',
        isoNo: '392',
        internet: 'JP'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Jordan',
        capital: 'Amman',
        fips: 'JO',
        iso2: 'JO',
        iso3: 'JOR',
        isoNo: '400',
        internet: 'JO'
    },
    {
        continent: 'Asia',
        region: 'Central Asia',
        country: 'Kazakhstan',
        capital: 'Astana (Akmola)',
        fips: 'KZ',
        iso2: 'KZ',
        iso3: 'KAZ',
        isoNo: '398',
        internet: 'KZ'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Kenya',
        capital: 'Nairobi',
        fips: 'KE',
        iso2: 'KE',
        iso3: 'KEN',
        isoNo: '404',
        internet: 'KE'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Kiribati',
        capital: 'Tarawa',
        fips: 'KR',
        iso2: 'KI',
        iso3: 'KIR',
        isoNo: '296',
        internet: 'KI'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'North Korea',
        capital: "P'yongyang",
        fips: 'KN',
        iso2: 'KP',
        iso3: 'PRK',
        isoNo: '408',
        internet: 'KP'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'South Korea',
        capital: 'Seoul',
        fips: 'KS',
        iso2: 'KR',
        iso3: 'KOR',
        isoNo: '410',
        internet: 'KR'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Kuwait',
        capital: 'Kuwait',
        fips: 'KU',
        iso2: 'KW',
        iso3: 'KWT',
        isoNo: '414',
        internet: 'KW'
    },
    {
        continent: 'Asia',
        region: 'Central Asia',
        country: 'Kyrgyzstan',
        capital: 'Bishkek',
        fips: 'KG',
        iso2: 'KG',
        iso3: 'KGZ',
        isoNo: '417',
        internet: 'KG'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Laos',
        capital: 'Vientiane',
        fips: 'LA',
        iso2: 'LA',
        iso3: 'LAO',
        isoNo: '418',
        internet: 'LA'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Latvia',
        capital: 'Riga',
        fips: 'LG',
        iso2: 'LV',
        iso3: 'LVA',
        isoNo: '428',
        internet: 'LV'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Lebanon',
        capital: 'Beirut',
        fips: 'LE',
        iso2: 'LB',
        iso3: 'LBN',
        isoNo: '422',
        internet: 'LB'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Lesotho',
        capital: 'Maseru',
        fips: 'LT',
        iso2: 'LS',
        iso3: 'LSO',
        isoNo: '426',
        internet: 'LS'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Liberia',
        capital: 'Monrovia',
        fips: 'LI',
        iso2: 'LR',
        iso3: 'LBR',
        isoNo: '430',
        internet: 'LR'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Libya',
        capital: 'Tripoli',
        fips: 'LY',
        iso2: 'LY',
        iso3: 'LBY',
        isoNo: '434',
        internet: 'LY'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Liechtenstein',
        capital: 'Vaduz',
        fips: 'LS',
        iso2: 'LI',
        iso3: 'LIE',
        isoNo: '438',
        internet: 'LI'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Lithuania',
        capital: 'Vilnius',
        fips: 'LH',
        iso2: 'LT',
        iso3: 'LTU',
        isoNo: '440',
        internet: 'LT'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Luxembourg',
        capital: 'Luxembourg',
        fips: 'LU',
        iso2: 'LU',
        iso3: 'LUX',
        isoNo: '442',
        internet: 'LU'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'North Macedonia',
        capital: 'Skopje',
        fips: 'MK',
        iso2: 'MK',
        iso3: 'MKD',
        isoNo: '807',
        internet: 'MK'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Madagascar',
        capital: 'Antananarivo',
        fips: 'MA',
        iso2: 'MG',
        iso3: 'MDG',
        isoNo: '450',
        internet: 'MG'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Malawi',
        capital: 'Lilongwe',
        fips: 'MI',
        iso2: 'MW',
        iso3: 'MWI',
        isoNo: '454',
        internet: 'MW'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Malaysia',
        capital: 'Kuala Lumpur',
        fips: 'MY',
        iso2: 'MY',
        iso3: 'MYS',
        isoNo: '458',
        internet: 'MY'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Maldives',
        capital: 'Male (Maale)',
        fips: 'MV',
        iso2: 'MV',
        iso3: 'MDV',
        isoNo: '462',
        internet: 'MV'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Mali',
        capital: 'Bamako',
        fips: 'ML',
        iso2: 'ML',
        iso3: 'MLI',
        isoNo: '466',
        internet: 'ML'
    },
    {
        continent: 'Europe',
        region: 'Southern Europe',
        country: 'Malta',
        capital: 'Valletta',
        fips: 'MT',
        iso2: 'MT',
        iso3: 'MLT',
        isoNo: '470',
        internet: 'MT'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Isle of Man',
        capital: 'Douglas',
        fips: 'IM',
        iso2: 'IM',
        iso3: 'IMN',
        isoNo: '833',
        internet: 'IM'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Marshall Islands',
        capital: 'Majuro',
        fips: 'RM',
        iso2: 'MH',
        iso3: 'MHL',
        isoNo: '584',
        internet: 'MH'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Martinique',
        capital: 'Fort-de-France',
        fips: 'MB',
        iso2: 'MQ',
        iso3: 'MTQ',
        isoNo: '474',
        internet: 'MQ'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Mauritania',
        capital: 'Nouakchott',
        fips: 'MR',
        iso2: 'MR',
        iso3: 'MRT',
        isoNo: '478',
        internet: 'MR'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Mauritius',
        capital: 'Port Louis',
        fips: 'MP',
        iso2: 'MU',
        iso3: 'MUS',
        isoNo: '480',
        internet: 'MU'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Mayotte',
        capital: 'Mamoutzou',
        fips: 'MF',
        iso2: 'YT',
        iso3: 'MYT',
        isoNo: '175',
        internet: 'YT'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Mexico',
        capital: 'Mexico',
        fips: 'MX',
        iso2: 'MX',
        iso3: 'MEX',
        isoNo: '484',
        internet: 'MX'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Federated States of Micronesia',
        capital: 'Palikir',
        fips: '',
        iso2: 'FM',
        iso3: 'FSM',
        isoNo: '583',
        internet: 'FM'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Moldova',
        capital: 'Chisinau',
        fips: 'MD',
        iso2: 'MD',
        iso3: 'MDA',
        isoNo: '498',
        internet: 'MD'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Monaco',
        capital: 'Monaco',
        fips: 'MN',
        iso2: 'MC',
        iso3: 'MCO',
        isoNo: '492',
        internet: 'MC'
    },
    {
        continent: 'Asia',
        region: 'Northern Asia',
        country: 'Mongolia',
        capital: 'Ulaanbaatar',
        fips: 'MG',
        iso2: 'MN',
        iso3: 'MNG',
        isoNo: '496',
        internet: 'MN'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Montserrat',
        capital: 'Plymouth',
        fips: 'MH',
        iso2: 'MS',
        iso3: 'MSR',
        isoNo: '500',
        internet: 'MS'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Morocco',
        capital: 'Rabat',
        fips: 'MO',
        iso2: 'MA',
        iso3: 'MAR',
        isoNo: '504',
        internet: 'MA'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Mozambique',
        capital: 'Maputo',
        fips: 'MZ',
        iso2: 'MZ',
        iso3: 'MOZ',
        isoNo: '508',
        internet: 'MZ'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Myanmar (Burma)',
        capital: 'Rangoon (Yangon)',
        fips: 'BM',
        iso2: 'MM',
        iso3: 'MMR',
        isoNo: '104',
        internet: 'MM'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Namibia',
        capital: 'Windhoek',
        fips: 'WA',
        iso2: 'NA',
        iso3: 'NAM',
        isoNo: '516',
        internet: 'NA'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Nauru',
        capital: 'no official capital',
        fips: 'NR',
        iso2: 'NR',
        iso3: 'NRU',
        isoNo: '520',
        internet: 'NR'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Nepal',
        capital: 'Kathmandu',
        fips: 'NP',
        iso2: 'NP',
        iso3: 'NPL',
        isoNo: '524',
        internet: 'NP'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Netherlands',
        capital: 'Amsterdam',
        fips: 'NL',
        iso2: 'NL',
        iso3: 'NLD',
        isoNo: '528',
        internet: 'NL'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Netherlands Antilles',
        capital: 'Willemstad',
        fips: 'NT',
        iso2: 'AN',
        iso3: 'ANT',
        isoNo: '530',
        internet: 'AN'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'New Caledonia',
        capital: 'Noumea',
        fips: 'NC',
        iso2: 'NC',
        iso3: 'NCL',
        isoNo: '540',
        internet: 'NC'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'New Zealand',
        capital: 'Wellington',
        fips: 'NZ',
        iso2: 'NZ',
        iso3: 'NZL',
        isoNo: '554',
        internet: 'NZ'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Nicaragua',
        capital: 'Managua',
        fips: 'NU',
        iso2: 'NI',
        iso3: 'NIC',
        isoNo: '558',
        internet: 'NI'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Niger',
        capital: 'Niamey',
        fips: 'NG',
        iso2: 'NE',
        iso3: 'NER',
        isoNo: '562',
        internet: 'NE'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Nigeria',
        capital: 'Abuja',
        fips: 'NI',
        iso2: 'NG',
        iso3: 'NGA',
        isoNo: '566',
        internet: 'NG'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Niue',
        capital: 'Alofi',
        fips: 'NE',
        iso2: 'NU',
        iso3: 'NIU',
        isoNo: '570',
        internet: 'NU'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Norfolk Island',
        capital: 'Kingston',
        fips: 'NF',
        iso2: 'NF',
        iso3: 'NFK',
        isoNo: '574',
        internet: 'NF'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Northern Mariana Islands',
        capital: 'Saipan',
        fips: 'CQ',
        iso2: 'MP',
        iso3: 'MNP',
        isoNo: '580',
        internet: 'MP'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Norway',
        capital: 'Oslo',
        fips: 'NO',
        iso2: 'NO',
        iso3: 'NOR',
        isoNo: '578',
        internet: 'NO'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Oman',
        capital: 'Muscat',
        fips: 'MU',
        iso2: 'OM',
        iso3: 'OMN',
        isoNo: '512',
        internet: 'OM'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Pakistan',
        capital: 'Islamabad',
        fips: 'PK',
        iso2: 'PK',
        iso3: 'PAK',
        isoNo: '586',
        internet: 'PK'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Palau',
        capital: 'Koror',
        fips: 'PS',
        iso2: 'PW',
        iso3: 'PLW',
        isoNo: '585',
        internet: 'PW'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Palestinian Territory',
        capital: 'East Jerusalem',
        fips: 'WE',
        iso2: 'PS',
        iso3: 'PSE',
        isoNo: '275',
        internet: 'PS'
    },
    {
        continent: 'Americas',
        region: 'Central America',
        country: 'Panama',
        capital: 'Panama',
        fips: 'PM',
        iso2: 'PA',
        iso3: 'PAN',
        isoNo: '591',
        internet: 'PA'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Papua New Guinea',
        capital: 'Port Moresby',
        fips: 'PP',
        iso2: 'PG',
        iso3: 'PNG',
        isoNo: '598',
        internet: 'PG'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Paraguay',
        capital: 'Asuncion',
        fips: 'PA',
        iso2: 'PY',
        iso3: 'PRY',
        isoNo: '600',
        internet: 'PY'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Peru',
        capital: 'Lima',
        fips: 'PE',
        iso2: 'PE',
        iso3: 'PER',
        isoNo: '604',
        internet: 'PE'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Philippines',
        capital: 'Manila',
        fips: 'RP',
        iso2: 'PH',
        iso3: 'PHL',
        isoNo: '608',
        internet: 'PH'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Pitcairn Islands',
        capital: 'Adamstown',
        fips: 'PC',
        iso2: 'PN',
        iso3: 'PCN',
        isoNo: '612',
        internet: 'PN'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Poland',
        capital: 'Warsaw',
        fips: 'PL',
        iso2: 'PL',
        iso3: 'POL',
        isoNo: '616',
        internet: 'PL'
    },
    {
        continent: 'Europe',
        region: 'South West Europe',
        country: 'Portugal',
        capital: 'Lisbon',
        fips: 'PO',
        iso2: 'PT',
        iso3: 'PRT',
        isoNo: '620',
        internet: 'PT'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Puerto Rico',
        capital: 'San Juan',
        fips: 'RQ',
        iso2: 'PR',
        iso3: 'PRI',
        isoNo: '630',
        internet: 'PR'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Qatar',
        capital: 'Doha',
        fips: 'QA',
        iso2: 'QA',
        iso3: 'QAT',
        isoNo: '634',
        internet: 'QA'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Reunion',
        capital: 'Saint-Denis',
        fips: 'RE',
        iso2: 'RE',
        iso3: 'REU',
        isoNo: '638',
        internet: 'RE'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Romania',
        capital: 'Bucharest',
        fips: 'RO',
        iso2: 'RO',
        iso3: 'ROU',
        isoNo: '642',
        internet: 'RO'
    },
    {
        continent: 'Asia',
        region: 'Northern Asia',
        country: 'Russia',
        capital: 'Moscow',
        fips: 'RS',
        iso2: 'RU',
        iso3: 'RUS',
        isoNo: '643',
        internet: 'RU'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Rwanda',
        capital: 'Kigali',
        fips: 'RW',
        iso2: 'RW',
        iso3: 'RWA',
        isoNo: '646',
        internet: 'RW'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Saint Kitts and Nevis',
        capital: 'Basseterre',
        fips: 'SC',
        iso2: 'KN',
        iso3: 'KNA',
        isoNo: '659',
        internet: 'KN'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Saint Lucia',
        capital: 'Castries',
        fips: 'ST',
        iso2: 'LC',
        iso3: 'LCA',
        isoNo: '662',
        internet: 'LC'
    },
    {
        continent: 'Americas',
        region: 'North America',
        country: 'Saint Pierre and Miquelon',
        capital: 'Saint-Pierre',
        fips: 'SB',
        iso2: 'PM',
        iso3: 'SPM',
        isoNo: '666',
        internet: 'PM'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Saint Vincent and the Grenadines',
        capital: 'Kingstown',
        fips: 'VC',
        iso2: 'VC',
        iso3: 'VCT',
        isoNo: '670',
        internet: 'VC'
    },
    {
        continent: 'Europe',
        region: 'Southern Europe',
        country: 'San Marino',
        capital: 'San Marino',
        fips: 'SM',
        iso2: 'SM',
        iso3: 'SMR',
        isoNo: '674',
        internet: 'SM'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Sao Tome and Principe',
        capital: 'Sao Tome',
        fips: 'TP',
        iso2: 'ST',
        iso3: 'STP',
        isoNo: '678',
        internet: 'ST'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Saudi Arabia',
        capital: 'Riyadh',
        fips: 'SA',
        iso2: 'SA',
        iso3: 'SAU',
        isoNo: '682',
        internet: 'SA'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Senegal',
        capital: 'Dakar',
        fips: 'SG',
        iso2: 'SN',
        iso3: 'SEN',
        isoNo: '686',
        internet: 'SN'
    },
    {
        continent: 'Africa',
        region: 'Indian Ocean',
        country: 'Seychelles',
        capital: 'Victoria',
        fips: 'SE',
        iso2: 'SC',
        iso3: 'SYC',
        isoNo: '690',
        internet: 'SC'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Sierra Leone',
        capital: 'Freetown',
        fips: 'SL',
        iso2: 'SL',
        iso3: 'SLE',
        isoNo: '694',
        internet: 'SL'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Singapore',
        capital: 'Singapore',
        fips: 'SN',
        iso2: 'SG',
        iso3: 'SGP',
        isoNo: '702',
        internet: 'SG'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Slovakia',
        capital: 'Bratislava',
        fips: 'LO',
        iso2: 'SK',
        iso3: 'SVK',
        isoNo: '703',
        internet: 'SK'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Slovenia',
        capital: 'Ljubljana',
        fips: 'SI',
        iso2: 'SI',
        iso3: 'SVN',
        isoNo: '705',
        internet: 'SI'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Solomon Islands',
        capital: 'Honiara',
        fips: 'BP',
        iso2: 'SB',
        iso3: 'SLB',
        isoNo: '090',
        internet: 'SB'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Somalia',
        capital: 'Mogadishu',
        fips: 'SO',
        iso2: 'SO',
        iso3: 'SOM',
        isoNo: '706',
        internet: 'SO'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'South Africa',
        capital: "Pretoria\uFFFD\uFFFD",
        fips: 'SF',
        iso2: 'ZA',
        iso3: 'ZAF',
        isoNo: '710',
        internet: 'ZA'
    },
    {
        continent: 'Europe',
        region: 'South West Europe',
        country: 'Spain',
        capital: 'Madrid',
        fips: 'SP',
        iso2: 'ES',
        iso3: 'ESP',
        isoNo: '724',
        internet: 'ES'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'Sri Lanka',
        capital: 'Colombo',
        fips: 'CE',
        iso2: 'LK',
        iso3: 'LKA',
        isoNo: '144',
        internet: 'LK'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Sudan',
        capital: 'Khartoum',
        fips: 'SU',
        iso2: 'SD',
        iso3: 'SDN',
        isoNo: '729',
        internet: 'SD'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Suriname',
        capital: 'Paramaribo',
        fips: 'NS',
        iso2: 'SR',
        iso3: 'SUR',
        isoNo: '740',
        internet: 'SR'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Svalbard',
        capital: 'Longyearbyen',
        fips: 'SV',
        iso2: 'SJ',
        iso3: 'SJM',
        isoNo: '744',
        internet: 'SJ'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Eswatini',
        capital: 'Mbabane',
        fips: 'WZ',
        iso2: 'SZ',
        iso3: 'SWZ',
        isoNo: '748',
        internet: 'SZ'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: 'Sweden',
        capital: 'Stockholm',
        fips: 'SW',
        iso2: 'SE',
        iso3: 'SWE',
        isoNo: '752',
        internet: 'SE'
    },
    {
        continent: 'Europe',
        region: 'Central Europe',
        country: 'Switzerland',
        capital: 'Bern',
        fips: 'SZ',
        iso2: 'CH',
        iso3: 'CHE',
        isoNo: '756',
        internet: 'CH'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Syria',
        capital: 'Damascus',
        fips: 'SY',
        iso2: 'SY',
        iso3: 'SYR',
        isoNo: '760',
        internet: 'SY'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'Taiwan',
        capital: 'Taipei',
        fips: 'TW',
        iso2: 'TW',
        iso3: 'TWN',
        isoNo: '158',
        internet: 'TW'
    },
    {
        continent: 'Asia',
        region: 'Central Asia',
        country: 'Tajikistan',
        capital: 'Dushanbe',
        fips: 'TI',
        iso2: 'TJ',
        iso3: 'TJK',
        isoNo: '762',
        internet: 'TJ'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Tanzania',
        capital: 'Dar es Salaam',
        fips: 'TZ',
        iso2: 'TZ',
        iso3: 'TZA',
        isoNo: '834',
        internet: 'TZ'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Thailand',
        capital: 'Bangkok',
        fips: 'TH',
        iso2: 'TH',
        iso3: 'THA',
        isoNo: '764',
        internet: 'TH'
    },
    {
        continent: 'Africa',
        region: 'Western Africa',
        country: 'Togo',
        capital: 'Lome',
        fips: 'TO',
        iso2: 'TG',
        iso3: 'TGO',
        isoNo: '768',
        internet: 'TG'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Tokelau',
        capital: 'none',
        fips: 'TL',
        iso2: 'TK',
        iso3: 'TKL',
        isoNo: '772',
        internet: 'TK'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Tonga',
        capital: "Nuku'alofa",
        fips: 'TN',
        iso2: 'TO',
        iso3: 'TON',
        isoNo: '776',
        internet: 'TO'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Trinidad and Tobago',
        capital: 'Port-of-Spain',
        fips: 'TD',
        iso2: 'TT',
        iso3: 'TTO',
        isoNo: '780',
        internet: 'TT'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Tunisia',
        capital: 'Tunis',
        fips: 'TS',
        iso2: 'TN',
        iso3: 'TUN',
        isoNo: '788',
        internet: 'TN'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Turkey',
        capital: 'Ankara',
        fips: 'TU',
        iso2: 'TR',
        iso3: 'TUR',
        isoNo: '792',
        internet: 'TR'
    },
    {
        continent: 'Asia',
        region: 'Central Asia',
        country: 'Turkmenistan',
        capital: 'Ashgabat',
        fips: 'TX',
        iso2: 'TM',
        iso3: 'TKM',
        isoNo: '795',
        internet: 'TM'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Turks and Caicos Islands',
        capital: 'Grand Turk',
        fips: 'TK',
        iso2: 'TC',
        iso3: 'TCA',
        isoNo: '796',
        internet: 'TC'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Tuvalu',
        capital: 'Funafuti',
        fips: 'TV',
        iso2: 'TV',
        iso3: 'TUV',
        isoNo: '798',
        internet: 'TV'
    },
    {
        continent: 'Africa',
        region: 'Eastern Africa',
        country: 'Uganda',
        capital: 'Kampala',
        fips: 'UG',
        iso2: 'UG',
        iso3: 'UGA',
        isoNo: '800',
        internet: 'UG'
    },
    {
        continent: 'Europe',
        region: 'Eastern Europe',
        country: 'Ukraine',
        capital: 'Kyiv',
        fips: 'UP',
        iso2: 'UA',
        iso3: 'UKR',
        isoNo: '804',
        internet: 'UA'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'United Arab Emirates',
        capital: 'Abu Dhabi',
        fips: 'TC',
        iso2: 'AE',
        iso3: 'ARE',
        isoNo: '784',
        internet: 'AE'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'United Kingdom',
        capital: 'London',
        fips: 'UK',
        iso2: 'GB',
        iso3: 'GBR',
        isoNo: '826',
        internet: 'UK'
    },
    {
        continent: 'Americas',
        region: 'North America',
        country: 'United States',
        capital: 'Washington DC',
        fips: 'US',
        iso2: 'US',
        iso3: 'USA',
        isoNo: '840',
        internet: 'US'
    },
    {
        continent: 'Americas',
        region: 'North America',
        country: 'United States Minor Outlying Islands',
        capital: 'Washington DC',
        fips: '',
        iso2: 'UM',
        iso3: 'UMI',
        isoNo: '581',
        internet: 'US'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Uruguay',
        capital: 'Montevideo',
        fips: 'UY',
        iso2: 'UY',
        iso3: 'URY',
        isoNo: '858',
        internet: 'UY'
    },
    {
        continent: 'Asia',
        region: 'Central Asia',
        country: 'Uzbekistan',
        capital: 'Tashkent (Toshkent)',
        fips: 'UZ',
        iso2: 'UZ',
        iso3: 'UZB',
        isoNo: '860',
        internet: 'UZ'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Vanuatu',
        capital: 'Port-Vila',
        fips: 'NH',
        iso2: 'VU',
        iso3: 'VUT',
        isoNo: '548',
        internet: 'VU'
    },
    {
        continent: 'Americas',
        region: 'South America',
        country: 'Venezuela',
        capital: 'Caracas',
        fips: 'VE',
        iso2: 'VE',
        iso3: 'VEN',
        isoNo: '862',
        internet: 'UE'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Vietnam',
        capital: 'Hanoi',
        fips: 'VN',
        iso2: 'VN',
        iso3: 'VNM',
        isoNo: '704',
        internet: 'VN'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Virgin Islands',
        capital: 'Charlotte Amalie',
        fips: 'VQ',
        iso2: 'VI',
        iso3: 'VIR',
        isoNo: '850',
        internet: 'VI'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Wallis and Futuna',
        capital: 'Mata-Utu (on Ile Uvea)',
        fips: 'WF',
        iso2: 'WF',
        iso3: 'WLF',
        isoNo: '876',
        internet: 'WF'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'Western Sahara',
        capital: 'none',
        fips: 'WI',
        iso2: 'EH',
        iso3: 'ESH',
        isoNo: '732',
        internet: 'EH'
    },
    {
        continent: 'Oceania',
        region: 'Pacific',
        country: 'Western Samoa',
        capital: 'Apia',
        fips: 'WS',
        iso2: 'WS',
        iso3: 'WSM',
        isoNo: '882',
        internet: 'WS'
    },
    {
        continent: 'Asia',
        region: 'South West Asia',
        country: 'Yemen',
        capital: 'Sanaa',
        fips: 'YM',
        iso2: 'YE',
        iso3: 'YEM',
        isoNo: '887',
        internet: 'YE'
    },
    {
        continent: 'Africa',
        region: 'Central Africa',
        country: 'Democratic Republic of the Congo',
        capital: 'Kinshasa',
        fips: 'CG',
        iso2: 'CD',
        iso3: 'COD',
        isoNo: '180',
        internet: 'ZR'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Zambia',
        capital: 'Lusaka',
        fips: 'ZA',
        iso2: 'ZM',
        iso3: 'ZMB',
        isoNo: '894',
        internet: 'ZM'
    },
    {
        continent: 'Africa',
        region: 'Southern Africa',
        country: 'Zimbabwe',
        capital: 'Harare',
        fips: 'ZI',
        iso2: 'ZW',
        iso3: 'ZWE',
        isoNo: '716',
        internet: 'ZW'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'Hong Kong',
        capital: 'Victoria',
        fips: 'HK',
        iso2: 'HK',
        iso3: 'HKG',
        isoNo: '344',
        internet: 'HK'
    },
    {
        continent: 'Asia',
        region: 'East Asia',
        country: 'Macau',
        capital: 'Macau',
        fips: 'MC',
        iso2: 'MO',
        iso3: 'MAC',
        isoNo: '446',
        internet: 'MO'
    },
    {
        continent: 'Antarctica',
        region: 'Antarctica',
        country: 'Antarctica',
        capital: '',
        fips: 'AY',
        iso2: 'AQ',
        iso3: 'ATA',
        isoNo: '010',
        internet: 'AQ'
    },
    {
        continent: 'Atlantic Ocean',
        region: 'South Atlantic Ocean',
        country: 'Bouvet Island',
        capital: '',
        fips: 'BV',
        iso2: 'BV',
        iso3: 'BVT',
        isoNo: '074',
        internet: 'BV'
    },
    {
        continent: 'Asia',
        region: 'South Asia',
        country: 'British Indian Ocean Territory',
        capital: '',
        fips: 'IO',
        iso2: 'IO',
        iso3: 'IOT',
        isoNo: '086',
        internet: 'IO'
    },
    {
        continent: 'Indian Ocean',
        region: 'Southern Indian Ocean',
        country: 'French Southern and Antarctic Lands',
        capital: '',
        fips: 'FS',
        iso2: 'TF',
        iso3: 'ATF',
        isoNo: '260',
        internet: '--'
    },
    {
        continent: 'Indian Ocean',
        region: 'Southern Indian Ocean',
        country: 'Heard Island and McDonald Islands',
        capital: '',
        fips: 'HM',
        iso2: 'HM',
        iso3: 'HMD',
        isoNo: '334',
        internet: 'HM'
    },
    {
        continent: 'Atlantic Ocean',
        region: 'South Atlantic Ocean',
        country: 'Saint Helena',
        capital: '',
        fips: 'SH',
        iso2: 'SH',
        iso3: 'SHN',
        isoNo: '654',
        internet: 'SH'
    },
    {
        continent: 'Atlantic Ocean',
        region: 'South Atlantic Ocean',
        country: 'South Georgia and the South Sandwich Islands',
        capital: '',
        fips: 'SX',
        iso2: 'GS',
        iso3: 'SGS',
        isoNo: '239',
        internet: 'GS'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Guernsey',
        capital: 'Saint Peter Port',
        fips: 'GK',
        iso2: 'GG',
        iso3: 'GGY',
        isoNo: '831',
        internet: 'GG'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Serbia',
        capital: 'Belgrade',
        fips: 'RI',
        iso2: 'RS',
        iso3: 'SRB',
        isoNo: '688',
        internet: 'RS'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: "Saint Barth\xe9lemy",
        capital: 'Gustavia',
        fips: 'TB',
        iso2: 'BL',
        iso3: 'BLM',
        isoNo: '652',
        internet: 'BL'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Montenegro',
        capital: 'Podgorica',
        fips: 'MJ',
        iso2: 'ME',
        iso3: 'MNE',
        isoNo: '499',
        internet: 'ME'
    },
    {
        continent: 'Europe',
        region: 'Western Europe',
        country: 'Jersey',
        capital: 'Saint Helier',
        fips: 'JE',
        iso2: 'JE',
        iso3: 'JEY',
        isoNo: '832',
        internet: 'JE'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: "Cura\xe7ao",
        capital: 'Willemstad',
        fips: 'UC',
        iso2: 'CW',
        iso3: 'CUW',
        isoNo: '531',
        internet: 'CW'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Saint Martin',
        capital: 'Marigot',
        fips: 'RN',
        iso2: 'MF',
        iso3: 'MAF',
        isoNo: '663',
        internet: 'MF'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Sint Maarten',
        capital: 'Philipsburg',
        fips: 'NN',
        iso2: 'SX',
        iso3: 'SXM',
        isoNo: '534',
        internet: 'SX'
    },
    {
        continent: 'Asia',
        region: 'South East Asia',
        country: 'Timor-Leste',
        capital: 'Dili',
        fips: 'TT',
        iso2: 'TL',
        iso3: 'TLS',
        isoNo: '626',
        internet: 'TL'
    },
    {
        continent: 'Africa',
        region: 'Northern Africa',
        country: 'South Sudan',
        capital: 'Juba',
        fips: 'OD',
        iso2: 'SS',
        iso3: 'SSD',
        isoNo: '728',
        internet: 'SS'
    },
    {
        continent: 'Europe',
        region: 'Northern Europe',
        country: "\xc5land Islands",
        capital: 'Mariehamn',
        fips: 'AX',
        iso2: 'AX',
        iso3: 'ALA',
        isoNo: '248',
        internet: 'AX'
    },
    {
        continent: 'Americas',
        region: 'West Indies',
        country: 'Bonaire',
        capital: 'Kralendijk',
        fips: 'BQ',
        iso2: 'BQ',
        iso3: 'BES',
        isoNo: '535',
        internet: 'BQ'
    },
    {
        continent: 'Europe',
        region: 'South East Europe',
        country: 'Republic of Kosovo',
        capital: 'Pristina',
        fips: 'KV',
        iso2: 'XK',
        iso3: 'XKX',
        isoNo: null,
        internet: 'XK'
    }
];
module.exports.countries = countries;

},{}],"a8RC8":[function(require,module,exports,__globalThis) {
/**
 * Handles the logic for option swatches
 *
 * document.addEventListener("swatchesReady", function() {
 *   new SwatchGroup({
 *     wrapper: ".some-swatch-wrapper",
 *     productData: {{ product | json }},
 *     swatchData: {{ product.metafields.swatches | json }},
 *     [OPTIONAL] allowUnavailableSelections: true
 *   });
 * });
 *
 * If you assign the swatch group to a variable, you can access the
 * selectSwatchesFromUrl function.
 * e.g. let swatchGroup = new SwatchGroup({...});
 *      swatchGroup.selectSwatchesFromUrl();
 */ var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utilsJs = require("./utils.js");
const ThemeVars = window.ThemeVars;
class SwatchGroup {
    /**
   * Adds the swatch markup to the DOM and sets up event listeners
   */ addSwatchesToDOM() {
        const { wrapper, productData } = this;
        const productOptions = {
            option1: (0, _utilsJs.makeArrayUnique)(productData.variants.map((variant)=>variant.option1)),
            option2: (0, _utilsJs.makeArrayUnique)(productData.variants.map((variant)=>variant.option2)),
            option3: (0, _utilsJs.makeArrayUnique)(productData.variants.map((variant)=>variant.option3))
        };
        Object.keys(productOptions).forEach((optionPosition)=>{
            const optionName = productData.options[parseInt(optionPosition.replace('option', '')) - 1]; // e.g. Colour
            const optionValues = productOptions[optionPosition]; // e.g. ['Red', 'Blue', 'Green']
            if (optionName && optionValues.length) {
                const { swatches, selector } = this.generateSwatches(optionName, optionPosition, optionValues);
                wrapper.insertAdjacentHTML('beforeend', swatches);
                wrapper.querySelectorAll(selector).forEach((swatch)=>{
                    swatch.addEventListener('click', this.handleSwatchClick.bind(this));
                });
            }
            if (document.querySelector('.product__tab') !== null) document.querySelector('.product__tab').addEventListener('click', this.handleSwatchClick.bind(this));
        });
    }
    /**
   * Generates the markup for the swatches for a given option
   * @param {string} optionName - The name of the option e.g. Colour
   * @param {string} optionPosition - The position of the option e.g. option1
   * @param {array} optionValues - The values of the option e.g. ['Red', 'Blue', 'Green']
   * @returns {object} - An object containing the markup and a selector for this set of swatches
   */ generateSwatches(optionName, optionPosition, optionValues) {
        const selector = `swatch-${optionPosition}`;
        const swatchItemsMarkup = optionValues.map((optionValue)=>{
            const swatchBackground = this.getSwatchBackground(optionValue);
            let swatchType;
            if (swatchBackground) swatchType = swatchBackground.includes('http') ? 'image' : 'colour';
            else swatchType = 'text';
            const swatchBackgroundCss = swatchType == 'image' ? `background-image: url(${swatchBackground});` : `background-color: ${swatchBackground};`;
            let optionValueText = optionValue;
            /*
       * switch (optionValue) {
       * case 'XS':
       *   optionValueText = 'Extra Small';
       *   break;
       * case 'S':
       *   optionValueText = 'Small';
       *   break;
       * case 'M':
       *   optionValueText = 'Medium';
       *   break;
       * case 'L':
       *   optionValueText = 'Large';
       *   break;
       * case 'XL':
       *   optionValueText = 'Extra Large';
       *   break;
       * case 'XXL':
       *   optionValueText = 'Extra Extra Large';
       *   break;
       * default:
       *   optionValueText = optionValue;
       *   break;
       * }
       */ return `
        <div
          data-selector="${selector}"
          style="${swatchBackgroundCss}"
          data-option-index="${optionPosition}"
          data-option-value="${optionValue}"
          class="swatch-group__swatch swatch-group__swatch--${swatchType}">
          ${swatchType == 'text' ? `<span>${optionValueText}</span>` : ''}
        </div>
      `;
        }).join('\n');
        /*
     * const swatches = `
     *   <div class="swatch-group">
     *     <div class="swatch-group__label">${optionName}:<span> <span></div>
     *     <div class="swatch-group__swatches">${swatchItemsMarkup}</div>
     *   </div>
     * `;
     */ // Create dropdown selector for swatches
        const swatches = optionValues.length > 5 ? `
    <div class="swatch-group swatch-group__selector">
            <div class="swatch-group__label">${optionName}:<span> <span></div>
    <div class="product__tab">
        <div class="product__tab__title">
            <p class="product__tab__text">${optionValues[0]}</p>
            <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="black" stroke-linecap="round"></path>
            </svg>
        </div>
        <div class="product__tab__content" style="display: none;">
          
            <div class="swatch-group__swatches">${swatchItemsMarkup}</div>
          
        </div>
    </div>
    </div>
    
    ` : `
      <div class="swatch-group" style="${optionName === 'Title' ? 'display:none;' : 'display:block;'}">
        <div class="swatch-group__label">${optionName}:<span> <span></div>
        <div class="swatch-group__swatches">${swatchItemsMarkup}</div>
      </div>
    `;
        return {
            swatches,
            selector: `[data-selector="${selector}"]`
        };
    }
    /**
   * Handles the click event on a swatch item
   *  - Sets the selected option for this swatch group
   *  - Visibly selects the swatch item
   *  - Marks swatches that would be unavailable with this selection
   *  - Updates the variant selector if a variant is selected and emits an event
   * @param {object} event - The click event
   */ handleSwatchClick(event) {
        event.stopPropagation();
        const swatchItem = event.currentTarget;
        const { optionIndex, optionValue } = swatchItem.dataset;
        this.selectedOptions[optionIndex] = optionValue;
        this.visiblySelectSwatch(swatchItem);
        this.markUnavailableSwatches(swatchItem);
        this.setSelectedVariant(this.getSelectedVariant());
        this.changeLabelValue(optionIndex, optionValue, swatchItem, this.wrapper);
    }
    // Changes the value displayed next to the swatch group label
    changeLabelValue(optionIndex, optionValue, swatchItem, wrapper) {
        let label = '';
        if (swatchItem.classList.contains('product__tab') && swatchItem.classList.contains('selected')) return;
        if (swatchItem.parentNode.parentNode.className == 'product__tab__content') label = swatchItem.parentNode.parentNode.parentNode.previousElementSibling;
        else label = swatchItem.parentNode.previousElementSibling;
        const labelValue = label ? label.querySelector('span') : null;
        if (labelValue) labelValue.innerHTML = ` ${optionValue}`;
        if (swatchItem.parentNode.parentNode.className == 'product__tab__content') {
            const selectorLabel = swatchItem.parentNode.parentNode.parentNode.querySelector('.product__tab__text');
            if (selectorLabel) selectorLabel.innerHTML = optionValue;
        }
    }
    /**
   * Visibly selects a swatch item with a class and deselects all other sibling swatch items
   * @param {object} swatch - The swatch item to visibly select
   * @returns {function | void} - Either a console error or nothing
   */ visiblySelectSwatch(swatch) {
        var _swatch_parentNode;
        if (!swatch) return console.error('SwatchGroup: Could not visibly select swatch, swatch does not exist.');
        /* Check if this swatch is inside a fake dropdown - see generateSwatches() */ let dropdownCheck = (_swatch_parentNode = swatch.parentNode) === null || _swatch_parentNode === void 0 ? void 0 : _swatch_parentNode.parentNode;
        if (dropdownCheck && dropdownCheck.classList.contains('product__tab__content')) {
            const dropdownContainer = dropdownCheck.parentNode;
            const optionText = dropdownContainer.querySelector('.product__tab__text');
            optionText.textContent = swatch.dataset.optionValue;
        }
        const swatchClass = swatch.classList[0];
        const swatchSiblings = swatch.parentNode.querySelectorAll(`.${swatchClass}`);
        swatchSiblings.forEach((swatchSibling)=>{
            swatchSibling.classList.remove('selected');
        });
        swatch.classList.add('selected');
    }
    /**
   * Combines a recently selected swatch with all other relevant swatches
   * If this combination would be an unavailable variant, marks the swatch as unavailable
   * Otherwise marks the swatch as available
   * @param {object} selectedSwatch - The swatch that was just selected
   */ markUnavailableSwatches(selectedSwatch) {
        const swatchClass = selectedSwatch.classList[0];
        const allSwatches = this.wrapper.querySelectorAll(`.${swatchClass}`);
        allSwatches.forEach((swatch)=>{
            if (selectedSwatch.dataset.optionIndex != swatch.dataset.optionIndex) {
                const temporarySelections = (0, _objectSpread._)({}, this.selectedOptions);
                temporarySelections[swatch.dataset.optionIndex] = swatch.dataset.optionValue;
                const variant = this.getSelectedVariant(temporarySelections);
                if (variant && variant.dataset.available != 'true') {
                    swatch.classList.add('unavailable');
                    /* If swatch only has 1 option, visually mark as available while keeping it unavailable */ let siblingsCheck = swatch.parentNode.children.length;
                    if (siblingsCheck <= 1) swatch.classList.add('swatch__only-option');
                    if (siblingsCheck <= 5) swatch.classList.add('swatch__style-notify-me');
                    if (!this.allowUnavailableSelections) swatch.classList.add('disabled');
                } else swatch.classList.remove('unavailable', 'disabled');
            }
        });
    }
    /**
   * Gets the variant that matches some specific option selections
   * @param {object} selections - An object containing the selected options, defaults to the user's selections
   * @returns {HTMLElement} - The variant <option> that matches the selected options
   */ getSelectedVariant(selections = this.selectedOptions) {
        const variants = Array.from(this.variantSelector.querySelectorAll('option'));
        const selectedVariant = variants.find((variant)=>{
            return (variant.dataset['option-1'] === selections.option1 || variant.dataset['option-1'] == 'null') && (variant.dataset['option-2'] === selections.option2 || variant.dataset['option-2'] == 'null') && (variant.dataset['option-3'] === selections.option3 || variant.dataset['option-3'] == 'null');
        });
        return selectedVariant;
    }
    /**
   * Sets the selected variant for the variant selector
   * Emits a variantChanged event if a variant is selected
   * @param {object} variant - The variant <option> to select
   */ setSelectedVariant(variant) {
        if (this.variantSelector && variant) {
            var _variant_closest;
            this.variantSelector.value = variant.value;
            const variantChangedEvent = new CustomEvent('variantChanged', {
                detail: {
                    wrapper: this.wrapper,
                    variant: this.variantSelector.value,
                    available: variant.dataset.available == 'true'
                }
            });
            const priceContainer = (_variant_closest = variant.closest('.product__info-wrapper')) === null || _variant_closest === void 0 ? void 0 : _variant_closest.querySelector('.product__price__container');
            if (priceContainer) {
                const variantPrice = this.variantPrices[`${variant.value}`];
                if (variantPrice) {
                    const newPrice = `
            ${variantPrice.compare_at_price ? `
              <div class="product__compare-at-price">
                  <span>${variantPrice.compare_at_price}</span>
              </div>
            ` : ''}
            <div class="product__price ${variantPrice.compare_at_price ? 'product__price__sale' : ''}">
              <span>${variantPrice.price}</span>
            </div>
          `;
                    priceContainer.innerHTML = newPrice;
                }
            }
            document.dispatchEvent(variantChangedEvent);
        }
    }
    /**
   * Gets the background colour or image of a swatch item
   * Defaults to the data from ThemeVars if this product doesn't have specific data for this swatch value
   * @param {string} swatchValue - The value of the swatch e.g. Red
   * @returns {string} - The background colour or image of the swatch item
   */ getSwatchBackground(swatchValue) {
        return this.swatchData.hasOwnProperty(swatchValue) ? this.swatchData[swatchValue] : ThemeVars.swatches[swatchValue];
    }
    /**
   * Selects swatches in this swatch group based on a variant URL parameter
   * @returns {boolean} - Whether or not swatches were selected
   */ selectSwatchesFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        let variant = urlParams.get('variant');
        // set the default variant if none is found in the url
        if (!variant) variant = this.productData.variants[0].id;
        let variantSelection = Array.from(this.variantSelector.querySelectorAll('option')).find((option)=>option.value == variant);
        /* If variant unavailable, select the first available one, if such exists */ if (variantSelection.dataset.available !== 'true' && this.variantSelector.querySelector('option[data-available="true"]')) variantSelection = this.variantSelector.querySelector('option[data-available="true"]');
        if (variantSelection && (variantSelection.dataset.available == 'true' || this.allowUnavailableSelections)) {
            this.selectedOptions = {
                option1: variantSelection.dataset['option-1'].replace('null', ''),
                option2: variantSelection.dataset['option-2'].replace('null', ''),
                option3: variantSelection.dataset['option-3'].replace('null', '')
            };
            this.setSelectedVariant(variantSelection);
            Object.keys(this.selectedOptions).forEach((optionIndex)=>{
                const swatch = this.wrapper.querySelector(`[data-option-value="${this.selectedOptions[optionIndex]}"]`);
                if (swatch) {
                    this.visiblySelectSwatch(swatch);
                    this.markUnavailableSwatches(swatch);
                }
            });
            return true;
        }
        return false;
    }
    constructor(args){
        (0, _defineProperty._)(this, "selectedOptions", {});
        (0, _defineProperty._)(this, "variantSelector", null);
        (0, _defineProperty._)(this, "allowUnavailableSelections", true);
        const { wrapper, productData, variantPrices, swatchData, allowUnavailableSelections } = args;
        this.variantPrices = variantPrices;
        // Handle basic errors
        if (!wrapper) return console.error('SwatchGroup: Could not create swatch group, requires a wrapper.');
        if (!productData) return console.error('SwatchGroup: Could not create swatch group, requires a productData object.');
        if (!swatchData) return console.error('SwatchGroup: Could not create swatch group, requires a swatchData object.');
        if (!document.querySelector(wrapper)) return console.error('SwatchGroup: Could not create swatch group, wrapper does not exist.');
        if (!ThemeVars) return console.error('SwatchGroup: Could not create swatch group, theme variables do not exist.');
        if (!ThemeVars.hasOwnProperty('swatches')) return console.error('SwatchGroup: Swatches are not enabled in the current theme\'s settings.');
        // Add product and swatch data
        this.wrapper = document.querySelector(wrapper);
        this.productData = productData;
        this.swatchData = swatchData;
        if (allowUnavailableSelections) this.allowUnavailableSelections = allowUnavailableSelections;
        // Generate random key for variant selector
        const variantSelectorKey = Math.random().toString(36).substring(2, 10);
        // Add swatches markup to DOM and set up event listeners
        const variantSelectorMarkup = `
      <select style="display: none;" name="id" id="variant-selector-${this.productData.id}" data-key="${variantSelectorKey}">
        <option value="" selected disabled></option>
        ${this.productData.variants.map((variant)=>`<option
          data-option-1="${variant.option1}"
          data-option-2="${variant.option2}"
          data-option-3="${variant.option3}"
          data-available="${variant.available}"
          data-sku="${variant.sku}"
          value="${variant.id}">${variant.title}</option>`).join('')}
      </select>`;
        this.wrapper.insertAdjacentHTML('beforeend', variantSelectorMarkup);
        this.variantSelector = document.querySelector(`[data-key="${variantSelectorKey}"]`);
        this.addSwatchesToDOM();
    }
}
window.SwatchGroup = SwatchGroup;
document.dispatchEvent(new CustomEvent('swatchesReady'));

},{"@swc/helpers/_/_define_property":"5gweT","@swc/helpers/_/_object_spread":"7R2pM","./utils.js":"juuyl"}],"5gweT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"7R2pM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"5gweT","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"iUmrV":[function(require,module,exports,__globalThis) {
/**
 * This file keeps track of a users recently viewed products.
 */ var _utilsJs = require("./utils.js");
const ThemeVars = window.ThemeVars;
let currencySymbol = window.ThemeVars.currency.symbol;
const RecentlyViewed = {
    config: {
        maxProducts: 5
    },
    state: {
        products: []
    },
    reloadScripts: (0, _utilsJs.reloadScripts),
    /**
   * Initialize the Recently Viewed module.
   * - Set the state to the current products in local storage
   * - Make sure the products tracked are not more than the maxProducts config
   * - If user is viewing a product, add it to the list
   * - Emits a recentlyViewedReady event at the end
   */ init: function() {
        if (localStorage.getItem('recentlyViewed')) this.state.products = JSON.parse(localStorage.getItem('recentlyViewed'));
        if (this.state.products.length > this.config.maxProducts) {
            let deleteCount = this.state.products.length - this.config.maxProducts;
            this.state.products.splice(this.config.maxProducts, deleteCount);
            this.updateProducts(this.state.products);
        }
        if (ThemeVars && ThemeVars.product) this.addProduct(ThemeVars.product);
        document.dispatchEvent(new CustomEvent('recentlyViewedReady'));
    },
    // prod card
    createProductCard: function(product) {
        var _product_images_, _product_images;
        let compare_at_price = product.compare_at_price;
        let price = product.price;
        let saleText = 'SALE';
        let saleBannerColor = '#CE0E2D';
        if (window.ThemeVars.site_wide_sale.activated == true) {
            console.log('got here');
            const promoTag = window.ThemeVars.site_wide_sale.promotion_tag;
            const tags = product.tags;
            const discount = (100 - window.ThemeVars.site_wide_sale.promotion_percentage) / 100.0;
            tags.map((tag)=>{
                if (tag === promoTag) {
                    compare_at_price = price;
                    price = price * discount;
                    saleText = window.ThemeVars.site_wide_sale.banner_text;
                    saleBannerColor = window.ThemeVars.site_wide_sale.banner_color;
                }
            });
        }
        const onSale = +compare_at_price > +price;
        const exchangeRate = 1; // window.Shopify.currency.rate;
        // TODO: is new logic
        const isNew = false;
        const card = document.createElement('div');
        card.classList.add('prod-card');
        card.innerHTML = `
      <div class="prod-card__image-container">
      <div class="prod-card__rollover-images">

      <div class="prod-card__alternate-image">
        <a href="/products/${product.handle}">
          <img width="295" height="443" src="${product.images[1]}&width=400" alt="${(_product_images = product.images) === null || _product_images === void 0 ? void 0 : (_product_images_ = _product_images[1]) === null || _product_images_ === void 0 ? void 0 : _product_images_.alt}" class="prod-card__image" />
        </a>
      </div>
      
      <div class="prod-card__original-image">
        <a href="/products/${product.handle}">
          <img width="295" height="443" src="${product.images[0]}&width=400" alt="${product.images[0].alt}" class="prod-card__image" />
        </a>
      </div>
      
      ${window.themeSettings.enable_quickview ? `
        <div class="prod-card__quick-view prod-card__quick-view-${product.handle}">
          <button class="prod-card__quick-view__button" data-quickshop="${product.handle}">+ Quick Add</button>
        </div>
        ` : ''}
    
        </div>
        <div class="prod-card__badges">
          ${isNew ? `<div class="prod-card__tag">
              <span class="prod-card__tag__text">{{- new_tag_text -}}</span>
            </div>` : ''}
            
        </div>
        ${!product.tags.includes('free-gift-product') ? `<div class="prod-card__wishlist-heart prod-card__wishlist-heart-${product.handle}">
          <button
            data-with-epi="true"
            class="swym-button swym-add-to-wishlist-view-product product_${product.id}"
            data-swaction="addToWishlist"
            data-product-id={product.id}
            data-variant-id={product.variants[0].id}
            data-product-url="https://www.carraigdonn.com/products/${product.handle}">
          </button>
        </div>` : ''}
      </div>
      <div class="prod-card__banner">
        ${onSale ? `<div class="prod-card__sale-banner" style="background-color: ${saleBannerColor}">
                    <span class="prod-card__banner__text">${saleText}</span>
                  </div>` : ''}
              </div>
      <div class="prod-card__info">
        <div class="prod-card__info__details">
          <a href="/products/${product.handle}">
            <h3 class="prod-card__title">
              ${product.title}
            </h3>
          </a>
          <div class="prod-card__info__price">
          <div class="prod-card__price__container">
            ${onSale ? `
            <div class="prod-card__compare-at-price">
              ${currencySymbol}${(compare_at_price * exchangeRate / 100).toFixed(2)}
            </div>` : ''}
            <div class="prod-card__price ${onSale ? 'prod-card__price__sale' : ''}">
            ${currencySymbol}${(price * exchangeRate / 100).toFixed(2)}
            </div>
          </div>
        </div>
        </div>
        
          <div class="prod-card__vendor">
            ${product.vendor}
          </div>
      </div>
  
  `;
        return card;
    },
    /**
   * Add a product to the list of recently viewed products
   * @param {Object} product - The product to add
   */ addProduct: function(product) {
        let products = this.state.products;
        if (products.findIndex((p)=>p.id == product.id) === -1) {
            if (products.length >= this.config.maxProducts) products.shift();
            products.push(product);
            this.updateProducts(products);
        }
    },
    /**
   * Update the list of recently viewed products
   * - Updates both state and local storage
   * - Emits a recentlyViewedUpdated event at the end
   * @param {Array} products - The products to update
   */ updateProducts: function(products) {
        this.state.products = products;
        localStorage.setItem('recentlyViewed', JSON.stringify(this.state.products));
        document.dispatchEvent(new CustomEvent('recentlyViewedUpdated'));
    }
};
window.RecentlyViewed = RecentlyViewed;
RecentlyViewed.init();

},{"./utils.js":"juuyl"}],"bFxGc":[function(require,module,exports,__globalThis) {
/**
 * This file handles interactions with the Shopify cart object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utilsJs = require("./utils.js");
const ThemeVars = window.ThemeVars;
const Cart = {
    /**
   * Sets up the cart object.
   * Values will be provided with init.
   * The keys are snake case to preserve parity with the Shopify cart object.
   */ cartData: {
        attributes: {},
        cart_level_discount_applications: [],
        currency: '',
        item_count: 0,
        items: [],
        items_subtotal_price: '',
        note: null,
        original_total_price: 0,
        requires_shipping: false,
        token: null,
        total_discount: 0,
        total_price: 0,
        total_weight: 0
    },
    isEligibleForFreeGift: false,
    /**
   * Initialises the cart object.
   */ init: async function() {
        this.freeGiftSettings = this.freeGiftSettings || {};
        document.addEventListener('itemsAddedToCart', this.setCartData.bind(this));
        document.addEventListener('cartUpdated', this.setCartData.bind(this));
        const atcForms = document.querySelectorAll('form[action="/cart/add"]');
        atcForms.forEach((form)=>{
            form.addEventListener('submit', this.handleAtcSubmit);
        });
        await this.setCartData();
        document.dispatchEvent(new CustomEvent('cartReady'));
    },
    /**
   * Updates the cartData attribute with the current state of the cart from the API.
   */ setCartData: async function() {
        const cartData = await fetch('/cart.js').then((response)=>response.json());
        this.cartData = (0, _objectSpread._)({}, cartData);
        document.dispatchEvent(new CustomEvent('cartDataUpdated'));
    },
    /*
   * ================================================
   * 
   *                  ADDING ITEMS
   * 
   * ================================================
   */ /**
   * Handles submission of an add to cart form for a single variant.
   * @param {Event} event The submit event.
   */ handleAtcSubmit: async function(event) {
        event.preventDefault();
        const form = event.target;
        const params = (0, _utilsJs.getParamsFromForm)(form);
        if (!params.id) return console.error('handleAtcSubmit: No variant ID found in form.');
        const quantity = params.quantity || 1;
        const propertyInputKeys = Object.keys(params).filter((key)=>key.startsWith('properties'));
        const properties = {};
        propertyInputKeys.forEach((key)=>{
            const propertyName = key.replace('properties[', '').replace(']', '');
            properties[propertyName] = params[key];
        });
        Cart.addItem(params.id.toString(), parseInt(quantity), properties);
    },
    /**
   * Adds a single gift item to the cart.
   * @param {String|Integer} id - The variant ID for the item to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {void}
   */ addGiftItem: function(id, quantity = 1, properties = {}) {
        if (!id) return console.error('Cart.addItem() : id is required.');
        const item = {
            id: parseInt(id),
            quantity,
            properties
        };
        let freeGiftBlock = false;
        let freeGiftVariantIds = [];
        let freeGiftProducts = Array.isArray(ThemeVars.freeGiftProducts) ? ThemeVars.freeGiftProducts : [
            ThemeVars.freeGiftProducts
        ]; // convert to array 
        if (freeGiftProducts && freeGiftProducts.length > 0) freeGiftProducts.forEach((product)=>{
            if (product && product.variants > 0) product.variants.forEach((variant)=>{
                freeGiftVariantIds.push(variant.id);
            });
        });
        // Check if the item being added is a free gift product
        if (freeGiftVariantIds.includes(parseInt(item.id))) for(let i = 0; i < this.cartData.items.length; i++){
            const cartItem = this.cartData.items[i];
            if (freeGiftVariantIds.includes(parseInt(cartItem.id))) {
                freeGiftBlock = true;
                break;
            }
        }
        if (!freeGiftBlock) this.sendAddGift([
            item
        ]);
        else console.error('Cart.addItem() : Free gift item already in cart');
    },
    /**
   * Adds a single item to the cart.
   * @param {String|Integer} id - The variant ID for the item to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {void}
   */ addItem: function(id, quantity = 1, properties = {}) {
        if (!id) return console.error('Cart.addItem() : id is required.');
        const item = {
            id: parseInt(id),
            quantity,
            properties
        };
        this.sendAddToCart([
            item
        ]);
    },
    /**
   * Adds multiple items to the cart.
   * @param {Array} items - An array of objects containing the item data. Each should match format of Cart.addItem().
   * @returns {void}
   */ addMultipleItems: function(items) {
        if (!items || !items.length) return console.error('Cart.addMultipleItems() : items is required.');
        this.sendAddToCart(items);
    },
    /**
   * Add a free gift item to the cart, and remove any that have already been added.
   * @param {number} id 
   * @returns {void}
   */ addFreeGift: function(id) {
        this.addGiftItem(id, 1, {
            _free_gift: true
        });
    },
    sendAddGift: function(items) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                items
            })
        }).then((response)=>response.json()).then((cart)=>{
            if (cart.status) console.error(`Cart.sendAddToCart() : ${cart.description || cart.message || 'Unknown error'}`);
            else Minicart.reloadDrawer();
        });
    },
    /**
   * Sends the add to cart form to Shopify.
   * NOTE: You should use addItems or addMultipleItems instead of this method directly.
   * @param {Array} items - An array of objects containing the item data. Each should match format of Cart.addItem().
   */ sendAddToCart: function(items) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                items
            })
        }).then((response)=>response.json()).then((cart)=>{
            if (cart.status) console.error(`Cart.sendAddToCart() : ${cart.description || cart.message || 'Unknown error'}`);
            else document.dispatchEvent(new CustomEvent('itemsAddedToCart', {
                detail: {
                    items: items
                }
            }));
        });
    },
    /*
   * ================================================
   * 
   *            UPDATING CART PROPERTIES
   * 
   * ================================================
   */ /**
   * Adds a note to the current cart. 
   * @param {String} note - The note to add.
   */ addNote: function(note) {
        const updateBody = {
            note
        }; // E.g. {note: 'This is a note'}
        this.sendCartUpdate(updateBody);
    },
    /**
   * Adds a single cart attribute to the current cart.
   * @param {String} key - The key of the attribute to add.
   * @param {String} value - The value of the attribute to add.
   */ addAttribute: function(key, value) {
        const updateBody = {
            attributes: {
                [key]: value
            }
        };
        this.sendCartUpdate(updateBody);
    },
    /**
   * Adds multiple cart attributes to the current cart.
   * @param {Object} attributes - An object containing the attributes to add.
   * Example: {'Gift Message': 'Happy Birthday!', 'Gift Wrap': 'true'}
   */ addMultipleAttributes: function(attributes) {
        const updateBody = {
            attributes
        };
        this.sendCartUpdate(updateBody);
    },
    /**
   * Sends a cart update request to Shopify.
   * Fires the 'cartUpdated' event if successful.
   * @param {Object} updateBody - The body of the update request.
   */ sendCartUpdate: function(updateBody) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(updateBody)
        }).then((response)=>response.json()).then((cart)=>{
            if (cart.status) console.error(`Cart.sendCartUpdate() : ${cart.description || cart.message || 'Unknown error'}`);
            else document.dispatchEvent(new CustomEvent('cartUpdated'));
        });
    },
    /*
   * ================================================
   * 
   *             CHANGING LINE ITEM DATA
   * 
   * ================================================
   */ /**
   * Change the quantity of an item in the cart. 
   * @param {String|Integer} itemId - The variant ID or 1-based index position for the item to update.
   * @param {Integer} quantity - The new quantity of the item.
   * @returns {void}
   */ changeItemQuantity: function(itemId, quantity) {
        if (!itemId || quantity == null) return console.error('Cart.changeItemQuantity() : itemId and quantity are required.');
        const itemKey = parseInt(itemId) < 1000 ? 'line' : 'id';
        const changeBody = {
            [itemKey]: itemId.toString(),
            'quantity': parseInt(quantity)
        };
        this.sendCartChange(changeBody);
        if (ThemeVars.freeGiftEnabled) {
            let freeGiftVariantIds = [];
            let freeGiftProducts = Array.isArray(ThemeVars.freeGiftProducts) ? ThemeVars.freeGiftProducts : [
                ThemeVars.freeGiftProducts
            ]; // convert to array 
            if (freeGiftProducts && freeGiftProducts.length > 0) freeGiftProducts.forEach((product)=>{
                if (product && product.variants > 0) product.variants.forEach((variant)=>{
                    freeGiftVariantIds.push(variant.id);
                });
            });
            // Check if the item being added is a free gift product
            if (freeGiftVariantIds.includes(parseInt(itemId)) && quantity !== 0) window.setTimeout(function() {
                Minicart.reloadDrawer();
            }, 3000);
        }
    },
    changeItemQuantityGift: function(itemId, quantity) {
        if (!itemId || quantity == null) return console.error('Cart.changeItemQuantity() : itemId and quantity are required.');
        const itemKey = parseInt(itemId) < 1000 ? 'line' : 'id';
        const changeBody = {
            [itemKey]: itemId.toString(),
            'quantity': parseInt(quantity)
        };
        this.sendCartChangeGift(changeBody);
    },
    /**
   * Changes custom properties of an item in the cart. 
   * @param {String|Integer} itemId - The variant ID or 1-based index position for the item to update.
   * @param {Object} properties - The new properties of the item.
   * @returns {void}
   * Example: {'Gift Message': 'Happy Birthday!', 'Gift Wrap': 'true'}
   */ changeItemProperties: function(itemId, properties = {}) {
        if (!itemId) return console.error('Cart.changeItemProperties() : itemId is required.');
        if (!properties || Object.keys(properties).length === 0) return console.error('Cart.changeItemProperties() : properties is required and cannot be empty.');
        const itemKey = parseInt(itemId) < 1000 ? 'line' : 'id';
        const changeBody = {
            [itemKey]: itemId.toString(),
            'properties': properties
        };
        this.sendCartChange(changeBody);
    },
    sendCartChangeGift: function(changeBody) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(changeBody)
        }).then((response)=>{
            if (response.status && response.status != 200) console.error(`Cart.sendCartChange() : ${response.status == 404 ? 'Item not in cart' : 'Unknown error'}`);
        });
    },
    /**
   * Sends a cart change request to Shopify. 
   * NOTE: You should use changeItemQuantity or changeItemProperties instead of this method directly.
   * NOTE: This method will trigger the 'cartUpdated' event, rather than a 'cartChanged' event.
   * @param {Object} changeBody - The body of the change request.
   */ sendCartChange: function(changeBody) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(changeBody)
        }).then((response)=>{
            if (response.status && response.status != 200) console.error(`Cart.sendCartChange() : ${response.status == 404 ? 'Item not in cart' : 'Unknown error'}`);
            else document.dispatchEvent(new CustomEvent('cartUpdated'));
        });
    }
};
exports.default = Cart;
window.Cart = Cart;
Cart.init();

},{"@swc/helpers/_/_object_spread":"7R2pM","./utils.js":"juuyl","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"bzIp9":[function(require,module,exports,__globalThis) {
/**
 * This file handles logic relating to the minicart drawer.
 * See _cart.js for interactions with the Shopify cart object.
 */ var _utilsJs = require("./utils.js");
const Minicart = {
    /**
   * Sets up minicart config.
   * You will need to change this at the start of your project to your own minicart.
   */ config: {
        drawer: document.querySelector('[data-minicart-drawer]'),
        openClass: 'is-open',
        minimalCartClass: 'minimalcart__drawer',
        minicartSection: 'minicart',
        openDrawerOnAdd: true
    },
    state: {
        // The stores and clickAndCollect states get updated in the minicart.liquid section
        isLoading: false,
        step: 1,
        stores: [],
        clickAndCollect: true,
        deliveryType: 'home_delivery',
        selectedStore: {},
        hasHeavyGoods: false,
        hasExcludedCC: false,
        isInROI: true
    },
    /**
   * Initialises the minicart.
   */ init: function() {
        this.setupEventListeners();
        /*
     * this.state.cartItems = JSON.parse(document.getElementById('CartItems').innerHTML);
     * console.log('cartItems HTML', this.state.cartItems);
     */ document.dispatchEvent(new CustomEvent('minicartReady'));
    },
    showFreeGiftForm (visible) {
        const form = document.getElementById('free-gift-form');
        if (!form) return;
        form.hidden = !visible;
    },
    showFreeGiftPrompt (visible) {
        // QSAll in case design requires multiple prompts in the future. --GAD
        document.querySelectorAll('.minicart__body__').forEach((p)=>p.hidden = !visible);
    },
    /**
   * Prepares correct URL format for the relevant shipping address object and cart attribute
   * @param {Object} data - The object to encode. Defaults to empty object for home delivery.
   */ encodeParameters () {
        const mappedParams = [];
        //const mappedParams = ['checkout[shipping_address]' + '[address1]=' + this.state.selectedStore.address1 + '[address2]=' + this.state.selectedStore.address2 + '[city]=' + this.state.selectedStore.city + '[county]=' + this.state.selectedStore.county + '[country]=' + this.state.selectedStore.country + '[province]=' + this.state.selectedStore.province + '[zip]=' + this.state.selectedStore.zip];
        mappedParams.push('attributes[delivery_type]=' + this.state.deliveryType);
        mappedParams.push('attributes[click_and_collect_email]=' + (this.state.deliveryType == 'click_and_collect' ? this.state.selectedStore.email : 'N/A'));
        mappedParams.push('attributes[click_and_collect_store]=' + (this.state.deliveryType == 'click_and_collect' ? this.state.selectedStore.name : 'N/A'));
        const joinedParams = '?step=contact_information&' + mappedParams.join('&');
        return joinedParams;
    },
    setDeliveryType (type) {
        const ccErrorMessage = document.querySelector('#CCErrorMessage');
        const ccSuccessMessage = document.querySelector('#CCSuccessMessage');
        const ccStoreSelector = document.querySelector('#ClickAndCollectStoreSelector');
        if (this.state.hasHeavyGoods && type == 'click_and_collect' || this.state.hasExcludedCC && type == 'click_and_collect') {
            this.state.deliveryType = 'home_delivery';
            // document.querySelector('.minicart__delivery-options__selector').innerHTML = 'Only Home Dleivery is available for this order';
            ccErrorMessage.hidden = false;
            ccSuccessMessage.hidden = true;
            ccStoreSelector.hidden = true;
        } else {
            this.state.deliveryType = type;
            if (type == 'click_and_collect') {
                this.state.selectedStore = this.state.stores[0];
                ccErrorMessage.hidden = true;
                ccSuccessMessage.hidden = false;
                ccStoreSelector.hidden = false;
            }
        }
    },
    setDeliveryStore (store) {
        this.state.selectedStore = store;
    },
    handleCheckoutSubmit () {
        window.location.href = '/checkout' + this.encodeParameters();
    },
    setHasInteractedWithMinicart (trueOrFalse) {
        this.state.hasInteractedWithMinicart = trueOrFalse;
    },
    /**
   * Sets up event listeners for the minicart.
   *  - Separated so we can re-add them if the minicart is re-rendered.
   */ setupEventListeners: async function() {
        const onItemsAddedToCart = (e)=>{
            let item;
            if (e.detail.items && e.detail.items.length > 0) item = e.detail.items[0];
            Minicart.reloadDrawer();
            if (Minicart.config.openDrawerOnAdd) {
                const onMinicartReloaded = ()=>{
                    if (item) {
                        Minicart.openDrawer("minimal", item.id);
                        setTimeout(()=>{
                            Minicart.closeDrawer("minimal");
                        }, 5000);
                    } else Minicart.openDrawer();
                    document.removeEventListener('minicartReloaded', onMinicartReloaded);
                };
                document.addEventListener('minicartReloaded', onMinicartReloaded);
            }
            document.removeEventListener('itemsAddedToCart', onItemsAddedToCart);
        };
        document.addEventListener('itemsAddedToCart', onItemsAddedToCart);
        this.config.drawer.addEventListener('click', ()=>{
            this.setHasInteractedWithMinicart(true);
        });
        this.config.drawer.addEventListener('pointerenter', ()=>{
            this.setHasInteractedWithMinicart(true);
        });
        document.querySelectorAll('.js-show-free-gift-form').forEach((el)=>el.addEventListener('click', ()=>this.showFreeGiftForm(true)));
        document.querySelectorAll('.js-hide-free-gift-form').forEach((el)=>el.addEventListener('click', (e)=>{
                if (e.target !== e.currentTarget) return;
                this.showFreeGiftForm(false);
            }));
        document.addEventListener('freeGiftEligibilityChanged', (e)=>{
            const { isEligible } = e.detail;
            this.showFreeGiftPrompt(isEligible);
        });
    },
    openDrawer: function(cartType, productId) {
        if (window.location.pathname == "/cart") return false;
        if (cartType == "minimal") {
            this.config.drawer.classList.add(this.config.minimalCartClass);
            if (productId) {
                let lineItem = this.config.drawer.querySelector(`.minicart__item--${productId}`);
                if (lineItem) lineItem.classList.add("minicart__item-new");
            }
            const underlay = document.querySelector('.modal-underlay');
            underlay.classList.add('modal-underlay-mini-cart');
        } else this.config.drawer.classList.remove(this.config.minimalCartClass);
        this.config.drawer.classList.add(this.config.openClass);
        const underlay = document.querySelector('.modal-underlay');
        underlay.style.display = 'block';
        const bodyContent = document.querySelector('body');
        bodyContent.style.overflow = 'hidden';
    },
    closeDrawer: function(cartType) {
        this.config.drawer.classList.remove(this.config.openClass);
        const underlay = document.querySelector('.modal-underlay');
        underlay.classList.remove('modal-underlay-mini-cart');
        underlay.style.display = 'none';
        const bodyContent = document.querySelector('body');
        bodyContent.style.overflow = 'auto';
        if (cartType == "minimal") {
            setTimeout(()=>{
                this.config.drawer.classList.add("is-closing");
            }, 500);
            setTimeout(()=>{
                this.config.drawer.classList.remove(this.config.minimalCartClass);
                let lineItems = document.querySelectorAll(".minicart__item-new");
                if (lineItems.length > 0) lineItems.forEach((lineItem)=>{
                    lineItem.classList.remove("minicart__item-new");
                });
                this.config.drawer.classList.remove("is-closing");
            }, 1000);
        }
    },
    toggleDrawer: function() {
        if (window.location.pathname == "/cart") return false;
        this.config.drawer.classList.toggle(this.config.openClass);
        const underlay = document.querySelector('.modal-underlay');
        underlay.style.display == 'none' ? underlay.style.display = 'block' : underlay.style.display = 'none';
        const bodyContent = document.querySelector('body');
        bodyContent.style.overflow == 'auto' ? bodyContent.style.overflow = 'hidden' : bodyContent.style.overflow = 'auto';
    },
    /**
   * Reloads the minicart drawer markup.
   * Sets up new event listeners.
   * Shows a loading state between.
   */ reloadDrawer: async function() {
        this.state.isLoading = true;
        this.config.drawer.innerHTML = this.loadingScreenMarkup;
        const newMinicartDrawer = await fetch(`?section_id=${this.config.minicartSection}`).then((response)=>response.text());
        // console.log('newMinicartDrawer', newMinicartDrawer);
        const temporaryElement = document.createElement('div');
        temporaryElement.innerHTML = newMinicartDrawer;
        const newMinicartDrawerMarkup = temporaryElement.querySelector('[data-minicart-drawer]').innerHTML;
        this.config.drawer.innerHTML = newMinicartDrawerMarkup;
        (0, _utilsJs.reloadScripts)(this.config.drawer);
        this.setupEventListeners();
        this.state.isLoading = false;
        /*
     * this.state.cartItems = JSON.parse(document.getElementById('CartItems').innerHTML);
     * console.log('cartItems HTML', this.state.cartItems);
     */ this.state.cartItems = JSON.parse(document.getElementById('CartItems').innerHTML);
        document.dispatchEvent(new CustomEvent('minicartReloaded'));
    },
    loadingScreenMarkup: `
    <!-- Loading Screen -->
    <div style="display: flex; width: 100%; height: 100%; min-height: 250px; justify-content: center; align-items: center;">
      <div class="loader__container">
        <div class="loader__inner">
          <div></div>
        </div>
      </div>
    </div>
  `
};
window.Minicart = Minicart;
Minicart.init();

},{"./utils.js":"juuyl"}],"9JRvR":[function(require,module,exports,__globalThis) {
/**
 * This file handles the wishlist functionality.
 * A user does not need to be logged in to have a wishlist.
 * The wishlist is stored in local storage - therefore specific to the browser, not the user.
 * Storing the wishlist on the user or cross device will require a third party service.
 */ const Wishlist = {
    config: {
        maxProducts: 0 // 0 means no limit
    },
    state: {
        products: []
    },
    /**
   * Initialize the Wishlist module.
   * - Set the state to the current products in local storage
   * - Make sure the products tracked are not more than the maxProducts config
   * - Emits a wishlistReady event at the end
   */ init: function() {
        if (localStorage.getItem('wishlist')) this.state.products = JSON.parse(localStorage.getItem('wishlist'));
        if (this.state.products.length > this.config.maxProducts && this.config.maxProducts != 0) {
            const deleteCount = this.state.products.length - this.config.maxProducts;
            this.state.products.splice(this.config.maxProducts, deleteCount);
            this.updateProducts(this.state.products);
        }
        document.dispatchEvent(new CustomEvent('wishlistReady'));
    },
    /**
   * Add a product to the list of wishlist products
   * - Updates both state and local storage
   * @param {String} handle - The product handle to add
   */ addProduct: function(handle) {
        if (this.state.products.length >= this.config.maxProducts && this.config.maxProducts != 0) {
            console.error('Wishlist.addProduct() : Cannot add product to wishlist. Max products reached.');
            return;
        }
        const products = this.state.products;
        if (products.findIndex((p)=>p == handle) === -1) {
            products.push(handle);
            this.updateProducts(products);
        }
    },
    /**
   * Remove a product from the list of wishlist products
   * - Updates both state and local storage
   * @param {String} handle - The product handle to remove
   * @returns {Boolean} - Whether the product was removed or not
   */ removeProduct: function(handle) {
        const products = this.state.products;
        const index = products.findIndex((p)=>p == handle);
        if (index !== -1) {
            products.splice(index, 1);
            this.updateProducts(products);
            return true;
        }
        return false;
    },
    /**
   * Update the list of wishlist products
   * - Updates both state and local storage
   * - Emits a wishlistUpdated event at the end
   * @param {Array} products - The products to update
   */ updateProducts: function(products) {
        this.state.products = products;
        localStorage.setItem('wishlist', JSON.stringify(this.state.products));
        document.dispatchEvent(new CustomEvent('wishlistUpdated'));
    },
    /**
   * Gets product data of the wishlist products
   * @returns {Array} - The products in the wishlist
   */ getProducts: async function() {
        const products = await Promise.all(this.state.products.map(async (handle)=>await this.getProduct(handle)));
        return products;
    },
    /**
   * Gets product data of a single product
   * @param {String} handle - The product handle to get
   */ getProduct: async function(handle) {
        const data = await fetch(`/products/${handle}.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>response.json());
        return data;
    }
};
window.Wishlist = Wishlist;
Wishlist.init();

},{}],"5g71u":[function(require,module,exports,__globalThis) {
/**
 * This file handles rendering and interactions with the quick shop modal.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Quickshop", ()=>Quickshop);
var _utils = require("./utils");
const Quickshop = {
    config: {
        section: 'quickshop',
        quickshopClass: 'quickshop-modal',
        triggerQuery: '[data-quickshop]',
        handleAttribute: 'data-quickshop' // Attribute to use for quickshop handle
    },
    state: {
        atcEvent: null
    },
    /**
   * Initialize the quickshop object.
   *  - Add event listeners to all trigger elements.
   */ init: function() {
        const triggerElements = document.querySelectorAll(this.config.triggerQuery);
        triggerElements.forEach((triggerElement)=>{
            // Check if the button already has the event listener so is not added again.
            if (!triggerElement.dataset.hasClickEvent) triggerElement.addEventListener('click', this.handleTriggerClick.bind(this, triggerElement));
            triggerElement.dataset.hasClickEvent = 'true';
        });
    },
    /**
   * Handle the click event on a quickshop trigger.
   *  - Prevents default action.
   *  - Get the handle attribute value.
   *  - Create a quickshop for this product hanlde.
   * @param {object} event - The click event.
   * @param {object} target - The triggered element.
   */ handleTriggerClick: function(target, event) {
        event.preventDefault();
        const handle = target.getAttribute(this.config.handleAttribute);
        console.log('HANDLE', handle);
        this.createQuickshop(handle);
    },
    /**
   * Removes the quickshop modal from the page, and removes the atc event listener.
   */ destroyQuickshop: function() {
        const modal = document.querySelector(`.${this.config.quickshopClass}`);
        if (modal) modal.remove();
        document.removeEventListener('itemsAddedToCart', this.state.atcEvent);
    },
    /**
   * Gets quickshop modal markup, appends it to the page, and adds an atc event listener.
   *  - Will also reload any scripts in the markup.
   *  - Shows a loading screen briefly.
   * @param {string} productHandle - The handle of the product to quickshop.
   */ createQuickshop: async function(productHandle) {
        const loadingMarkup = (0, _utils.generateModal)(this.config.quickshopClass, this.loadingScreenMarkup);
        document.body.insertAdjacentHTML('beforeend', loadingMarkup);
        const modalInner = document.querySelector(`.${this.config.quickshopClass}__inner`);
        const quickshopMarkup = await this.getQuickshopMarkup(productHandle);
        modalInner.innerHTML = quickshopMarkup;
        (0, _utils.reloadScripts)(modalInner);
        this.state.atcEvent = document.addEventListener('itemsAddedToCart', this.destroyQuickshop.bind(this));
        document.dispatchEvent(new CustomEvent('quickshopCreated'));
    },
    /**
   * Gets the quickshop markup for the product.
   * @param {string} productHandle - The handle of the product to quickshop.
   * @returns {string} - The markup for the quickshop modal.
   */ getQuickshopMarkup: async function(productHandle) {
        const response = await fetch(`/products/${productHandle}?section_id=${this.config.section}`).then((response)=>response.text());
        return response;
    },
    /**
   * Markup for the loading screen when quickshop is loading.
   */ loadingScreenMarkup: `
    <!-- Loading Screen -->
    <div style="display: flex; width: 100%; height: 100%; min-height: 250px; justify-content: center; align-items: center;">
      <div class="loader__container">
        <div class="loader__inner">
          <div></div>
        </div>
      </div>
    </div>
  `
};
window.Quickshop = Quickshop;
document.dispatchEvent(new CustomEvent('quickshopReady'));

},{"./utils":"juuyl","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"93gCs":[function(require,module,exports,__globalThis) {
/**
 * This file is responsible for getting product recommendations from the Shopify API.
 * It requires a "seed" product, which is the product that the recommendations are based on.
 * 
 * It uses the following data (dependant on Shopify plan) to generate the recommendations:
 * - Purchase History - Finds products that have historically been purchased with the seed product.
 * - Product Description - Finds products that have similar descriptions to the seed product.
 * - Related Collections - Finds products from collections that the seed product is a part of. Does not include 'all' or 'frontpage' collections.
 * 
 * See the following for more information:
 * https://shopify.dev/themes/product-merchandising/recommendations#recommendation-logic
 * 
 * Use the recommendations object for markup if you are requesting a section:
 * https://shopify.dev/api/liquid/objects/recommendations 
 */ const ProductRecommendations = {
    config: {
        limit: 6 // How many products to return - max is 10
    },
    state: {
        json: null,
        markup: null
    },
    /**
   * Get the product recommendations from the Shopify API.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @param {string} section - Optional. A section to render with recommendations.
   * @returns {object} - The product recommendations. Always with json, optionally with markup.
   * @example
   * const recommendations = await ProductRecommendations.getRecommendations(seedProductId);
   * console.log(recommendations.json);
   * console.log(recommendations.markup);
   */ getRecommendations: async function(seedProduct, section = null) {
        if (!seedProduct) return console.error('getRecommendations: No seed product provided.');
        if (!parseInt(seedProduct)) return console.error('getRecommendations: seedProduct must be a product ID.');
        this.state.json = await this.getJson(seedProduct);
        if (section) this.state.markup = await this.getMarkup(seedProduct, section);
        this.dispatchRecommendationEvent();
        return this.state;
    },
    /**
   * Returns parsed JSON of the product recommendations.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @returns {object} - The product recommendations.
   * @example
   * const recommendations = await ProductRecommendations.getJson(seedProductId);
   * console.log(recommendations);
   */ getJson: async function(seedProduct) {
        const jsonUrl = `/recommendations/products.json?product_id=${seedProduct}&limit=${this.config.limit || 10}`;
        const jsonResponse = await fetch(jsonUrl).then((response)=>response.json());
        if (jsonResponse.status) {
            console.error(`getJson: ${jsonResponse.description || jsonResponse.message}`);
            return null;
        }
        return jsonResponse;
    },
    /**
   * Returns the product recommendations markup.
   * @param {string|integer} seedProduct - The product ID of the seed product.
   * @param {string} section - The section to render.
   * @returns {string} - The product recommendations markup.
   * @example
   * const markup = await ProductRecommendations.getMarkup(seedProductId, 'related-products');
   * myElement.outerHTML = markup;
   */ getMarkup: async function(seedProduct, section) {
        const markupUrl = `/recommendations/products?product_id=${seedProduct}&section_id=${section}&limit=${this.config.limit || 10}`;
        const markupResponse = await fetch(markupUrl).then((response)=>{
            if (!response.ok) {
                if (response.status == 422) console.error('getMarkup: Invalid parameter error - seedProduct was not provided.');
                if (response.status == 404) console.error('getMarkup: Not found error - either the seed product or the section does not exist.');
                if (response.status != 422 && response.status != 404) console.error(`getMarkup: Unknown error - ${response.status}`);
                return '';
            }
            return response.text();
        }).catch((error)=>console.error(`getMarkup: ${error}`));
        return markupResponse;
    },
    /**
   * Dispatches a custom event to the document.
   * Contains the product recommendations data in the event detail.
   */ dispatchRecommendationEvent: function() {
        const event = new CustomEvent('productRecommendationsReceived', {
            detail: {
                json: this.state.json,
                markup: this.state.markup
            }
        });
        document.dispatchEvent(event);
    }
};
window.ProductRecommendations = ProductRecommendations;
document.dispatchEvent(new CustomEvent('productRecommendationsReady'));

},{}],"jIqS0":[function(require,module,exports,__globalThis) {
/**
 * This file provides utilities for creating a "bundle" of products that can be added to the cart.
 * 
 * Example usage:
 * var myBundle = new Bundle();
 * myBundle.addProduct(handle, variantId);
 * myBundle.addProduct(handle, variantId2, quantity, {"Gift Message": "Happy Birthday!"});
 * myBundle.removeProduct(variantId); 
 * myBundle.addToCart();
 * 
 * var myBundleProducts = myBundle.products;
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _cart = require("./_cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
class Bundle {
    /**
   * Adds a product to the current bundle.
   * @param {String} handle - The handle of the product to add.
   * @param {String} id - The ID of the variant to add.
   * @param {Integer} quantity - The quantity of the item to add. Defaults to 1.
   * @param {Object} properties - Optional properties to add to the cart item.
   * @returns {Bundle} - Returns the current bundle.
   */ async addProduct(handle, id, quantity = 1, properties = {}) {
        const productJson = await fetch(`/products/${handle}.js`).then((response)=>response.json());
        if (productJson.variants) productJson.variants = productJson.variants.filter((variant)=>variant.id.toString() === id.toString());
        const product = {
            data: productJson,
            quantity,
            properties
        };
        this.products.push(product);
        document.dispatchEvent(new CustomEvent('bundleProductsChanged', {
            detail: this.products
        }));
        return this;
    }
    /**
   * Removes all products that match the query (handle or variant ID) from the bundle.
   * Removes all products if no arguments are provided.
   * @param {String} query - The handle or variant ID of the product to remove.
   * @returns {Bundle} - Returns the current bundle.
   */ removeProduct(query) {
        if (query) this.products = this.products.filter((product)=>{
            return product.data.handle !== query && product.data.variants[0].id.toString() !== query.toString();
        });
        else this.products = [];
        document.dispatchEvent(new CustomEvent('bundleProductsChanged', {
            detail: this.products
        }));
        return this;
    }
    /**
   * Sets the quantity of a product in the bundle.
   * @param {String} query - The handle or variant ID of the product to change.
   * @param {Integer} quantity - The new quantity of the product.
   * @returns {Bundle} - Returns the current bundle.
   */ setQuantity(query, quantity) {
        if (!query) return console.error('setQuantity: query (either handle or variant id) is required.');
        if (!quantity) return console.error('setQuantity: quantity is required.');
        this.products = this.products.map((product)=>{
            if (product.data.handle === query || product.data.variants[0].id.toString() === query.toString()) product.quantity = quantity;
            return product;
        });
        document.dispatchEvent(new CustomEvent('bundleProductsChanged', {
            detail: this.products
        }));
        return this;
    }
    /** 
   * Removes a product from the bundle at a specific index.
   * @param {Integer} index - The index of the product to remove.
   * @returns {Bundle} - Returns the current bundle.
   */ removeProductAtIndex(index) {
        if (!index) return console.error('removeProductAtIndex: index is required.');
        this.products.splice(index, 1);
        document.dispatchEvent(new CustomEvent('bundleProductsChanged', {
            detail: this.products
        }));
        return this;
    }
    /**
   * Adds the bundle to the cart.
   * Note: Cart dispatches it's own "itemsAddedToCart" event if successful.
   */ addToCart() {
        const products = this.products.reduce((accumulator, product)=>{
            const existingProduct = accumulator.find((p)=>p.data.handle === product.data.handle);
            if (existingProduct) existingProduct.quantity += product.quantity;
            else accumulator.push(product);
            return accumulator;
        }, []);
        const productsWithIds = products.map((product)=>{
            return {
                id: product.data.variants[0].id,
                quantity: product.quantity,
                properties: product.properties
            };
        });
        (0, _cartDefault.default).addMultipleItems(productsWithIds);
    }
    constructor(){
        this.products = [];
    }
}
window.Bundle = Bundle;
document.dispatchEvent(new CustomEvent('bundlesReady'));

},{"./_cart":"bFxGc","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"7T43G":[function(require,module,exports,__globalThis) {
(()=>{
    const timers = document.querySelectorAll('[data-countdown-timer]');
    timers.forEach((timer)=>{
        const difference = Number(timer.dataset.difference);
        const daysNumber = timer.querySelector('[data-countdown-number][data-type="days"]');
        const hoursNumber = timer.querySelector('[data-countdown-number][data-type="hours"]');
        const minutesNumber = timer.querySelector('[data-countdown-number][data-type="minutes"]');
        const secondsNumber = timer.querySelector('[data-countdown-number][data-type="seconds"]');
        const removeZeroElements = timer.hasAttribute('data-remove-zero-elements');
        if (!(daysNumber && hoursNumber && minutesNumber && secondsNumber && !isNaN(difference) && difference > 0)) return;
        const timerParts = {
            daysNumber,
            hoursNumber,
            minutesNumber,
            secondsNumber
        };
        let secondsLeft = difference;
        updateTimer(timer, timerParts, secondsLeft, removeZeroElements);
        const interval = setInterval(()=>{
            secondsLeft -= 1;
            if (secondsLeft < 0) {
                clearInterval(interval);
                return;
            }
            updateTimer(timer, timerParts, secondsLeft, removeZeroElements);
        }, 1000);
    });
    function updateTimer(timer, timerParts, timeLeft, removeZeroElements) {
        const days = Math.floor(timeLeft / 86400);
        const hours = Math.floor(timeLeft % 86400 / 3600);
        const minutes = Math.floor(timeLeft % 3600 / 60);
        const seconds = timeLeft % 60;
        const formattedDays = formatNumber(days);
        const formattedHours = formatNumber(hours);
        const formattedMinutes = formatNumber(minutes);
        const formattedSeconds = formatNumber(seconds);
        timerParts.daysNumber.innerText = formattedDays;
        timerParts.hoursNumber.innerText = formattedHours;
        timerParts.minutesNumber.innerText = formattedMinutes;
        timerParts.secondsNumber.innerText = formattedSeconds;
        if (removeZeroElements) {
            let elements = 4;
            if (formattedDays == '00') {
                elements = 3;
                if (formattedHours == '00') {
                    elements = 2;
                    if (formattedMinutes == '00') {
                        elements = 1;
                        if (formattedSeconds == '00') elements = 0;
                    }
                }
            }
            const elementHidingClasses = [
                'elements-3',
                'elements-2',
                'elements-1',
                'elements-0'
            ];
            const elementHidingClass = `elements-${elements}`;
            if (elements == 4 || elements < 4 && !timer.classList.contains(elementHidingClass)) elementHidingClasses.forEach((className)=>{
                timer.classList.remove(className);
            });
            if (elements < 4 && !timer.classList.contains(elementHidingClass)) timer.classList.add(elementHidingClass);
        }
    }
    function formatNumber(num) {
        return `${num > 9 ? '' : '0'}${num}`;
    }
})();

},{}],"bBZQF":[function(require,module,exports,__globalThis) {
(()=>{
    var _window_navigator_userAgentData, _window_navigator;
    let os = 'unknown';
    const userAgent = window.navigator.userAgent;
    const platform = ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_userAgentData = _window_navigator.userAgentData) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform;
    const macosPlatforms = [
        'Macintosh',
        'MacIntel',
        'MacPPC',
        'Mac68K',
        'Mac OS X',
        'macOS'
    ];
    const windowsPlatforms = [
        'Win32',
        'Win64',
        'Windows',
        'WinCE'
    ];
    const iosPlatforms = [
        'iPhone',
        'iPad',
        'iPod',
        'iOS'
    ];
    if (macosPlatforms.indexOf(platform) !== -1) os = 'mac';
    else if (iosPlatforms.indexOf(platform) !== -1) os = 'ios';
    else if (windowsPlatforms.indexOf(platform) !== -1) os = 'windows';
    else if (/Android/.test(userAgent)) os = 'android';
    else if (/Linux/.test(platform)) os = 'linux';
    document.body.classList.add(`os-${os}`);
})();

},{}],"lQ6yl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _productCollection = require("./components/ProductCollection");
var _productCollectionDefault = parcelHelpers.interopDefault(_productCollection);
function initProductCollection() {
    const parent = document.querySelector((0, _configDefault.default).queries.productGridParent);
    if (!parent) return;
    (0, _preact.render)(/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productCollectionDefault.default), {}, void 0, false, {
        fileName: "src/js/custom/uwpfilters/index.tsx",
        lineNumber: 11,
        columnNumber: 10
    }, this), parent);
}
document.addEventListener('DOMContentLoaded', initProductCollection);

},{"react/jsx-dev-runtime":"hXvBL","preact":"8i6UJ","./config":"kYp8m","./components/ProductCollection":"6hSdF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hXvBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _compat = require("preact/compat");
var _jsxRuntime = require("preact/jsx-runtime");
parcelHelpers.exportAll(_jsxRuntime, exports);

},{"preact/compat":"3IYZM","preact/jsx-runtime":"5r70q","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"3IYZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>(0, _preact.Component));
parcelHelpers.export(exports, "Fragment", ()=>(0, _preact.Fragment));
parcelHelpers.export(exports, "createContext", ()=>(0, _preact.createContext));
parcelHelpers.export(exports, "createElement", ()=>(0, _preact.createElement));
parcelHelpers.export(exports, "createRef", ()=>(0, _preact.createRef));
parcelHelpers.export(exports, "Children", ()=>O);
parcelHelpers.export(exports, "PureComponent", ()=>N);
parcelHelpers.export(exports, "StrictMode", ()=>Cn);
parcelHelpers.export(exports, "Suspense", ()=>P);
parcelHelpers.export(exports, "SuspenseList", ()=>B);
parcelHelpers.export(exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", ()=>hn);
parcelHelpers.export(exports, "cloneElement", ()=>_n);
parcelHelpers.export(exports, "createFactory", ()=>dn);
parcelHelpers.export(exports, "createPortal", ()=>$);
parcelHelpers.export(exports, "default", ()=>Rn);
parcelHelpers.export(exports, "findDOMNode", ()=>Sn);
parcelHelpers.export(exports, "flushSync", ()=>En);
parcelHelpers.export(exports, "forwardRef", ()=>D);
parcelHelpers.export(exports, "hydrate", ()=>tn);
parcelHelpers.export(exports, "isElement", ()=>xn);
parcelHelpers.export(exports, "isFragment", ()=>pn);
parcelHelpers.export(exports, "isMemo", ()=>yn);
parcelHelpers.export(exports, "isValidElement", ()=>mn);
parcelHelpers.export(exports, "lazy", ()=>z);
parcelHelpers.export(exports, "memo", ()=>M);
parcelHelpers.export(exports, "render", ()=>nn);
parcelHelpers.export(exports, "startTransition", ()=>R);
parcelHelpers.export(exports, "unmountComponentAtNode", ()=>bn);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>gn);
parcelHelpers.export(exports, "useDeferredValue", ()=>w);
parcelHelpers.export(exports, "useInsertionEffect", ()=>I);
parcelHelpers.export(exports, "useSyncExternalStore", ()=>C);
parcelHelpers.export(exports, "useTransition", ()=>k);
parcelHelpers.export(exports, "version", ()=>vn);
var _preact = require("preact");
var _hooks = require("preact/hooks");
parcelHelpers.exportAll(_hooks, exports);
function g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function C(n, t) {
    var e = t(), r = (0, _hooks.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, _hooks.useLayoutEffect)(function() {
        u.__ = e, u.u = t, x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, _hooks.useEffect)(function() {
        return x(u) && o({
            t: u
        }), n(function() {
            x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function R(n) {
    n();
}
function w(n) {
    return n;
}
function k() {
    return [
        !1,
        R
    ];
}
var I = (0, _hooks.useLayoutEffect);
function N(n, t) {
    this.props = n, this.context = t;
}
function M(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, _preact.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u.type = n, u;
}
(N.prototype = new (0, _preact.Component)).isPureReactComponent = !0, N.prototype.shouldComponentUpdate = function(n, t) {
    return E(this.props, n) || E(this.state, t);
};
var T = (0, _preact.options).__b;
(0, _preact.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), T && T(n);
};
var A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function D(n) {
    function t(t) {
        var e = g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var L = function(n, t) {
    return null == n ? null : (0, _preact.toChildArray)((0, _preact.toChildArray)(n).map(t));
}, O = {
    map: L,
    forEach: L,
    count: function(n) {
        return n ? (0, _preact.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, _preact.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, _preact.toChildArray)
}, F = (0, _preact.options).__e;
(0, _preact.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    F(n, t, e, r);
};
var U = (0, _preact.options).unmount;
function V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return V(n, t, e);
    })), n;
}
function W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function P() {
    this.__u = 0, this.o = null, this.__b = null;
}
function j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function z(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, _preact.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function B() {
    this.i = null, this.l = null;
}
(0, _preact.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), U && U(n);
}, (P.prototype = new (0, _preact.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, P.prototype.componentWillUnmount = function() {
    this.o = [];
}, P.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, _preact.createElement)((0, _preact.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, _preact.createElement)((0, _preact.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, _preact.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, _preact.render)((0, _preact.createElement)(Z, {
        context: e.context
    }, n.__v), e.v);
}
function $(n, e) {
    var r = (0, _preact.createElement)(Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
(B.prototype = new (0, _preact.Component)).__a = function(n) {
    var t = this, e = j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, B.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, _preact.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        H(n, e, t);
    });
};
var q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function nn(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, _preact.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function tn(n, t, e) {
    return (0, _preact.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, _preact.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, _preact.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var en = (0, _preact.options).event;
function rn() {}
function un() {
    return this.cancelBubble;
}
function on() {
    return this.defaultPrevented;
}
(0, _preact.options).event = function(n) {
    return en && (n = en(n)), n.persist = rn, n.isPropagationStopped = un, n.isDefaultPrevented = on, n.nativeEvent = n;
};
var ln, cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, fn = (0, _preact.options).vnode;
(0, _preact.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : J.test(i) && (i = c) : c = i = "oninput" : o && G.test(i) ? i = i.replace(K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, _preact.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, _preact.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = q, fn && fn(n);
};
var an = (0, _preact.options).__r;
(0, _preact.options).__r = function(n) {
    an && an(n), ln = n.__c;
};
var sn = (0, _preact.options).diffed;
(0, _preact.options).diffed = function(n) {
    sn && sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), ln = null;
};
var hn = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return ln.__n[n.__c].props.value;
            },
            useCallback: (0, _hooks.useCallback),
            useContext: (0, _hooks.useContext),
            useDebugValue: (0, _hooks.useDebugValue),
            useDeferredValue: w,
            useEffect: (0, _hooks.useEffect),
            useId: (0, _hooks.useId),
            useImperativeHandle: (0, _hooks.useImperativeHandle),
            useInsertionEffect: I,
            useLayoutEffect: (0, _hooks.useLayoutEffect),
            useMemo: (0, _hooks.useMemo),
            useReducer: (0, _hooks.useReducer),
            useRef: (0, _hooks.useRef),
            useState: (0, _hooks.useState),
            useSyncExternalStore: C,
            useTransition: k
        }
    }
}, vn = "18.3.1";
function dn(n) {
    return (0, _preact.createElement).bind(null, n);
}
function mn(n) {
    return !!n && n.$$typeof === q;
}
function pn(n) {
    return mn(n) && n.type === (0, _preact.Fragment);
}
function yn(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function _n(n) {
    return mn(n) ? (0, _preact.cloneElement).apply(null, arguments) : n;
}
function bn(n) {
    return !!n.__k && ((0, _preact.render)(null, n), !0);
}
function Sn(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var gn = function(n, t) {
    return n(t);
}, En = function(n, t) {
    return n(t);
}, Cn = (0, _preact.Fragment), xn = mn, Rn = {
    useState: (0, _hooks.useState),
    useId: (0, _hooks.useId),
    useReducer: (0, _hooks.useReducer),
    useEffect: (0, _hooks.useEffect),
    useLayoutEffect: (0, _hooks.useLayoutEffect),
    useInsertionEffect: I,
    useTransition: k,
    useDeferredValue: w,
    useSyncExternalStore: C,
    startTransition: R,
    useRef: (0, _hooks.useRef),
    useImperativeHandle: (0, _hooks.useImperativeHandle),
    useMemo: (0, _hooks.useMemo),
    useCallback: (0, _hooks.useCallback),
    useContext: (0, _hooks.useContext),
    useDebugValue: (0, _hooks.useDebugValue),
    version: "18.3.1",
    Children: O,
    render: nn,
    hydrate: tn,
    unmountComponentAtNode: bn,
    createPortal: $,
    createElement: (0, _preact.createElement),
    createContext: (0, _preact.createContext),
    createFactory: dn,
    cloneElement: _n,
    createRef: (0, _preact.createRef),
    Fragment: (0, _preact.Fragment),
    isValidElement: mn,
    isElement: xn,
    isFragment: pn,
    isMemo: yn,
    findDOMNode: Sn,
    Component: (0, _preact.Component),
    PureComponent: N,
    memo: M,
    forwardRef: D,
    flushSync: En,
    unstable_batchedUpdates: gn,
    StrictMode: Cn,
    Suspense: P,
    SuspenseList: B,
    lazy: z,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: hn
};

},{"preact":"8i6UJ","preact/hooks":"8rATR","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8i6UJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>x);
parcelHelpers.export(exports, "Fragment", ()=>k);
parcelHelpers.export(exports, "cloneElement", ()=>K);
parcelHelpers.export(exports, "createContext", ()=>Q);
parcelHelpers.export(exports, "createElement", ()=>_);
parcelHelpers.export(exports, "createRef", ()=>b);
parcelHelpers.export(exports, "h", ()=>_);
parcelHelpers.export(exports, "hydrate", ()=>J);
parcelHelpers.export(exports, "isValidElement", ()=>t);
parcelHelpers.export(exports, "options", ()=>l);
parcelHelpers.export(exports, "render", ()=>G);
parcelHelpers.export(exports, "toChildArray", ()=>H);
var n, l, u, t, i, r, o, e, f, c, s, a, h, p = {}, v = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, w = Array.isArray;
function d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function _(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return m(l, e, i, r, null);
}
function m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != l.vnode && l.vnode(e), e;
}
function b() {
    return {
        current: null
    };
}
function k(n) {
    return n.children;
}
function x(n, l) {
    this.props = n, this.context = l;
}
function S(n, l) {
    if (null == l) return n.__ ? S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? S(n) : null;
}
function C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return C(n);
    }
}
function M(n) {
    (!n.__d && (n.__d = !0) && i.push(n) && !$.__r++ || r != l.debounceRendering) && ((r = l.debounceRendering) || o)($);
}
function $() {
    for(var n, u, t, r, o, f, c, s = 1; i.length;)i.length > s && i.sort(e), n = i.shift(), s = i.length, n.__d && (t = void 0, r = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = d({}, r)).__v = r.__v + 1, l.vnode && l.vnode(t), O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, N(f, t, c), r.__e = r.__ = null, t.__e != o && C(t)));
    $.__r = 0;
}
function I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || v, b = l.length;
    for(f = P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? p : m[y.__i] || p, y.__i = a, g = O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? m(null, o, null, null, null) : w(o) ? m(k, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = S(e)), D(e, e));
    return t;
}
function A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function H(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || (w(n) ? n.some(function(n) {
        H(n, l);
    }) : l.push(n)), l;
}
function L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || y.test(l) ? u : u + "px";
}
function j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace(f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = c, n.addEventListener(l, r ? a : s, r)) : n.removeEventListener(l, r ? a : s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = c++;
            else if (u.t < t.u) return;
            return t(l.event ? l.event(u) : u);
        }
    };
}
function O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = l.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new x(b, M), h.constructor = j, h.render = E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = d({}, h.__s)), d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = l.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = d(d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === k && null == a.key && (L = V(a.props.children)), f = I(n, w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)g(o[T]);
                z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || z(u);
        l.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = q(t.__e, u, t, i, r, o, e, c, s);
    return (a = l.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach(z);
}
function N(n, u, t) {
    for(var i = 0; i < t.length; i++)B(t[i], t[++i], t[++i]);
    l.__c && l.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            l.__e(n, u.__v);
        }
    });
}
function V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : w(n) ? n.map(V) : d({}, n);
}
function q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && (l.__m && l.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && n.call(u.childNodes), b = i.props || p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), I("template" == t.type ? u.content : u, w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && S(i, 0), c, s), null != e) for(a = e.length; a--;)g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && j(u, a, m, b[a], o));
    }
    return u;
}
function B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        l.__e(n, t);
    }
}
function D(n, u, t) {
    var i, r;
    if (l.unmount && l.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            l.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && D(i[r], u, t || "function" != typeof n.type);
    t || g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function E(n, l, u) {
    return this.constructor(n, u);
}
function G(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), l.__ && l.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], O(t, u = (!r && i || t).__k = _(k, null, [
        u
    ]), o || p, p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), N(e, u, f);
}
function J(n, l) {
    G(n, l, J);
}
function K(l, u, t) {
    var i, r, o, e, f = d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? n.call(arguments, 2) : t), m(l.type, f, i || l.key, r || l.ref, null);
}
function Q(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
n = v.slice, l = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, u = 0, t = function(n) {
    return null != n && null == n.constructor;
}, x.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = d({}, this.state), "function" == typeof n && (n = n(d({}, u), this.props)), n && d(u, n), null != n && this.__v && (l && this._sb.push(l), M(this));
}, x.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), M(this));
}, x.prototype.render = k, i = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $.__r = 0, f = /(PointerCapture)$|Capture$/i, c = 0, s = F(!1), a = F(!0), h = 0;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8rATR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", ()=>q);
parcelHelpers.export(exports, "useContext", ()=>x);
parcelHelpers.export(exports, "useDebugValue", ()=>P);
parcelHelpers.export(exports, "useEffect", ()=>y);
parcelHelpers.export(exports, "useErrorBoundary", ()=>b);
parcelHelpers.export(exports, "useId", ()=>g);
parcelHelpers.export(exports, "useImperativeHandle", ()=>F);
parcelHelpers.export(exports, "useLayoutEffect", ()=>_);
parcelHelpers.export(exports, "useMemo", ()=>T);
parcelHelpers.export(exports, "useReducer", ()=>h);
parcelHelpers.export(exports, "useRef", ()=>A);
parcelHelpers.export(exports, "useState", ()=>d);
var _preact = require("preact");
var t, r, u, i, o = 0, f = [], c = (0, _preact.options), e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
function p(n, t) {
    c.__h && c.__h(r, n, o || t), o = 0;
    var u = r.__H || (r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function d(n) {
    return o = 1, h(D, n);
}
function h(n, u, i) {
    var o = p(t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = r, !r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        r.__f = !0;
        var c = r.shouldComponentUpdate, e = r.componentWillUpdate;
        r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function y(n, u) {
    var i = p(t++, 3);
    !c.__s && C(i.__H, u) && (i.__ = n, i.u = u, r.__H.__h.push(i));
}
function _(n, u) {
    var i = p(t++, 4);
    !c.__s && C(i.__H, u) && (i.__ = n, i.u = u, r.__h.push(i));
}
function A(n) {
    return o = 5, T(function() {
        return {
            current: n
        };
    }, []);
}
function F(n, t, r) {
    o = 6, _(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function T(n, r) {
    var u = p(t++, 7);
    return C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function q(n, t) {
    return o = 8, T(function() {
        return n;
    }, t);
}
function x(n) {
    var u = r.context[n.__c], i = p(t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub(r)), u.props.value) : n.__;
}
function P(n, t) {
    c.useDebugValue && c.useDebugValue(t ? t(n) : n);
}
function b(n) {
    var u = p(t++, 10), i = d();
    return u.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function g() {
    var n = p(t++, 11);
    if (!n.__) {
        for(var u = r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function j() {
    for(var n; n = f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], c.__e(t, n.__v);
    }
}
c.__b = function(n) {
    r = null, e && e(n);
}, c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), s && s(n, t);
}, c.__r = function(n) {
    a && a(n), t = 0;
    var i = (r = n.__c).__H;
    i && (u === r ? (i.__h = [], r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach(z), i.__h.forEach(B), i.__h = [], t = 0)), u = r;
}, c.diffed = function(n) {
    v && v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== f.push(t) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w)(j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), u = r = null;
}, c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach(z), n.__h = n.__h.filter(function(n) {
                return !n.__ || B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], c.__e(r, n.__v);
        }
    }), l && l(n, t);
}, c.unmount = function(n) {
    m && m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && c.__e(t, r.__v));
};
var k = "function" == typeof requestAnimationFrame;
function w(n) {
    var t, r = function() {
        clearTimeout(u), k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    k && (t = requestAnimationFrame(r));
}
function z(n) {
    var t = r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), r = t;
}
function B(n) {
    var t = r;
    n.__c = n.__(), r = t;
}
function C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

},{"preact":"8i6UJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"5r70q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fragment", ()=>(0, _preact.Fragment));
parcelHelpers.export(exports, "jsx", ()=>u);
parcelHelpers.export(exports, "jsxAttr", ()=>l);
parcelHelpers.export(exports, "jsxDEV", ()=>u);
parcelHelpers.export(exports, "jsxEscape", ()=>s);
parcelHelpers.export(exports, "jsxTemplate", ()=>a);
parcelHelpers.export(exports, "jsxs", ()=>u);
var _preact = require("preact");
var t = /["&<]/;
function n(r) {
    if (0 === r.length || !1 === t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, f = 0, i = Array.isArray;
function u(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, _preact.options).vnode && (0, _preact.options).vnode(l), l;
}
function a(r) {
    var t = u((0, _preact.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var c = {}, p = /[A-Z]/g;
function l(e, t) {
    if ((0, _preact.options).attr) {
        var f = (0, _preact.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : c[u] || (c[u] = u.replace(p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + n("" + t) + '"';
}
function s(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if (i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = s(r[e]);
            return r;
        }
    }
    return n("" + r);
}

},{"preact":"8i6UJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"kYp8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _window_ThemeVars;
exports.default = {
    apiUrl: 'https://storefront.cdconsole.com/api/v2',
    // apiUrl: 'http://localhost:3000/api/v2',
    classes: {
        container: 'collection__results',
        containerFiltersOpen: 'collection__results--filters-open',
        containerMinimumColumns: 'collection__results--min',
        filterForm: 'filters__form',
        filterFormApplyButton: 'filters__form__apply-button',
        filterFormClearButton: 'filters__form__clear-button',
        filterFormExpanded: 'filters__form--open',
        filterFormFieldset: 'filters__form__toggle-list',
        filterFormHeader: 'filters__form__header',
        filterFormInputLabel: 'filters__form__toggle',
        filterFormMoreButton: 'filters__form__more-button',
        filterFormTitle: 'filters__form__title',
        filterFormWrapper: 'filters__form-wrapper',
        gridViewToggle: 'collection__results__header__toggle',
        productGrid: 'products-grid',
        productGridContainer: 'products-grid__container',
        productGridHeader: 'collection__results__header',
        backToTopButton: 'products-grid__back-to-top'
    },
    currencySymbol: window.ThemeVars.currency.symbol,
    exchangeRate: +window.Shopify.currency.rate,
    matchType: 'all',
    namedTags: {
        style: 'Style',
        sleevelength: 'Sleeve Length',
        birth: 'Birth Month'
    },
    numPriceFilters: 5,
    priceFilterRound: 10,
    queries: {
        productGridParent: '#uwpfilters'
    },
    sortOptions: {
        '': 'Relevance',
        'price:asc': 'Price (low-to-high)',
        'price:desc': 'Price (high-to-low)',
        'title:asc': 'Name (A-Z)',
        'title:desc': 'Name (Z-A)',
        'published_at:asc': 'Date (old-to-new)',
        'published_at:desc': 'Date (new-to-old)'
    },
    themeVars: (_window_ThemeVars = window.ThemeVars) !== null && _window_ThemeVars !== void 0 ? _window_ThemeVars : {},
    collectionSettings: {
        '*': {
            hideOptions: [
                'Title'
            ]
        },
        'handbags': {
            type: false
        },
        "womens-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "curve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-sale": {
            hideOptions: [
                "Style"
            ]
        },
        "new-in-gift-home": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-a-line": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-bodycon": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-shirt": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-skater": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-tunic": {
            hideOptions: [
                "Style"
            ]
        },
        "dresses-wrap": {
            hideOptions: [
                "Style"
            ]
        },
        "mini-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "knee-length-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "midi-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "maxi-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "sleeveless-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "short-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "3-4-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "long-sleeve-dresses": {
            hideOptions: [
                "Style"
            ]
        },
        "as-seen-on-social": {
            hideOptions: [
                "Style"
            ]
        }
    }
} // [TODO] Make this configurable and pull from app/theme settings instead.
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6hSdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProductCollection);
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _useCollectionView = require("../hooks/useCollectionView");
var _useCollectionViewDefault = parcelHelpers.interopDefault(_useCollectionView);
var _useFilterContext = require("../hooks/useFilterContext");
var _useFilterContextDefault = parcelHelpers.interopDefault(_useFilterContext);
var _filterForm = require("./FilterForm");
var _filterFormDefault = parcelHelpers.interopDefault(_filterForm);
var _productGrid = require("./ProductGrid");
var _productGridDefault = parcelHelpers.interopDefault(_productGrid);
var _collectionHeader = require("./CollectionHeader");
var _collectionHeaderDefault = parcelHelpers.interopDefault(_collectionHeader);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
function ProductCollection() {
    const collection = getCollection();
    const search = getSearch();
    const filterContext = (0, _useFilterContextDefault.default)({
        collection,
        search
    });
    const collectionView = (0, _useCollectionViewDefault.default)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        class: (0, _classnamesDefault.default)({
            [(0, _configDefault.default).classes.container]: true,
            [(0, _configDefault.default).classes.containerFiltersOpen]: collectionView.expanded,
            [(0, _configDefault.default).classes.containerMinimumColumns]: collectionView.minColumns
        }),
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _collectionHeaderDefault.default), {
                collectionView: collectionView,
                filterContext: filterContext
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductCollection.tsx",
                lineNumber: 24,
                columnNumber: 7
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _filterFormDefault.default), {
                filterContext: filterContext,
                collectionView: collectionView
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductCollection.tsx",
                lineNumber: 27,
                columnNumber: 7
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productGridDefault.default), {
                filterContext: filterContext,
                collectionView: collectionView
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductCollection.tsx",
                lineNumber: 30,
                columnNumber: 7
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/ProductCollection.tsx",
        lineNumber: 19,
        columnNumber: 5
    }, this);
}
function getCollection() {
    var _window_location_pathname_match;
    const rx = /^\/collections\/(?:.+\/)*(?!all\b)([^\/]+)\/?$/;
    var _window_location_pathname_match_;
    // Matches the final path in a /collections URL except "all", ignoring parents.
    // e.g.
    //  /collections/dresses = 'dresses'
    //  /collections/all/dresses = 'dresses'
    //  /collections/dresses/mini-dresses = 'mini-dresses'
    //  /collections/all = null
    //                             --GAD
    const collection = (_window_location_pathname_match_ = (_window_location_pathname_match = window.location.pathname.match(rx)) === null || _window_location_pathname_match === void 0 ? void 0 : _window_location_pathname_match[1]) !== null && _window_location_pathname_match_ !== void 0 ? _window_location_pathname_match_ : null;
    return collection;
}
function getSearch() {
    const usp = new URLSearchParams(window.location.search);
    // Previously we appended a search param to the /collections/all page to render a search,
    // e.g. /collections/all?search=xyz. We will continue to support this here, in case a
    // user has bookmarked a search page. --GAD
    if (/^\/collections/.test(window.location.pathname)) return usp.get('search');
    if (/^\/search/.test(window.location.pathname)) return usp.get('q');
    return null;
}

},{"react/jsx-dev-runtime":"hXvBL","preact":"8i6UJ","../hooks/useCollectionView":"i0mVl","../hooks/useFilterContext":"lbrbh","./FilterForm":"hoPtr","./ProductGrid":"cd5Pp","./CollectionHeader":"9Vnfh","classnames":"gxX47","../config":"kYp8m","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"i0mVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCollectionView);
var _hooks = require("preact/hooks");
function useCollectionView() {
    const [minColumns, setMinColumns] = (0, _hooks.useState)(false);
    const [expanded, setExpanded] = (0, _hooks.useState)(false);
    const toggleExpanded = (0, _hooks.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    return (0, _hooks.useMemo)(()=>({
            expanded,
            toggleExpanded,
            minColumns,
            setMinColumns
        }), [
        minColumns,
        setMinColumns,
        expanded,
        toggleExpanded
    ]);
}

},{"preact/hooks":"8rATR","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"lbrbh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFilterContext);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _hooks = require("preact/hooks");
var _fetch = require("../fetch");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
const defaultSettings = {
    type: true
};
function useFilterContext({ collection, search }) {
    const [availableFilters, setAvailableFilters] = (0, _hooks.useState)(null);
    const [filterValues, setFilterValues] = (0, _hooks.useState)({});
    const [results, setResults] = (0, _hooks.useState)(null);
    const [statePage, setPage] = (0, _hooks.useState)(1);
    const [count, setCount] = (0, _hooks.useState)(null);
    const [hasNextPage, setHasNextPage] = (0, _hooks.useState)(true);
    const [cursor, setCursor] = (0, _hooks.useState)(null);
    var _config_collectionSettings_collection;
    // console.log('Filter Values', filterValues)
    // console.log('PAGE', statePage)
    const settings = (_config_collectionSettings_collection = (0, _configDefault.default).collectionSettings[collection]) !== null && _config_collectionSettings_collection !== void 0 ? _config_collectionSettings_collection : defaultSettings;
    var _availableFilters_map;
    const filtersWithValues = (_availableFilters_map = availableFilters === null || availableFilters === void 0 ? void 0 : availableFilters.map((filter)=>{
        var _filterValues_;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, filter), {
            values: (_filterValues_ = filterValues[filter.key + filter.operator]) !== null && _filterValues_ !== void 0 ? _filterValues_ : [],
            setValues: (values)=>setFilterValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, filterValues), {
                    [filter.key + filter.operator]: values
                }))
        });
    })) !== null && _availableFilters_map !== void 0 ? _availableFilters_map : null;
    (0, _hooks.useEffect)(()=>{
        // Reset pagination if the collection, search, filterValues is changed.
        setHasNextPage(true);
        setCursor(null);
        setPage(1);
        const queryString = filtersToQueryString(filtersWithValues, collection, search);
        applyFilters(queryString, true, null);
    }, [
        collection,
        search,
        filterValues
    ]);
    // Refresh when the page number changes
    (0, _hooks.useEffect)(()=>{
        const queryString = filtersToQueryString(filtersWithValues, collection, search);
        applyFilters(queryString, hasNextPage, statePage);
    }, [
        statePage
    ]);
    const applyFilters = async (queryString, hasNextPage, page)=>{
        console.log("HAS NEXT PAGE", hasNextPage);
        // console.log("PAGE FROM APPLY FILTERS FUNC", page)
        try {
            if (!queryString) return;
            if (!hasNextPage) return;
            const { products, meta, pageInfo, count } = await (0, _fetch.filterFetch)(`/products?${queryString !== null && queryString !== void 0 ? queryString : ''}${page ? `&page=${page}` : ''}`);
            setResults((existingResults)=>statePage === 1 || !existingResults ? products : [
                    ...existingResults,
                    ...products
                ]);
            setCount(meta.count);
            const filters = parseFiltersMeta(meta, settings, !!search);
            setAvailableFilters(filters);
            setHasNextPage(pageInfo.hasNextPage);
            setCursor(pageInfo.endCursor);
            setCount(count);
        } catch (err) {
            console.error(err);
        }
    };
    const incrementPage = (0, _hooks.useCallback)(()=>{
        console.log('incrementing page');
        setPage((page)=>page + 1);
    }, []);
    const reset = (0, _hooks.useCallback)(()=>{
        setFilterValues({});
    }, [
        availableFilters
    ]);
    return {
        collection,
        count,
        filters: filtersWithValues,
        incrementPage,
        reset,
        results,
        search
    };
}
function filtersToQueryString(filters, collection, search) {
    const query = new URLSearchParams();
    // Need to build this manually, as W3C and Express disagree on arrays. --GAD
    if (collection) query.append('collection', collection);
    if (search) query.append('search', search);
    filters === null || filters === void 0 ? void 0 : filters.forEach((filter)=>{
        const key = filter.key + filter.operator;
        filter.values.forEach((val)=>isTruthyOrZero(val) && query.append(key, String(val)));
    });
    var _config_matchType;
    query.append('match', (_config_matchType = (0, _configDefault.default).matchType) !== null && _config_matchType !== void 0 ? _config_matchType : 'any');
    return query.toString();
}
function parseFiltersMeta(meta, settings, isSearch) {
    const { options, tags, vendors, types, prices } = meta;
    const isSearchPage = window.location.pathname.includes('search');
    if (isSearchPage) {
        var _config_sortOptions, _config_sortOptions1, _config_sortOptions2;
        ((_config_sortOptions = (0, _configDefault.default).sortOptions) === null || _config_sortOptions === void 0 ? void 0 : _config_sortOptions['title:asc']) && delete (0, _configDefault.default).sortOptions['title:asc'];
        ((_config_sortOptions1 = (0, _configDefault.default).sortOptions) === null || _config_sortOptions1 === void 0 ? void 0 : _config_sortOptions1['title:desc']) && delete (0, _configDefault.default).sortOptions['title:desc'];
        ((_config_sortOptions2 = (0, _configDefault.default).sortOptions) === null || _config_sortOptions2 === void 0 ? void 0 : _config_sortOptions2['published_at:asc']) && delete (0, _configDefault.default).sortOptions['published_at:asc'];
    }
    const sortOptions = {
        category: 'Sort by',
        key: 'sort',
        operator: '',
        type: 'sort',
        options: Object.entries((0, _configDefault.default).sortOptions).map(([value, label])=>({
                label,
                value
            }))
    };
    const vendorFilters = {
        category: 'Brand',
        key: 'vendor',
        operator: '',
        multiple: !isSearch,
        type: 'attribute',
        options: vendors.map((vendor)=>({
                label: vendor,
                value: vendor
            }))
    };
    const typeFilters = {
        category: 'Type',
        key: 'type',
        multiple: !isSearch,
        operator: '',
        type: 'attribute',
        options: settings.type ? types.map((type)=>({
                label: type,
                value: type
            })) : []
    };
    const tagCategories = tags.map((tag)=>{
        const tagCategory = tag.label;
        const tagValue = tag.value; // Assuming the value is stored in the value property
        const tagName = (0, _configDefault.default).namedTags[tagCategory];
        if (!tagName) return null;
        return {
            category: tagName,
            label: tagValue,
            value: tag.label
        };
    }).filter((t)=>!!t).sort(sortLabelsAlphaNum).reduce(splitByCategory, {});
    const tagFilters = Object.entries(tagCategories).map(([category, options])=>({
            category,
            key: 'tag',
            operator: '',
            multiple: !isSearch,
            type: 'tag',
            options,
            values: []
        }));
    const optionCategories = options.filter((option)=>{
        var _settings_hideOptions;
        return option && !(0, _configDefault.default).collectionSettings['*'].hideOptions.includes(option.name) && !((_settings_hideOptions = settings.hideOptions) === null || _settings_hideOptions === void 0 ? void 0 : _settings_hideOptions.includes(option.name));
    }).map((option)=>option.values.map((value)=>({
                category: option.name,
                label: value.label,
                value,
                count: option
            })).sort(sortLabelsAlphaNum)).flat().reduce(splitByCategory, {});
    const optionFilters = Object.entries(optionCategories).map(([category, options])=>({
            category: category,
            key: `option:${category}`,
            operator: '',
            type: 'option',
            multiple: !isSearch,
            options: options,
            values: []
        }));
    const priceFloor = Math.floor(+prices.min);
    const priceCeil = Math.ceil(+prices.max);
    const priceFilters = [
        {
            category: 'Price',
            key: 'price',
            operator: '<',
            type: 'attribute',
            min: priceFloor,
            max: priceCeil,
            options: []
        },
        {
            category: 'Price',
            key: 'price',
            operator: '>',
            type: 'attribute',
            min: priceFloor,
            max: priceCeil,
            options: []
        }
    ];
    const filters = [
        sortOptions,
        ...[
            ...optionFilters,
            ...tagFilters,
            typeFilters,
            vendorFilters,
            ...priceFilters
        ].sort((o1, o2)=>o1.category > o2.category ? 1 : -1)
    ];
    return filters;
}
function sortLabelsAlphaNum(o1, o2) {
    if (isNaN(+(o1.label + o2.label))) return o1.label > o2.label ? 1 : -1;
    return +o1.label > +o2.label ? 1 : -1;
}
function splitByCategory(acc = {}, current) {
    if (!current) return acc;
    const { category } = current, rest = (0, _objectWithoutProperties._)(current, [
        "category"
    ]);
    var _acc_category;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
        [category]: [
            ...(_acc_category = acc[category]) !== null && _acc_category !== void 0 ? _acc_category : [],
            rest
        ]
    });
}
function isTruthyOrZero(value) {
    return value === 0 || !!value;
}

},{"@swc/helpers/_/_object_spread":"7R2pM","@swc/helpers/_/_object_spread_props":"abDP4","@swc/helpers/_/_object_without_properties":"dwmMx","preact/hooks":"8rATR","../fetch":"2NkFc","../config":"kYp8m","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"abDP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"dwmMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties);
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"dwD8h","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"dwD8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties_loose);
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"2NkFc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterFetch", ()=>filterFetch);
parcelHelpers.export(exports, "cancelPendingFetch", ()=>cancelPendingFetch);
var _shopify = require("./shopify");
let searchController = new AbortController();
let fetchPromise = null; // Promise to store the result
async function filterFetch(url, params = {}) {
    // [NOTE] Don't refactor searchController to be set here - this will prevent us from
    // cancelling simultaneous requests.
    // check + return for existing fetch if already running
    if (fetchPromise) return fetchPromise;
    // create new fetch promise
    fetchPromise = (async ()=>{
        try {
            const responseFromShopify = await (0, _shopify.getAllProductsFromShopify)(url, params);
            return responseFromShopify;
        } finally{
            fetchPromise = null; // clear promise after completion
        }
    })();
    return fetchPromise;
}
function cancelPendingFetch() {
    searchController === null || searchController === void 0 ? void 0 : searchController.abort();
    searchController = new AbortController();
}
async function parseError(res) {
    var _res_headers_get;
    if ((_res_headers_get = res.headers.get('content-type')) === null || _res_headers_get === void 0 ? void 0 : _res_headers_get.startsWith('application/json')) {
        const json = await res.json();
        var _json_error;
        return (_json_error = json.error) !== null && _json_error !== void 0 ? _json_error : json;
    }
    return await res.text();
}

},{"./shopify":"5Z1QI","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"5Z1QI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorefrontApiUrl", ()=>getStorefrontApiUrl);
parcelHelpers.export(exports, "getPublicTokenHeaders", ()=>getPublicTokenHeaders);
parcelHelpers.export(exports, "getAllProductsFromShopify", ()=>getAllProductsFromShopify);
parcelHelpers.export(exports, "convertShopifyProductToApiProduct", ()=>convertShopifyProductToApiProduct);
parcelHelpers.export(exports, "convertSectionProductToApiProduct", ()=>convertSectionProductToApiProduct);
parcelHelpers.export(exports, "convertShopifyFiltersToApiFilters", ()=>convertShopifyFiltersToApiFilters);
parcelHelpers.export(exports, "convertSectionFiltersToApiFilters", ()=>convertSectionFiltersToApiFilters);
var _hydrogenReact = require("@shopify/hydrogen-react");
const storefrontParams = {
    storefrontAccessToken: 'f8a75d98d3f83b7e1faa22dcd0e7e60b',
    domain: 'carraigdonn.myshopify.com'
};
const shopify = (0, _hydrogenReact.createStorefrontClient)({
    publicStorefrontToken: storefrontParams.storefrontAccessToken,
    storeDomain: storefrontParams.domain,
    storefrontApiVersion: '2023-07',
    contentType: 'graphql'
});
const getStorefrontApiUrl = shopify.getStorefrontApiUrl;
const getPublicTokenHeaders = shopify.getPublicTokenHeaders;
const getSortKey = (sort, isSearch)=>{
    switch(sort){
        case 'published_at:asc':
            return 'CREATED';
        case 'published_at:desc':
            return 'CREATED';
        case 'price:asc':
            return 'PRICE';
        case 'price:desc':
            return 'PRICE';
        case 'title:asc':
            return 'TITLE';
        case 'title:desc':
            return 'TITLE';
        case 'best-selling':
            return 'BEST_SELLING';
        case 'relevance':
            return 'RELEVANCE';
        default:
            return isSearch ? 'RELEVANCE' : 'CREATED';
    }
};
const getSortKeyForQuery = (sort)=>{
    switch(sort){
        case 'published_at:asc':
            return 'created-ascending';
        case 'published_at:desc':
            return 'created-descending';
        case 'price:asc':
            return 'price-ascending';
        case 'price:desc':
            return 'price-descending';
        case 'title:asc':
            return 'title-ascending';
        case 'title:desc':
            return 'title-descending';
        case 'best-selling':
            return 'best-selling';
        case 'relevance':
            return 'relevance';
        default:
            return 'relevance';
    }
};
async function getAllProductsFromShopify(url, params = {}) {
    const queries = new URLSearchParams(url.split('?')[1]);
    // make a filters object with all the queries, if the key already exists, add it to an array
    const filters = {};
    queries.forEach((value, key)=>{
        if (filters[key]) {
            if (Array.isArray(filters[key])) filters[key].push(value);
            else filters[key] = [
                filters[key],
                value
            ];
        } else filters[key] = value;
    });
    // console.log('GETTING ALL PRODUCTS FROM SHOPIFY')
    const { page, search, sort, collection, tag, vendor, type } = filters;
    const priceFilter = {
        max: filters['price<'] || 1000000000,
        min: filters['price>'] || 0
    };
    const options = Object.keys(filters).filter((key)=>key.startsWith('option:')).map((key)=>{
        return {
            name: key.split(':')[1],
            value: filters[key]
        };
    });
    // console.log('OPTIONS', options)
    const tagsFragment = (tags)=>{
        let fragment = ``;
        if (!tags) return "";
        if ((tags === null || tags === void 0 ? void 0 : tags.length) === 0) return "";
        tags.map((tag)=>{
            search ? fragment += `
            tag: "${tag}",
            ` : fragment += `
            {
                tag: "${tag}"
            },
            `;
        });
        return fragment;
    };
    const vendorsFragment = (vendors)=>{
        let fragment = ``;
        if (!vendors) return "";
        if ((vendors === null || vendors === void 0 ? void 0 : vendors.length) === 0) return "";
        vendors.map((vendor)=>{
            search ? fragment += `
                productVendor: "${vendor}",
                ` : fragment += `
                {
                    productVendor: "${vendor}"
                },
                `;
        });
        return fragment;
    };
    const typesFragment = (types)=>{
        let fragment = ``;
        if (!types) return "";
        if ((types === null || types === void 0 ? void 0 : types.length) === 0) return "";
        types.map((type)=>{
            search ? fragment += `
                productType: "${type}",
                ` : fragment += `
                {
                    productType: "${type}"
                },
                `;
        });
        return fragment;
    };
    const optionsFragment = (options)=>{
        let fragment = ``;
        if (!options) return "";
        if ((options === null || options === void 0 ? void 0 : options.length) === 0) return "";
        options.map((option)=>{
            Array.isArray(option.value) ? option.value.map((value)=>{
                search ? fragment += `
                    variantOption: {
                        name: "${option.name}"
                        value: "${value}"
                    },
                    ` : fragment += `
                    {
                        variantOption: {
                            name: "${option.name}"
                            value: "${value}"
                        }
                    },
                    `;
            }) : search ? fragment += `
                variantOption: {
                    name: "${option.name}"
                    value: "${option.value}"
                },
                ` : fragment += `
                {
                    variantOption: {
                        name: "${option.name}"
                        value: "${option.value}"
                    }
                },
                `;
        });
        return fragment;
    };
    const priceFragment = (price)=>{
        let fragment = ``;
        if (!price) return "";
        if ((price === null || price === void 0 ? void 0 : price.min) === 0 && (price === null || price === void 0 ? void 0 : price.max) === 0) return "";
        search ? fragment += `
        price: {
            min: ${price.min},
            max: ${price.max}
        },
        ` : fragment += `
        {
            price: {
                min: ${price.min}
                max: ${price.max}
            }
        },
        `;
        return fragment;
    };
    const sortKey = search ? getSortKey(sort, true) : getSortKey(sort);
    const direction = sort ? sort.split(':')[1] === "desc" : true;
    const optionQuery = (option)=>{
        if (!option) return "";
        let optionQuery = '';
        const valuesLength = option.value.length - 1;
        // console.log('option values', option.value)
        Array.isArray(option.value) ? optionQuery += `filter.v.option.${option.name.toLowerCase()}=${option.value.map((value, index)=>`${value}${index !== valuesLength ? ',' : ''}`)}&` : optionQuery += `filter.v.option.${option.name.toLowerCase()}=${option.value}`;
        return optionQuery;
    };
    const vendorQuery = (vendors)=>{
        // console.log('vendors from func', vendors)
        if (!vendors) return "";
        if (Array.isArray(vendors)) return `filter.p.vendor=${vendors.map((vendor, index)=>`${vendor}`)}`;
        return `filter.p.vendor=${vendors}`;
    };
    const tagsQuery = (tags)=>{
        if (!tags) return "";
        if (Array.isArray(tags)) return `filter.p.tag=${tags.map((tag, index)=>`${tag}`)}&`;
        return `filter.p.tag=${tags}`;
    };
    const typesQuery = (types)=>{
        if (!types) return "";
        if (Array.isArray(types)) return `filter.p.product_type=${types.map((type, index)=>`${type}`)}`;
        return `filter.p.product_type=${types}`;
    };
    const priceQuery = (price)=>{
        if (!price) return "";
        // to two decimal places
        price.min = Math.round(price.min * 100) / 100;
        price.max = Math.round(price.max * 100) / 100;
        return `filter.v.price.lte=${price.max}&filter.v.price.gte=${price.min}`;
    };
    const sortQuery = (sort)=>{
        if (!sort) return "";
        return `sort_by=${getSortKeyForQuery(sort)}`;
    };
    const pageQuery = (page)=>{
        if (!page) return "";
        return `page=${page}`;
    };
    const replaceWhitespaceAndAmpersand = (string)=>{
        return string.replace(/\s/g, '%20').replace(/&/g, '%26');
    };
    const constructProductsUrl = (options, vendors, tags, types, price)=>{
        let productsUrl = '';
        if (options) options.map((option)=>{
            productsUrl += `&${optionQuery(option)}`;
        });
        if (vendors) productsUrl += `&${replaceWhitespaceAndAmpersand(vendorQuery(vendors))}`;
        if (tags) productsUrl += `&${tagsQuery(tags)}`;
        if (types) productsUrl += `&${typesQuery(types)}`;
        if (price) productsUrl += `&${priceQuery(price)}`;
        if (page) productsUrl += `&${pageQuery(page)}`;
        if (sort) productsUrl += `&${sortQuery(sort)}`;
        productsUrl += `&section_id=collections-filters-data-backup`;
        if (search) productsUrl = `search?q=${search}` + productsUrl;
        else {
            // remove any & from the beginning of the string (could be more than one)
            productsUrl = productsUrl.replace(/^&+/, '');
            // add the ? to the url
            productsUrl = `?${productsUrl}`;
        }
        return productsUrl;
    };
    const productsUrl = constructProductsUrl(options, vendor, tag, type, priceFilter);
    try {
        const isSearchPage = window.location.pathname.includes('search');
        const filteredProductsResponse = await fetch(productsUrl);
        const filteredProductsText = await filteredProductsResponse.text();
        const filteredProductsString = filteredProductsText.replace(/(<([^>]+)>)/gi, "").trim();
        const filteredProducts = JSON.parse(filteredProductsString);
        const apiFilters = convertSectionFiltersToApiFilters(filteredProducts.filters);
        let checkedValue = null;
        let allProductsFromSectionApi = {
            products: filteredProducts.products,
            pageInfo: {
                hasNextPage: filteredProducts.pagination.currentPage == filteredProducts.pagination.pages ? false : true,
                hasPreviousPage: false,
                endCursor: null,
                startCursor: null
            },
            count: filteredProducts.productCount,
            meta: apiFilters
        };
        const sortByButtons = document.querySelectorAll('fieldset.filters__form__toggle-list input[type="radio"]');
        const defaultSortOption = document.querySelector('fieldset.filters__form__toggle-list input[value="published_at:desc"]');
        if (sortByButtons.length > 0) sortByButtons.forEach((radioButton)=>{
            if (radioButton.checked) checkedValue = radioButton.value; // Store the checked sort by radio button value
        });
        if (checkedValue === null) {
            if (defaultSortOption) defaultSortOption.checked = true;
            checkedValue = 'published_at:desc';
        }
        // Function to sort products by published_at date in descending order
        const sortProductsByPublishedAt = ()=>{
            allProductsFromSectionApi.products.sort((a, b)=>{
                const dateA = new Date(a.published_at).getTime();
                const dateB = new Date(b.published_at).getTime();
                return dateB - dateA; // Newest to oldest
            });
        };
        if (isSearchPage && checkedValue == 'published_at:desc') sortProductsByPublishedAt();
        return allProductsFromSectionApi;
    } catch (error) {
        console.error('ERROR:', error);
        return null;
    }
}
const convertShopifyProductToApiProduct = (shopifyProduct)=>{
    const apiProduct = {
        compare_at_price: shopifyProduct.compareAtPriceRange.maxVariantPrice.amount,
        handle: shopifyProduct.handle,
        id: shopifyProduct.id.split('/').pop(),
        images: shopifyProduct.images.nodes.map((image)=>{
            return {
                alt: image.altText,
                height: image.height,
                src: image.url,
                width: image.width
            };
        }),
        price: shopifyProduct.priceRange.maxVariantPrice.amount,
        tags: shopifyProduct.tags,
        title: shopifyProduct.title,
        variants: shopifyProduct.variants.nodes.map((variant)=>{
            return {
                id: variant.id.split('/').pop(),
                inventory_quantity: variant.quantityAvailable
            };
        }),
        vendor: shopifyProduct.vendor
    };
    return apiProduct;
};
const convertSectionProductToApiProduct = (sectionProduct)=>{
    const apiProduct = {
        compare_at_price: sectionProduct.compareAtPriceRange.maxVariantPrice.amount,
        handle: sectionProduct.handle,
        id: sectionProduct.id,
        created_at: sectionProduct.createdAt,
        images: sectionProduct.images.nodes.map((image)=>{
            return {
                alt: image.altText,
                height: image.height,
                src: image.url,
                width: image.width
            };
        }),
        price: sectionProduct.priceRange.maxVariantPrice.amount,
        tags: sectionProduct.tags,
        title: sectionProduct.title,
        variants: sectionProduct.variants.nodes.map((variant)=>{
            return {
                id: variant.id.split('/').pop(),
                inventory_quantity: variant.quantityAvailable
            };
        }),
        vendor: sectionProduct.vendor
    };
    return apiProduct;
};
const convertShopifyFiltersToApiFilters = (shopifyFilters)=>{
    // get all the options by splitting the filter id
    const options = shopifyFilters.map((filter)=>filter.id.split('.').includes('option') ? filter : null).filter((filter)=>filter !== null);
    // get all the product types by splitting the filter id
    const types = shopifyFilters.map((filter)=>filter.id.split('.').includes('product_type') ? filter : null).filter((filter)=>filter !== null);
    // get all the vendors by splitting the filter id
    const vendors = shopifyFilters.map((filter)=>filter.id.split('.').includes('vendor') ? filter : null).filter((filter)=>filter !== null);
    // get all the tags by splitting the filter id
    const tags = shopifyFilters.map((filter)=>filter.id.split('.').includes('tag') ? filter : null).filter((filter)=>filter !== null);
    // get the price filter
    const price = shopifyFilters.find((filter)=>filter.id.split('.').includes('price'));
    // create the api filters object
    const apiFilters = {
        options: [],
        types: [],
        vendors: [],
        tags: [],
        prices: {
            min: 0,
            max: 0
        }
    };
    // add the options to the api filters
    if (options.length > 0) // console.log('options', options)
    apiFilters.options = options.map((option)=>{
        return {
            name: option.label,
            values: option.values.map((value)=>value.label)
        };
    });
    // add the types to the api filters
    if (types.length > 0) apiFilters.types = types[0].values.map((type)=>type.label);
    // add the vendors to the api filters
    if (vendors.length > 0) apiFilters.vendors = vendors[0].values.map((vendor)=>vendor.label);
    // add the tags to the api filters
    if (tags.length > 0) // console.log('tags', tags)
    apiFilters.tags = tags[0].values.map((tag)=>tag.label);
    // add the price to the api filters
    if (price) apiFilters.prices = JSON.parse(price.values[0].input).price;
    return apiFilters;
};
const convertSectionFiltersToApiFilters = (sectionFilters)=>{
    // console.log('SECTION FILTERS', sectionFilters)
    // get all the options by splitting the filter id
    const options = sectionFilters.map((filter)=>filter.param_name.split('.').includes('option') ? filter : null).filter((filter)=>filter !== null);
    // get all the product types by splitting the filter id
    const types = sectionFilters.map((filter)=>filter.param_name.split('.').includes('product_type') ? filter : null).filter((filter)=>filter !== null);
    // get all the vendors by splitting the filter id
    const vendors = sectionFilters.map((filter)=>filter.param_name.split('.').includes('vendor') ? filter : null).filter((filter)=>filter !== null);
    // get all the tags by splitting the filter id
    const tags = sectionFilters.map((filter)=>filter.param_name.split('.').includes('tag') ? filter : null).filter((filter)=>filter !== null);
    // get the price filter
    const price = sectionFilters.find((filter)=>filter.param_name.split('.').includes('price'));
    // console.log('section filters')
    // console.log('options', options)
    // console.log('types', types)
    // console.log('vendors', vendors)
    // console.log('tags', tags)
    // console.log('PRICE FROM CONVERt FUNCtiON', price)
    // create the api filters object
    const apiFilters = {
        options: [],
        types: [],
        vendors: [],
        tags: [],
        prices: {
            min: 0,
            max: 0
        }
    };
    // add the options to the api filters
    if (options.length > 0) apiFilters.options = options.map((option)=>{
        return {
            name: option.label,
            values: option.values.map((value)=>({
                    label: value.label,
                    count: value.count
                }))
        };
    });
    // add the types to the api filters
    if (types.length > 0) apiFilters.types = types[0].values.map((type)=>({
            label: type.label,
            count: type.count
        }));
    // add the vendors to the api filters
    if (vendors.length > 0) apiFilters.vendors = vendors[0].values.map((vendor)=>({
            label: vendor.label,
            count: vendor.count
        }));
    // add the tags to the api filters
    if (tags.length > 0) apiFilters.tags = tags[0].values.map((tag)=>({
            label: tag.label,
            count: tag.count
        }));
    // add the price to the api filters
    if (price) apiFilters.prices = {
        min: price.min_value,
        max: price.range_max / 100
    };
    return apiFilters;
};

},{"@shopify/hydrogen-react":"4Qor4","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"4Qor4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddToCartButton", ()=>(0, _addToCartButtonMjs.AddToCartButton));
parcelHelpers.export(exports, "AnalyticsEventName", ()=>(0, _analyticsConstantsMjs.AnalyticsEventName));
parcelHelpers.export(exports, "AnalyticsPageType", ()=>(0, _analyticsConstantsMjs.AnalyticsPageType));
parcelHelpers.export(exports, "BuyNowButton", ()=>(0, _buyNowButtonMjs.BuyNowButton));
parcelHelpers.export(exports, "CartCheckoutButton", ()=>(0, _cartCheckoutButtonMjs.CartCheckoutButton));
parcelHelpers.export(exports, "CartCost", ()=>(0, _cartCostMjs.CartCost));
parcelHelpers.export(exports, "CartLineProvider", ()=>(0, _cartLineProviderMjs.CartLineProvider));
parcelHelpers.export(exports, "CartLineQuantity", ()=>(0, _cartLineQuantityMjs.CartLineQuantity));
parcelHelpers.export(exports, "CartLineQuantityAdjustButton", ()=>(0, _cartLineQuantityAdjustButtonMjs.CartLineQuantityAdjustButton));
parcelHelpers.export(exports, "CartProvider", ()=>(0, _cartProviderMjs.CartProvider));
parcelHelpers.export(exports, "ExternalVideo", ()=>(0, _externalVideoMjs.ExternalVideo));
parcelHelpers.export(exports, "IMAGE_FRAGMENT", ()=>(0, _imageMjs.IMAGE_FRAGMENT));
parcelHelpers.export(exports, "Image", ()=>(0, _imageMjs.Image));
parcelHelpers.export(exports, "MediaFile", ()=>(0, _mediaFileMjs.MediaFile));
parcelHelpers.export(exports, "ModelViewer", ()=>(0, _modelViewerMjs.ModelViewer));
parcelHelpers.export(exports, "Money", ()=>(0, _moneyMjs.Money));
parcelHelpers.export(exports, "ProductPrice", ()=>(0, _productPriceMjs.ProductPrice));
parcelHelpers.export(exports, "ProductProvider", ()=>(0, _productProviderMjs.ProductProvider));
parcelHelpers.export(exports, "RichText", ()=>(0, _richTextMjs.RichText));
parcelHelpers.export(exports, "SHOPIFY_S", ()=>(0, _cartConstantsMjs.SHOPIFY_S));
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_ID_HEADER", ()=>(0, _cartConstantsMjs.SHOPIFY_STOREFRONT_ID_HEADER));
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_S_HEADER", ()=>(0, _cartConstantsMjs.SHOPIFY_STOREFRONT_S_HEADER));
parcelHelpers.export(exports, "SHOPIFY_STOREFRONT_Y_HEADER", ()=>(0, _cartConstantsMjs.SHOPIFY_STOREFRONT_Y_HEADER));
parcelHelpers.export(exports, "SHOPIFY_Y", ()=>(0, _cartConstantsMjs.SHOPIFY_Y));
parcelHelpers.export(exports, "ShopPayButton", ()=>(0, _shopPayButtonMjs.ShopPayButton));
parcelHelpers.export(exports, "ShopifyProvider", ()=>(0, _shopifyProviderMjs.ShopifyProvider));
parcelHelpers.export(exports, "ShopifySalesChannel", ()=>(0, _analyticsConstantsMjs.ShopifySalesChannel));
parcelHelpers.export(exports, "Video", ()=>(0, _videoMjs.Video));
parcelHelpers.export(exports, "createStorefrontClient", ()=>(0, _storefrontClientMjs.createStorefrontClient));
parcelHelpers.export(exports, "customerAccountApiCustomScalars", ()=>(0, _codegenHelpersMjs.customerAccountApiCustomScalars));
parcelHelpers.export(exports, "decodeEncodedVariant", ()=>(0, _optionValueDecoderMjs.decodeEncodedVariant));
parcelHelpers.export(exports, "flattenConnection", ()=>(0, _flattenConnectionMjs.flattenConnection));
parcelHelpers.export(exports, "getAdjacentAndFirstAvailableVariants", ()=>(0, _getProductOptionsMjs.getAdjacentAndFirstAvailableVariants));
parcelHelpers.export(exports, "getClientBrowserParameters", ()=>(0, _analyticsMjs.getClientBrowserParameters));
parcelHelpers.export(exports, "getProductOptions", ()=>(0, _getProductOptionsMjs.getProductOptions));
parcelHelpers.export(exports, "getShopifyCookies", ()=>(0, _cookiesUtilsMjs.getShopifyCookies));
parcelHelpers.export(exports, "isOptionValueCombinationInEncodedVariant", ()=>(0, _optionValueDecoderMjs.isOptionValueCombinationInEncodedVariant));
parcelHelpers.export(exports, "mapSelectedProductOptionToObject", ()=>(0, _getProductOptionsMjs.mapSelectedProductOptionToObject));
parcelHelpers.export(exports, "parseGid", ()=>(0, _analyticsUtilsMjs.parseGid));
parcelHelpers.export(exports, "parseMetafield", ()=>(0, _parseMetafieldMjs.parseMetafield));
parcelHelpers.export(exports, "sendShopifyAnalytics", ()=>(0, _analyticsMjs.sendShopifyAnalytics));
parcelHelpers.export(exports, "storefrontApiCustomScalars", ()=>(0, _codegenHelpersMjs.storefrontApiCustomScalars));
parcelHelpers.export(exports, "useCart", ()=>(0, _cartProviderMjs.useCart));
parcelHelpers.export(exports, "useCartLine", ()=>(0, _cartLineProviderMjs.useCartLine));
parcelHelpers.export(exports, "useLoadScript", ()=>(0, _loadScriptMjs.useLoadScript));
parcelHelpers.export(exports, "useMoney", ()=>(0, _useMoneyMjs.useMoney));
parcelHelpers.export(exports, "useProduct", ()=>(0, _productProviderMjs.useProduct));
parcelHelpers.export(exports, "useSelectedOptionInUrlParam", ()=>(0, _useSelectedOptionInUrlParamMjs.useSelectedOptionInUrlParam));
parcelHelpers.export(exports, "useShop", ()=>(0, _shopifyProviderMjs.useShop));
parcelHelpers.export(exports, "useShopifyCookies", ()=>(0, _useShopifyCookiesMjs.useShopifyCookies));
var _addToCartButtonMjs = require("./AddToCartButton.mjs");
var _analyticsMjs = require("./analytics.mjs");
var _analyticsConstantsMjs = require("./analytics-constants.mjs");
var _analyticsUtilsMjs = require("./analytics-utils.mjs");
var _buyNowButtonMjs = require("./BuyNowButton.mjs");
var _cartConstantsMjs = require("./cart-constants.mjs");
var _cartCheckoutButtonMjs = require("./CartCheckoutButton.mjs");
var _cartCostMjs = require("./CartCost.mjs");
var _cartLineProviderMjs = require("./CartLineProvider.mjs");
var _cartLineQuantityMjs = require("./CartLineQuantity.mjs");
var _cartLineQuantityAdjustButtonMjs = require("./CartLineQuantityAdjustButton.mjs");
var _cartProviderMjs = require("./CartProvider.mjs");
var _codegenHelpersMjs = require("./codegen.helpers.mjs");
var _cookiesUtilsMjs = require("./cookies-utils.mjs");
var _externalVideoMjs = require("./ExternalVideo.mjs");
var _flattenConnectionMjs = require("./flatten-connection.mjs");
var _getProductOptionsMjs = require("./getProductOptions.mjs");
var _imageMjs = require("./Image.mjs");
var _loadScriptMjs = require("./load-script.mjs");
var _mediaFileMjs = require("./MediaFile.mjs");
var _modelViewerMjs = require("./ModelViewer.mjs");
var _moneyMjs = require("./Money.mjs");
var _optionValueDecoderMjs = require("./optionValueDecoder.mjs");
var _parseMetafieldMjs = require("./parse-metafield.mjs");
var _productPriceMjs = require("./ProductPrice.mjs");
var _productProviderMjs = require("./ProductProvider.mjs");
var _richTextMjs = require("./RichText.mjs");
var _shopifyProviderMjs = require("./ShopifyProvider.mjs");
var _shopPayButtonMjs = require("./ShopPayButton.mjs");
var _storefrontClientMjs = require("./storefront-client.mjs");
var _useMoneyMjs = require("./useMoney.mjs");
var _useSelectedOptionInUrlParamMjs = require("./useSelectedOptionInUrlParam.mjs");
var _useShopifyCookiesMjs = require("./useShopifyCookies.mjs");
var _videoMjs = require("./Video.mjs");

},{"./AddToCartButton.mjs":false,"./analytics.mjs":false,"./analytics-constants.mjs":false,"./analytics-utils.mjs":false,"./BuyNowButton.mjs":false,"./cart-constants.mjs":false,"./CartCheckoutButton.mjs":false,"./CartCost.mjs":false,"./CartLineProvider.mjs":false,"./CartLineQuantity.mjs":false,"./CartLineQuantityAdjustButton.mjs":false,"./CartProvider.mjs":false,"./codegen.helpers.mjs":false,"./cookies-utils.mjs":false,"./ExternalVideo.mjs":false,"./flatten-connection.mjs":false,"./getProductOptions.mjs":false,"./Image.mjs":false,"./load-script.mjs":false,"./MediaFile.mjs":false,"./ModelViewer.mjs":false,"./Money.mjs":false,"./optionValueDecoder.mjs":false,"./parse-metafield.mjs":false,"./ProductPrice.mjs":false,"./ProductProvider.mjs":false,"./RichText.mjs":false,"./ShopifyProvider.mjs":false,"./ShopPayButton.mjs":false,"./storefront-client.mjs":"jfG15","./useMoney.mjs":false,"./useSelectedOptionInUrlParam.mjs":false,"./useShopifyCookies.mjs":false,"./Video.mjs":false,"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"jfG15":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStorefrontClient", ()=>createStorefrontClient);
parcelHelpers.export(exports, "getPublicTokenHeadersRaw", ()=>getPublicTokenHeadersRaw);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _storefrontApiConstantsMjs = require("./storefront-api-constants.mjs");
const MOCK_SHOP_DOMAIN = "mock.shop";
const isMockShop = (domain)=>domain.includes(MOCK_SHOP_DOMAIN);
function createStorefrontClient({ storeDomain, privateStorefrontToken, publicStorefrontToken, storefrontApiVersion = (0, _storefrontApiConstantsMjs.SFAPI_VERSION), contentType }) {
    if (!storeDomain) throw new Error(H2_PREFIX_ERROR + `\`storeDomain\` is required when creating a new Storefront client in production.`);
    if (storefrontApiVersion !== (0, _storefrontApiConstantsMjs.SFAPI_VERSION)) warnOnce(`The Storefront API version that you're using is different than the version this build of Hydrogen React is targeting.
You may run into unexpected errors if these versions don't match. Received version: "${storefrontApiVersion}"; expected version "${(0, _storefrontApiConstantsMjs.SFAPI_VERSION)}"`);
    const getShopifyDomain = (overrideProps)=>{
        var _ref;
        const domain = (_ref = overrideProps == null ? void 0 : overrideProps.storeDomain) !== null && _ref !== void 0 ? _ref : storeDomain;
        return domain.includes("://") ? domain : `https://${domain}`;
    };
    return {
        getShopifyDomain,
        getStorefrontApiUrl (overrideProps) {
            const domain = getShopifyDomain(overrideProps);
            const apiUrl = domain + (domain.endsWith("/") ? "api" : "/api");
            if (isMockShop(domain)) return apiUrl;
            var _ref;
            return `${apiUrl}/${(_ref = overrideProps == null ? void 0 : overrideProps.storefrontApiVersion) !== null && _ref !== void 0 ? _ref : storefrontApiVersion}/graphql.json`;
        },
        getPrivateTokenHeaders (overrideProps) {
            if (!privateStorefrontToken && !(overrideProps == null ? void 0 : overrideProps.privateStorefrontToken) && !isMockShop(storeDomain)) throw new Error(H2_PREFIX_ERROR + "You did not pass in a `privateStorefrontToken` while using `createStorefrontClient()` or `getPrivateTokenHeaders()`");
            var _ref;
            const finalContentType = (_ref = overrideProps == null ? void 0 : overrideProps.contentType) !== null && _ref !== void 0 ? _ref : contentType;
            var _ref1, _ref2;
            return (0, _objectSpread._)({
                // default to json
                "content-type": finalContentType === "graphql" ? "application/graphql" : "application/json",
                "X-SDK-Variant": "hydrogen-react",
                "X-SDK-Variant-Source": "react",
                "X-SDK-Version": storefrontApiVersion,
                "Shopify-Storefront-Private-Token": (_ref2 = (_ref1 = overrideProps == null ? void 0 : overrideProps.privateStorefrontToken) !== null && _ref1 !== void 0 ? _ref1 : privateStorefrontToken) !== null && _ref2 !== void 0 ? _ref2 : ""
            }, (overrideProps == null ? void 0 : overrideProps.buyerIp) ? {
                "Shopify-Storefront-Buyer-IP": overrideProps.buyerIp
            } : {});
        },
        getPublicTokenHeaders (overrideProps) {
            if (!publicStorefrontToken && !(overrideProps == null ? void 0 : overrideProps.publicStorefrontToken) && !isMockShop(storeDomain)) throw new Error(H2_PREFIX_ERROR + "You did not pass in a `publicStorefrontToken` while using `createStorefrontClient()` or `getPublicTokenHeaders()`");
            var _ref, _ref1;
            const finalContentType = (_ref1 = (_ref = overrideProps == null ? void 0 : overrideProps.contentType) !== null && _ref !== void 0 ? _ref : contentType) !== null && _ref1 !== void 0 ? _ref1 : "json";
            var _ref2, _ref3;
            return getPublicTokenHeadersRaw(finalContentType, storefrontApiVersion, (_ref3 = (_ref2 = overrideProps == null ? void 0 : overrideProps.publicStorefrontToken) !== null && _ref2 !== void 0 ? _ref2 : publicStorefrontToken) !== null && _ref3 !== void 0 ? _ref3 : "");
        }
    };
}
function getPublicTokenHeadersRaw(contentType, storefrontApiVersion, accessToken) {
    return {
        // default to json
        "content-type": contentType === "graphql" ? "application/graphql" : "application/json",
        "X-SDK-Variant": "hydrogen-react",
        "X-SDK-Variant-Source": "react",
        "X-SDK-Version": storefrontApiVersion,
        "X-Shopify-Storefront-Access-Token": accessToken
    };
}
const warnings = /* @__PURE__ */ new Set();
const H2_PREFIX_ERROR = "[h2:error:createStorefrontClient] ";
const warnOnce = (string, type = "warn")=>{
    if (!warnings.has(string)) {
        console[type](`[h2:${type}:createStorefrontClient] ` + string);
        warnings.add(string);
    }
};

},{"@swc/helpers/_/_object_spread":"7R2pM","./storefront-api-constants.mjs":"9xFsa","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9xFsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SFAPI_VERSION", ()=>SFAPI_VERSION);
const SFAPI_VERSION = "2025-07";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hoPtr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilterForm);
parcelHelpers.export(exports, "sortSizeOptions", ()=>sortSizeOptions);
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _hooks = require("preact/hooks");
const { classes } = (0, _configDefault.default);
function FilterForm({ filterContext, collectionView }) {
    if (!filterContext.filters) return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {}, void 0, false, {
        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
        lineNumber: 18,
        columnNumber: 12
    }, this);
    const handleSubmit = (e)=>{
        e.preventDefault();
    // filterContext.applyFilters()
    };
    const reOrderAndRenderFilters = (filters)=>{
        const order = [
            "Sort by",
            "Type",
            "Colour",
            "Size",
            "Style",
            "Length",
            "Sleeve Length",
            "Brand",
            "Price"
        ];
        const orderedFilters = filters.sort((a, b)=>{
            const aOrder = order.indexOf(a.category);
            const bOrder = order.indexOf(b.category);
            return aOrder - bOrder;
        });
        // take all filters that appear before the Sort by filter and add them to the end
        const sortByFilter = orderedFilters.find((f)=>f.key === 'sort');
        if (sortByFilter) {
            const sortByFilterIndex = orderedFilters.indexOf(sortByFilter);
            const filtersBeforeSortBy = orderedFilters.slice(0, sortByFilterIndex);
            orderedFilters.splice(0, sortByFilterIndex);
            orderedFilters.push(...filtersBeforeSortBy);
        }
        // get brand and add it to the end
        const brandFilter = orderedFilters.find((f)=>f.key === 'vendor');
        if (brandFilter) {
            orderedFilters.splice(orderedFilters.indexOf(brandFilter), 1);
            orderedFilters.push(brandFilter);
        }
        // re-order the options in the sort filter
        const sortFilter = orderedFilters.find((f)=>f.key === 'sort');
        if (sortFilter) {
            const order = [
                'Relevance',
                'Price (low-to-high)',
                'Price (high-to-low)',
                'Date (old-to-new)',
                'Date (new-to-old)',
                'Name (A-Z)',
                'Name (Z-A)'
            ];
            sortFilter.options = sortFilter.options.sort((a, b)=>{
                const aOrder = order.indexOf(a.label);
                const bOrder = order.indexOf(b.label);
                return aOrder - bOrder;
            });
        }
        return orderedFilters.map((filter)=>!!filter.options.length && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(FilterCategory, {
                filter: filter
            }, filter.key + filter.operator, false, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 83,
                columnNumber: 7
            }, this));
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            class: classes.filterFormWrapper,
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("form", {
                class: `${classes.filterForm}${collectionView.expanded ? ' ' + classes.filterFormExpanded : ''}`,
                onReset: filterContext.reset,
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: classes.filterFormHeader,
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                                class: classes.filterFormTitle,
                                children: "Filters / Sort By"
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                                lineNumber: 96,
                                columnNumber: 11
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                                class: "filters__close-button",
                                onClick: collectionView.toggleExpanded,
                                type: "button",
                                children: "Close"
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                                lineNumber: 99,
                                columnNumber: 11
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 95,
                        columnNumber: 9
                    }, this),
                    reOrderAndRenderFilters(filterContext.filters),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(PriceSlider, {
                        minFilter: filterContext.filters.find((f)=>f.key === 'price' && f.operator === '>'),
                        maxFilter: filterContext.filters.find((f)=>f.key === 'price' && f.operator === '<')
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 107,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                        class: classes.filterFormApplyButton,
                        onClick: collectionView.toggleExpanded,
                        type: "submit",
                        children: "Apply"
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 110,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                        class: classes.filterFormClearButton,
                        type: "reset",
                        children: "Clear"
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 116,
                        columnNumber: 9
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 91,
                columnNumber: 7
            }, this)
        }, void 0, false, {
            fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
            lineNumber: 90,
            columnNumber: 5
        }, this)
    }, void 0, false);
}
const sortSizeOptions = (options)=>{
    const sizeOrder = {
        "1YR-2YR": 701,
        "3YR-4YR": 702,
        "5YR-6YR": 703,
        "7YR-8YR": 704,
        "1": 201,
        "2": 202,
        "3": 203,
        "4": 204,
        "5": 205,
        "6": 1,
        "7": 2,
        "8": 3,
        "10": 4,
        "12": 5,
        "14": 6,
        "16": 7,
        "18": 8,
        "20": 9,
        "22": 10,
        "24": 11,
        "26": 12,
        "14/16": 301,
        "16/18": 302,
        "18/20": 303,
        "20/22": 304,
        "22/24": 305,
        "24/26": 306,
        "One": 401,
        "XS": 501,
        "S": 502,
        "M": 503,
        "L": 504,
        "Xl": 505,
        "XL": 506,
        "XXL": 507,
        "XXXL": 508,
        "S/M": 601,
        "M/L": 602,
        "L/XL": 603
    };
    const sortedOptions = options.sort((a, b)=>{
        const aOrder = sizeOrder[a.label] || 0;
        const bOrder = sizeOrder[b.label] || 0;
        return aOrder - bOrder;
    });
    return sortedOptions;
};
function FilterCategory({ filter }) {
    // console.log('****** FilterCategory', filter)
    if (filter.key === "option:Size") // sort filter options by size
    // console.log('SIZE OPTIONS', filter.options)
    filter.options = sortSizeOptions(filter.options);
    const [expanded, setExpanded] = (0, _hooks.useState)(false);
    const visibleOptions = filter.options.slice(0, expanded ? filter.options.length : 10);
    const toggleExpanded = ()=>setExpanded(!expanded);
    const getHandleInputChange = (filter)=>(e)=>{
            const target = e.target;
            // console.warn('[TODO] New logic for setting filter values array')
            if (target.type === 'checkbox') // console.log('checkbox')
            return filter.setValues(toggleArrayItem(filter.values, target.value));
            // console.log('not checkbox')
            filter.setValues([
                target.value
            ]);
        };
    // [TODO] Can we change this in the API? -DAN
    const changeOptionLabel = (optionLabel)=>{
        switch(optionLabel){
            case 'Price (low-to-high)':
                return 'Price: Low - High';
            case 'Price (high-to-low)':
                return 'Price: High - Low';
            case 'Name (A-Z)':
                return 'A - Z';
            case 'Name (Z-A)':
                return 'Z - A';
            case 'Date (old-to-new)':
                return 'Date: Old - New';
            case 'Date (new-to-old)':
                return 'Date: New - Old';
            default:
                return optionLabel;
        }
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("fieldset", {
        class: classes.filterFormFieldset,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("legend", {
                children: filter.key === "option:Sleeve Length" ? "Sleeve Length - Tops" : filter.category
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 231,
                columnNumber: 7
            }, this),
            visibleOptions.map((option)=>/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("label", {
                    class: 'count-' + option.value.count,
                    children: filter.key === "sort" ? /* Special rendering for the "sort" filter */ /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("input", {
                                onChange: getHandleInputChange(filter),
                                name: filter.key,
                                type: filter.multiple ? 'checkbox' : 'radio',
                                value: option.value,
                                checked: filter.values.includes(option.value)
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                                lineNumber: 242,
                                columnNumber: 15
                            }, this),
                            changeOptionLabel(option.label)
                        ]
                    }, void 0, true) : /* Rendering for other filters */ /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("input", {
                                onChange: getHandleInputChange(filter),
                                name: filter.key,
                                type: filter.multiple ? 'checkbox' : 'radio',
                                value: option.value.label,
                                checked: filter.values.includes(option.value.label)
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                                lineNumber: 254,
                                columnNumber: 15
                            }, this),
                            changeOptionLabel(option.value.label),
                            " \xa0(",
                            option.value.count,
                            ")"
                        ]
                    }, void 0, true)
                }, option.value.label, false, {
                    fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                    lineNumber: 235,
                    columnNumber: 9
                }, this)),
            filter.options.length > 10 && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                class: classes.filterFormMoreButton,
                onClick: toggleExpanded,
                type: "button",
                children: expanded ? 'Less' : 'More'
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 267,
                columnNumber: 9
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
        lineNumber: 230,
        columnNumber: 5
    }, this);
}
function PriceSlider({ minFilter, maxFilter }) {
    // const min = minFilter.min!
    // const max = minFilter.max!
    // Keep the initial value to avoid it changing when the product results
    // change, [TODO] do this more elegantly.
    const [min] = (0, _hooks.useState)(minFilter.min);
    const [max] = (0, _hooks.useState)(minFilter.max);
    var _minFilter_values_;
    const minValue = (_minFilter_values_ = minFilter.values[0]) !== null && _minFilter_values_ !== void 0 ? _minFilter_values_ : min;
    var _maxFilter_values_;
    const maxValue = (_maxFilter_values_ = maxFilter.values[0]) !== null && _maxFilter_values_ !== void 0 ? _maxFilter_values_ : max;
    const setMin = (newValue)=>minFilter.setValues([
            Math.min(newValue, maxValue)
        ]);
    const setMax = (newValue)=>maxFilter.setValues([
            Math.max(newValue, minValue)
        ]);
    const [draggingValueMin, _setDraggingValueMin] = (0, _hooks.useState)(minValue);
    const [draggingValueMax, _setDraggingValueMax] = (0, _hooks.useState)(maxValue);
    const setDraggingValueMin = (newValue)=>_setDraggingValueMin(Math.min(newValue, maxValue));
    const setDraggingValueMax = (newValue)=>_setDraggingValueMax(Math.max(newValue, minValue));
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: "price-slider",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(SliderKnob, {
                        min: min,
                        max: max,
                        value: minValue,
                        setValue: setMin,
                        draggingValue: draggingValueMin,
                        setDraggingValue: setDraggingValueMin
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 305,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(SliderKnob, {
                        min: min,
                        max: max,
                        value: maxValue,
                        setValue: setMax,
                        draggingValue: draggingValueMax,
                        setDraggingValue: setDraggingValueMax
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                        lineNumber: 312,
                        columnNumber: 9
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 304,
                columnNumber: 7
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: `\u{20AC}${draggingValueMin.toFixed(2)} to \u{20AC}${draggingValueMax.toFixed(2)}`
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
                lineNumber: 320,
                columnNumber: 7
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
        lineNumber: 303,
        columnNumber: 5
    }, this);
}
function SliderKnob({ min, max, value, setValue, draggingValue, setDraggingValue }) {
    const range = max - min;
    const [isDragging, setIsDragging] = (0, _hooks.useState)(false);
    const handlePointerDown = (e)=>{
        // e.preventDefault()
        setDraggingValue(value);
        setIsDragging(true);
        window.addEventListener('pointerup', ()=>{
            setIsDragging(false);
        // setValue(draggingValue!)
        }, {
            once: true
        });
    };
    const handlePointerUp = ()=>{
        setValue(draggingValue);
        setIsDragging(false);
    };
    (0, _hooks.useEffect)(()=>{
        if (!isDragging) return;
        window.addEventListener('pointermove', handlePointerMove);
        window.addEventListener('pointerup', handlePointerUp);
        return ()=>{
            window.removeEventListener('pointermove', handlePointerMove);
            window.removeEventListener('pointerup', handlePointerUp);
        };
    }, [
        isDragging,
        draggingValue
    ]);
    const handlePointerMove = (e)=>{
        if (!isDragging) return;
        const slider = e.target.parentElement;
        const sliderDimensions = slider.getBoundingClientRect();
        const movementPercent = e.movementX / sliderDimensions.width;
        const movementAmount = movementPercent * range;
        const newValue = draggingValue + movementAmount;
        const newValueWithinRange = Math.min(Math.max(min, newValue), max);
        setDraggingValue(newValueWithinRange);
    };
    const offsetPercent = ((isDragging ? draggingValue : value) - min) / range * 100;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        onPointerDown: handlePointerDown,
        class: "price-slider__thumb",
        tabIndex: -1,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": isDragging ? draggingValue : value,
        style: {
            insetInlineStart: `${offsetPercent}%`
        }
    }, void 0, false, {
        fileName: "src/js/custom/uwpfilters/components/FilterForm.tsx",
        lineNumber: 382,
        columnNumber: 5
    }, this);
}
function toggleArrayItem(array, item) {
    const existingIndex = array.indexOf(item);
    if (existingIndex === -1) return [
        ...array,
        item
    ];
    return [
        ...array.slice(0, existingIndex),
        ...array.slice(existingIndex + 1)
    ];
}
function removeFromArray(array, value) {
    const existingIndex = array.indexOf(value);
    if (existingIndex === -1) return array;
    return [
        ...array.slice(0, existingIndex),
        ...array.slice(existingIndex + 1)
    ];
}

},{"react/jsx-dev-runtime":"hXvBL","../config":"kYp8m","preact":"8i6UJ","preact/hooks":"8rATR","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"cd5Pp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProductGrid);
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _productCard = require("./ProductCard");
var _productCardDefault = parcelHelpers.interopDefault(_productCard);
var _hooks = require("preact/hooks");
const { classes } = (0, _configDefault.default);
function ProductGrid({ filterContext, collectionView }) {
    var _filterContext_results;
    // const [lastProductElement, setLastProductElement] = useState<HTMLElement | null>(null)
    const lastElementRef = (0, _hooks.useRef)(null);
    // useInfiniteScroll(lastElementRef.current, filterContext.incrementPage)
    let lastSeenElementRef;
    const [isScrolled, setIsScrolled] = (0, _hooks.useState)(false);
    (0, _hooks.useEffect)(()=>{
        const scrollHandler = (e)=>{
            let threshold = 5200;
            if (window.innerWidth < 767) threshold = 8000;
            const scrollPosition = window.scrollY;
            const hasScrolledFarEnough = scrollPosition > threshold;
            setIsScrolled(hasScrolledFarEnough);
        };
        document.addEventListener('scroll', scrollHandler);
        return ()=>document.removeEventListener('scroll', scrollHandler);
    }, []);
    const showBackToTop = filterContext.results && isScrolled && filterContext.results.length >= 55;
    const backToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    (0, _hooks.useEffect)(()=>{
        const scrollHandler = (e)=>{
            if (lastElementRef.current == null) return;
            const lastElementPosition = lastElementRef.current.getBoundingClientRect().top;
            const bottomOfViewport = window.innerHeight;
            const hasScrolledFarEnough = lastElementPosition < bottomOfViewport + 500;
            if (hasScrolledFarEnough) {
                console.log('INCREMENTING PAGE');
                document.removeEventListener('scroll', scrollHandler);
                filterContext.incrementPage();
            }
        };
        document.addEventListener('scroll', scrollHandler);
        return ()=>document.removeEventListener('scroll', scrollHandler);
    }, [
        filterContext.results
    ]);
    // watch for changes to lastElementRef - this indicates a "page" load has completed
    (0, _hooks.useEffect)(()=>{
        if (lastElementRef.current !== lastSeenElementRef) {
            lastSeenElementRef = lastElementRef.current;
            document.dispatchEvent(new CustomEvent("infinitescroll:filtercontext:finished"));
        }
    }, [
        filterContext.results
    ]);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        class: classes.productGridContainer,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: classes.productGrid,
                children: (_filterContext_results = filterContext.results) === null || _filterContext_results === void 0 ? void 0 : _filterContext_results.map((product, index)=>/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productCardDefault.default), {
                        product: product,
                        filterContext: filterContext,
                        nodeRef: lastElementRef
                    }, product.handle, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                        lineNumber: 83,
                        columnNumber: 9
                    }, this))
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                lineNumber: 81,
                columnNumber: 7
            }, this),
            showBackToTop && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: "#",
                onClick: backToTop,
                class: classes.backToTopButton,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("svg", {
                        width: "32",
                        height: "32",
                        viewBox: "0 0 32 32",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("rect", {
                                width: "32",
                                height: "32"
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                                lineNumber: 94,
                                columnNumber: 13
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("path", {
                                d: "M7.64645 15.6464C7.45119 15.8417 7.45119 16.1583 7.64645 16.3536L10.8284 19.5355C11.0237 19.7308 11.3403 19.7308 11.5355 19.5355C11.7308 19.3403 11.7308 19.0237 11.5355 18.8284L8.70711 16L11.5355 13.1716C11.7308 12.9763 11.7308 12.6597 11.5355 12.4645C11.3403 12.2692 11.0237 12.2692 10.8284 12.4645L7.64645 15.6464ZM24 15.5L8 15.5L8 16.5L24 16.5L24 15.5Z",
                                fill: "white"
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                                lineNumber: 95,
                                columnNumber: 13
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                        lineNumber: 93,
                        columnNumber: 11
                    }, this),
                    "Back to top"
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
                lineNumber: 92,
                columnNumber: 9
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/ProductGrid.tsx",
        lineNumber: 80,
        columnNumber: 5
    }, this);
}
function useInfiniteScroll(lastElement, callback) {
    // At the moment you can't change the callback once the hook has been called, but it may
    // be useful to implement this in the future. It's not required right now. --GAD
    const onIntersection = (entries)=>{
        if (!entries[0].isIntersecting) return;
        callback();
    };
    const [observer] = (0, _hooks.useState)(new IntersectionObserver(onIntersection, {
        rootMargin: '0px 0px 50% 0px'
    }));
    // This observer will fire when the element is 100px below the bottom of the viewport.
    const [observedElement, setObservedElement] = (0, _hooks.useState)(null);
    (0, _hooks.useEffect)(()=>{
        if (lastElement === observedElement) return;
        if (observedElement) observer.unobserve(observedElement);
        if (!lastElement) return setObservedElement(null);
        observer.observe(lastElement);
        setObservedElement(lastElement);
    }, [
        lastElement,
        observedElement
    ]);
}

},{"react/jsx-dev-runtime":"hXvBL","../config":"kYp8m","preact":"8i6UJ","./ProductCard":"bfT39","preact/hooks":"8rATR","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"bfT39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ProductCard);
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _quickshop = require("../../../framework/_quickshop");
var _hooks = require("preact/hooks");
function ProductCard({ product, filterContext, nodeRef }) {
    var _product_images_, _product_images_1, _product_images_2, _product_images_3;
    // nodeRef is used to attach an IntersectionObserver to allow for infinite scrolling without
    // messy viewport scroll position arithmetic. If this is adapted for future projects that
    // require infinite scrolling, ensure that nodeRef is set as a ref on the outer element of
    // this component. --GAD
    const { collection } = filterContext;
    // [TODO] This is a mess and needs refactoring, as it has been copied almost verbatim from
    // imperative code.
    // console.log('HAS PRODCUT BADGES', product.product_badges)
    const handleQuickshopClick = (handle)=>()=>{
            (0, _quickshop.Quickshop).createQuickshop(handle);
        };
    const [showAllSwatches, setShowAllSwatches] = (0, _hooks.useState)(false);
    // check for an element in the DOM with ID 'InitialProducts' and remove it
    (0, _hooks.useEffect)(()=>{
        const initialProducts = document.getElementById('InitialProducts');
        if (initialProducts) initialProducts.remove();
    }, []);
    var _config_themeVars_site_wide_sale;
    const site_wide_sale = (_config_themeVars_site_wide_sale = (0, _configDefault.default).themeVars.site_wide_sale) !== null && _config_themeVars_site_wide_sale !== void 0 ? _config_themeVars_site_wide_sale : {};
    var _config_themeVars_theme_accent_color;
    const site_wide_accent_color = (_config_themeVars_theme_accent_color = (0, _configDefault.default).themeVars.theme.accent_color) !== null && _config_themeVars_theme_accent_color !== void 0 ? _config_themeVars_theme_accent_color : '';
    // console.log(product)
    let compare_at_price = String(product.compare_at_price);
    let price = String(product.price);
    let saleText = 'SALE';
    let saleBannerColor = '#CE0E2D';
    const notifyMe = product.tags.includes('back-in-stock');
    const outOfStock = product.variants.filter((variant)=>variant.inventory_quantity === 0).length === product.variants.length;
    const showNotifyMe = outOfStock && notifyMe;
    const customLabel = product.customLabel;
    const customLabelColor = product.customLabelColor;
    const customLabelTextColor = product.customLabelTextColor;
    if (site_wide_sale.activated == true) {
        const promoTag = site_wide_sale.promotion_tag;
        const tags = product.tags;
        const discount = (100 - site_wide_sale.promotion_percentage) / 100.0;
        tags.map((tag)=>{
            if (tag === promoTag) {
                compare_at_price = price;
                price = (Number(price) * discount).toFixed(2);
                saleText = site_wide_sale.banner_text;
                saleBannerColor = site_wide_sale.banner_color;
            }
        });
    }
    const onSale = +compare_at_price > +price;
    const labelText = getLabelTagText(product.tags);
    const labelBackgroundColor = getLabelBackgroundColor(product.tags);
    const productURL = collection ? `${collection}/products/${product.handle}` : `/products/${product.handle}`;
    let freeGift = '';
    if (product.tags.includes('free-gift-product')) freeGift = 'free-gift-hide';
    (0, _hooks.useEffect)(()=>{
        try {
            if (window._swat) window._swat.initializeActionButtons(`#productID-${product.id}`);
            else {
                window.SwymCallbacks = window.SwymCallbacks || [];
                window.SwymCallbacks.push(function() {
                    window._swat.initializeActionButtons(`#productID-${product.id}`);
                });
            }
        } catch (error) {
            console.log(error);
        }
    }, []);
    function getSwatches(product) {
        const isMobile = window.innerWidth <= 768;
        const maxSwatches = isMobile ? 3 : 6;
        const swatchesToShow = showAllSwatches ? product.linked_products : product.linked_products.slice(0, maxSwatches);
        const moreSwatches = product.linked_products.length > maxSwatches;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "prod-card__swatches",
            children: [
                product.swatch && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                    href: productURL,
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                        class: "prod-card__swatch selected",
                        src: product.swatch,
                        alt: product.title
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 104,
                        columnNumber: 13
                    }, this)
                }, void 0, false, {
                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                    lineNumber: 103,
                    columnNumber: 11
                }, this),
                swatchesToShow.map((swatch, index)=>/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                        href: swatch.linked_url,
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                            onClick: selectedSwatch(),
                            className: "prod-card__swatch",
                            src: swatch.linked_swatch,
                            alt: product.title
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 109,
                            columnNumber: 13
                        }, this)
                    }, index, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 108,
                        columnNumber: 11
                    }, this)),
                moreSwatches && !showAllSwatches && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                    class: "show-more-swatches",
                    onClick: ()=>setShowAllSwatches(true),
                    children: "+"
                }, void 0, false, {
                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                    lineNumber: 118,
                    columnNumber: 11
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
            lineNumber: 101,
            columnNumber: 7
        }, this);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        class: `prod-card ${freeGift}`,
        ref: nodeRef,
        id: `productID-${product.id}`,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: "prod-card__image-container",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: "prod-card__rollover-images",
                        children: [
                            product.images[1] && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                class: "prod-card__alternate-image",
                                children: [
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                                        href: productURL,
                                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                                            width: "295",
                                            // onError="this.style.visibility='hidden'"
                                            height: "443",
                                            src: `${(_product_images_ = product.images[1]) === null || _product_images_ === void 0 ? void 0 : _product_images_.src}&width=400`,
                                            alt: (_product_images_1 = product.images[1]) === null || _product_images_1 === void 0 ? void 0 : _product_images_1.alt,
                                            class: "prod-card__image"
                                        }, void 0, false, {
                                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                            lineNumber: 133,
                                            columnNumber: 17
                                        }, this)
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 132,
                                        columnNumber: 15
                                    }, this),
                                    window.themeSettings.enable_quickview ? /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                        class: `prod-card__quick-view prod-card__quick-view-${product.handle}`,
                                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                                            class: "prod-card__quick-view__button",
                                            onClick: handleQuickshopClick(product.handle),
                                            children: "+ View"
                                        }, void 0, false, {
                                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                            lineNumber: 143,
                                            columnNumber: 21
                                        }, this)
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 142,
                                        columnNumber: 17
                                    }, this) : null
                                ]
                            }, void 0, true, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 131,
                                columnNumber: 13
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                class: "prod-card__original-image",
                                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                                    href: productURL,
                                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                                        width: "295",
                                        height: "443",
                                        src: `${(_product_images_2 = product.images[0]) === null || _product_images_2 === void 0 ? void 0 : _product_images_2.src}&width=400`,
                                        alt: `${(_product_images_3 = product.images[0]) === null || _product_images_3 === void 0 ? void 0 : _product_images_3.alt}`,
                                        class: "prod-card__image"
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 155,
                                        columnNumber: 15
                                    }, this)
                                }, void 0, false, {
                                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                    lineNumber: 154,
                                    columnNumber: 13
                                }, this)
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 153,
                                columnNumber: 11
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 129,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: "prod-card__badges",
                        children: [
                            isNew(product) && !onSale && !showNotifyMe && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                class: "prod-card__tag",
                                style: `background-color: ${site_wide_accent_color}`,
                                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                    class: "prod-card__tag__text",
                                    children: "New"
                                }, void 0, false, {
                                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                    lineNumber: 168,
                                    columnNumber: 15
                                }, this)
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 167,
                                columnNumber: 13
                            }, this),
                            showNotifyMe && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                class: "prod-card__tag",
                                style: `background-color: ${site_wide_accent_color}`,
                                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                    class: "prod-card__tag__text",
                                    children: "Notify Me"
                                }, void 0, false, {
                                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                    lineNumber: 173,
                                    columnNumber: 15
                                }, this)
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 172,
                                columnNumber: 13
                            }, this),
                            product.product_badges && // map the product  badges
                            product.product_badges.map((badge)=>{
                                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                    class: "prod-card__tag",
                                    style: `background-color: ${badge.colour}`,
                                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                        class: "prod-card__tag__text",
                                        children: badge.text
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 181,
                                        columnNumber: 19
                                    }, this)
                                }, void 0, false, {
                                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                    lineNumber: 180,
                                    columnNumber: 17
                                }, this);
                            })
                        ]
                    }, void 0, true, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 165,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: `prod-card__wishlist-heart prod-card__wishlist-heart-${product.handle}`,
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                            "data-with-epi": "true",
                            class: `swym-button swym-add-to-wishlist-view-product product_${product.id}`,
                            "data-swaction": "addToWishlist",
                            "data-product-id": product.id,
                            "data-variant-id": product.variants[0].id,
                            "data-product-url": `https://www.carraigdonn.com/products/${product.handle}`
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 194,
                            columnNumber: 11
                        }, this)
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 193,
                        columnNumber: 9
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                lineNumber: 128,
                columnNumber: 7
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "prod-card__banner",
                children: customLabel ? /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "prod-card__label-banner custom",
                    style: {
                        backgroundColor: customLabelColor
                    },
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        style: {
                            color: customLabelTextColor
                        },
                        className: "prod-card__banner__text",
                        children: customLabel
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 211,
                        columnNumber: 13
                    }, this)
                }, void 0, false, {
                    fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                    lineNumber: 206,
                    columnNumber: 11
                }, this) : /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                    children: [
                        onSale && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "prod-card__sale-banner",
                            style: {
                                backgroundColor: saleBannerColor
                            },
                            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                className: "prod-card__banner__text",
                                children: saleText
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 225,
                                columnNumber: 17
                            }, this)
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 220,
                            columnNumber: 15
                        }, this),
                        labelText && !onSale && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "prod-card__label-banner",
                            style: {
                                backgroundColor: labelBackgroundColor
                            },
                            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                className: "prod-card__banner__text",
                                children: labelText.toUpperCase()
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 234,
                                columnNumber: 17
                            }, this)
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 229,
                            columnNumber: 15
                        }, this)
                    ]
                }, void 0, true)
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                lineNumber: 204,
                columnNumber: 7
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: "prod-card__info",
                style: {
                    flexDirection: 'column',
                    flexWrap: 'nowrap'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: "prod-card__info__details",
                        style: {
                            flex: 'none'
                        },
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                            href: `${window.location.origin}/products/${product.handle}`,
                            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                                class: "prod-card__title",
                                dangerouslySetInnerHTML: {
                                    __html: product.title
                                }
                            }, void 0, false, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 248,
                                columnNumber: 13
                            }, this)
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 247,
                            columnNumber: 11
                        }, this)
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 246,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: "prod-card__vendor",
                        children: product.vendor
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 251,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                        class: "yotpolink",
                        href: `${productURL}#goToYotpo`,
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            class: "yotpo-widget-instance",
                            "data-yotpo-instance-id": "574878",
                            "data-yotpo-product-id": product.id,
                            "data-yotpo-cart-product-id": product.id,
                            "data-yotpo-section-id": "product-card"
                        }, void 0, false, {
                            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                            lineNumber: 255,
                            columnNumber: 11
                        }, this)
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 254,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        class: "prod-card__info__price",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                class: "prod-card__price__container",
                                children: [
                                    onSale && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                        class: "prod-card__compare-at-price",
                                        children: `${(0, _configDefault.default).currencySymbol}${Number(compare_at_price).toFixed(2)}`
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 260,
                                        columnNumber: 15
                                    }, this),
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                        class: `prod-card__price ${onSale ? 'prod-card__price__sale' : ''}`,
                                        children: `${(0, _configDefault.default).currencySymbol}${Number(price).toFixed(2)}`
                                    }, void 0, false, {
                                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                        lineNumber: 263,
                                        columnNumber: 13
                                    }, this)
                                ]
                            }, void 0, true, {
                                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                                lineNumber: 258,
                                columnNumber: 11
                            }, this),
                            Array.isArray(product.linked_products) && product.linked_products.length > 0 && getSwatches(product)
                        ]
                    }, void 0, true, {
                        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                        lineNumber: 257,
                        columnNumber: 9
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                lineNumber: 242,
                columnNumber: 7
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
        lineNumber: 127,
        columnNumber: 5
    }, this);
}
function isNew(product) {
    let proper_date = '';
    const proper_date_parts = product.published_at.toString().split(' ');
    if (proper_date_parts.length < 1) return 0;
    proper_date = proper_date_parts[0] + 'T' + proper_date_parts[1];
    const createdAtDate = new Date(proper_date);
    const now = new Date();
    const daysSinceCreation = Math.floor((now.valueOf() - createdAtDate.valueOf()) / 86400000);
    return daysSinceCreation <= 14;
}
function getSwatches(product) {
    return product.linked_products.map((swatch)=>/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
            href: swatch.linked_url,
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                onClick: selectedSwatch(),
                class: "prod-card__swatch",
                src: swatch.linked_swatch,
                alt: product.title
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
                lineNumber: 304,
                columnNumber: 7
            }, this)
        }, void 0, false, {
            fileName: "src/js/custom/uwpfilters/components/ProductCard.tsx",
            lineNumber: 303,
            columnNumber: 5
        }, this));
}
function selectedSwatch() {
    return (event)=>{
        const swatches = document.querySelectorAll('.prod-card__swatch');
        swatches.forEach((swatch)=>{
            swatch.classList.remove('selected');
        });
        const target = event.target;
        target.classList.add('selected');
    };
}
function getLabelTagText(tags) {
    // [TODO] Refactor
    let labelTagText = null;
    tags.forEach((tag)=>{
        const splitTag = tag.split('-');
        if (splitTag[0] == 'label' && splitTag.length == 2) labelTagText = tag.split('-')[1];
        else if (splitTag[0] == 'label' && splitTag.length == 3) labelTagText = `${splitTag[1]} ${splitTag[2]}`;
        else if (splitTag[0] == 'label' && splitTag.length == 4) labelTagText = `${splitTag[1]} ${splitTag[2]} ${splitTag[3]}`;
    });
    return labelTagText;
}
function getLabelBackgroundColor(tags) {
    let labelBackgroundColor = null;
    tags.forEach((tag)=>{
        // console.log('tag', tag)
        const splitTag = tag.split('-');
        if (splitTag[0] == 'label' && splitTag[1] == 'background') labelBackgroundColor = splitTag[2];
    });
    return labelBackgroundColor;
}

},{"react/jsx-dev-runtime":"hXvBL","../config":"kYp8m","preact":"8i6UJ","../../../framework/_quickshop":"5g71u","preact/hooks":"8rATR","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9Vnfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CollectionHeader);
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _preact = require("preact");
var _preactDefault = parcelHelpers.interopDefault(_preact);
var _config = require("../config");
var _configDefault = parcelHelpers.interopDefault(_config);
const { classes } = (0, _configDefault.default);
function CollectionHeader({ collectionView, filterContext }) {
    // [TODO] This has become kind of an ugly way of doing this. --GAD
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        class: classes.productGridHeader,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                onClick: collectionView.toggleExpanded,
                class: "filters__button",
                children: "Filters / Sort By"
            }, void 0, false, {
                fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                lineNumber: 20,
                columnNumber: 7
            }, this),
            (filterContext === null || filterContext === void 0 ? void 0 : filterContext.count) !== null && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: "filters__product-count",
                children: [
                    filterContext === null || filterContext === void 0 ? void 0 : filterContext.count,
                    " products"
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                lineNumber: 24,
                columnNumber: 9
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                class: "filters__toggles filters__toggles--show",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        class: "filters__toggles-title",
                        children: "View"
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                        lineNumber: 29,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ViewToggle, {
                        gridView: collectionView,
                        minColumns: true,
                        classSuffix: "small"
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                        lineNumber: 32,
                        columnNumber: 9
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ViewToggle, {
                        gridView: collectionView,
                        minColumns: false,
                        classSuffix: "large"
                    }, void 0, false, {
                        fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                        lineNumber: 33,
                        columnNumber: 9
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
                lineNumber: 28,
                columnNumber: 7
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
        lineNumber: 19,
        columnNumber: 5
    }, this);
}
function ViewToggle({ minColumns, gridView, classSuffix }) {
    const isActive = minColumns === gridView.minColumns;
    const buttonClass = [
        classes.gridViewToggle,
        classes.gridViewToggle + '--' + (isActive ? 'active' : 'inactive'),
        classes.gridViewToggle + '--' + classSuffix
    ].join(' ');
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
        class: buttonClass,
        onClick: ()=>gridView.setMinColumns(minColumns)
    }, void 0, false, {
        fileName: "src/js/custom/uwpfilters/components/CollectionHeader.tsx",
        lineNumber: 58,
        columnNumber: 5
    }, this);
}

},{"react/jsx-dev-runtime":"hXvBL","preact":"8i6UJ","../config":"kYp8m","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"gxX47":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"2URCC":[function(require,module,exports,__globalThis) {
const ThemeVars = window.ThemeVars;
const currencySymbol = window.ThemeVars.currency.symbol;
const queries = {
    productGridParent: '#uwpfilters',
    quickSearchCloseResults: '[data-action=close-quick-search-results]',
    quickSearchContainer: '[data-search-results-grid],#quick-search',
    quickSearchForm: '[data-uwpf=search-form]',
    quickSearchInput: '[data-search-input]',
    quickSearchQuerySlot: '.quick-search__query',
    quickSearchViewMore: '.quick-search__view-more',
    themeFiltersJson: '#filter-data'
};
if (ThemeVars.search.pSearchShowProducts) queries.quickSearchProducts = ".quick-search__search-grid--products";
if (ThemeVars.search.pSearchShowArticles) queries.quickSearchArticles = ".quick-search__search-grid--articles";
if (ThemeVars.search.pSearchShowArticles) queries.quickSearchCollections = ".quick-search__search-grid--collections";
function renderQuickSearchGrid(template, query, results) {
    let { articles, collections, pages, products } = results;
    const quickSearch = template.content.cloneNode(true);
    if (queries.quickSearchProducts) var productSearchGrid = quickSearch.querySelector(queries.quickSearchProducts);
    if (queries.quickSearchArticles) var articleSearchGrid = quickSearch.querySelector(queries.quickSearchArticles);
    if (queries.quickSearchCollections) var collectionSearchGrid = quickSearch.querySelector(queries.quickSearchCollections);
    const querySlot = quickSearch.querySelector(queries.quickSearchQuerySlot);
    const viewMore = quickSearch.querySelector(queries.quickSearchViewMore);
    viewMore.href = `/search?q=${query}`;
    querySlot.textContent = query;
    const existingSearchGrid = document.querySelectorAll(queries.quickSearchContainer);
    if (queries.quickSearchProducts) {
        var productCards = products.map(createProductSuggestionCard);
        productCards.forEach(function(renderCardInParent) {
            return renderCardInParent(productSearchGrid);
        });
    }
    if (queries.quickSearchArticles) {
        var articleCards = articles.map(createArticleSuggestionCard);
        articleCards.forEach(function(renderCardInParent) {
            return renderCardInParent(articleSearchGrid);
        });
    }
    if (queries.quickSearchCollections) {
        var alphabeticalCollections = collections.sort(function(a, b) {
            return a.title.localeCompare(b.title);
        });
        var collectionCards = alphabeticalCollections.map(createCollectionSuggestionCard);
        collectionCards.forEach(function(renderCardInParent) {
            return renderCardInParent(collectionSearchGrid);
        });
    }
    existingSearchGrid === null || existingSearchGrid === void 0 ? void 0 : existingSearchGrid.forEach((el)=>el.remove());
    quickSearch.children[0].dataset.searchResultsGrid = true;
    template.after(quickSearch);
    document.querySelectorAll(queries.quickSearchCloseResults).forEach((closeButton)=>closeButton.addEventListener('click', closeQuickSearchResults));
}
async function handleSearchQueryChanged(query, searchGridTemplate) {
    // if (!query || query == '') { return closeQuickSearchResults(); }
    const results = await getSearchSuggestions(query);
    if (!results) return;
    if (results.redirect) window.location = results.redirect;
    // [TODO] Handle network error
    renderQuickSearchGrid(searchGridTemplate, query, results);
}
function closeQuickSearchResults() {
    const existingSearchGrid = document.querySelectorAll(queries.quickSearchContainer);
    const searchInput = document.querySelectorAll(queries.quickSearchInput);
    const searchForms = document.querySelectorAll(queries.quickSearchForm);
    if (!existingSearchGrid[0]) return;
    searchInput.forEach((el)=>el.value = '');
    existingSearchGrid.forEach((el)=>el.remove());
    searchForms.forEach((el)=>el.blur());
}
async function getSearchSuggestions(searchQuery) {
    /* 
   * This function is a refactored version of _predictive-search.js (without config and rendering)
   * to fulfill last-minute requirements for functionality that isn't yet present in UWPFilters
   * by using the Shopify search API. Once tracking of blog posts and collections is incorporated
   * into UWPFilters, it will be replaced by getResults(). --GAD
   */ if (!searchQuery || typeof searchQuery !== 'string' || searchQuery.length < 3) return null; // Return null for invalid queries
    let searchTypes = [];
    if (ThemeVars.search.pSearchShowProducts) searchTypes.push('product');
    if (ThemeVars.search.pSearchShowCollections) searchTypes.push('collection');
    if (ThemeVars.search.pSearchShowArticles) searchTypes.push('article');
    const searchParamTypes = `&${encodeURIComponent('resources[type]')}=${searchTypes.join()}`;
    const tagNew = 'tag:NEW';
    const combinedSearchQuery = `${searchQuery} ${tagNew}`;
    const encodedQuery = encodeURIComponent(combinedSearchQuery);
    let searchUrl = `/search/suggest.json?q=${encodedQuery}${searchParamTypes}&resources[limit]=10&resources[unavailable_products]=last&resources[fields]=title,tag,product_type,variants.title,vendor,variants.barcode,variants.sku`;
    let searchResponse = await fetch(searchUrl);
    let searchResults = (await searchResponse.json()).resources.results;
    const productsOnlySearch = ThemeVars.search.pSearchShowProducts && !ThemeVars.search.pSearchShowArticles && !ThemeVars.search.pSearchShowCollections;
    let searchResultProductCount = 10 - searchResults.products.length;
    if (productsOnlySearch && searchResultProductCount < 10) {
        // If fewer than 10 results, re-fetch without 'NEW' tag
        const encodedOriginalQuery = encodeURIComponent(searchQuery);
        const reFetchUrl = `/search/suggest.json?q=${encodedOriginalQuery}${searchParamTypes}&resources[limit]=${searchResultProductCount}&resources[unavailable_products]=last&resources[fields]=title,tag,product_type,variants.title,vendor,variants.barcode,variants.sku`;
        searchResponse = await fetch(reFetchUrl);
        const additionalResults = (await searchResponse.json()).resources.results;
        // Combine initial and additional results
        if (searchResults.products) searchResults.products = searchResults.products.concat(additionalResults.products).slice(0, 10);
    }
    return searchResults;
}
function handleSearchFocusIn(e) {
    var _e_currentTarget_querySelector;
    if (e.target.className == 'quick-search__close') return;
    const form = e.currentTarget;
    const query = (_e_currentTarget_querySelector = e.currentTarget.querySelector('.header__search-input')) === null || _e_currentTarget_querySelector === void 0 ? void 0 : _e_currentTarget_querySelector.value;
    const searchGridTemplate = form.querySelector('template');
    if (query) handleSearchQueryChanged(query, searchGridTemplate);
}
function handleSearchInput(e) {
    const input = e.target;
    const searchGridTemplate = input.form.querySelector('template');
    const query = input.value;
    handleSearchQueryChanged(query, searchGridTemplate);
}
function getCompareAtPrice(product) {
    if (product.compare_at_price_min == '0.00' && product.compare_at_price_max == '0.00') return null;
    return Math.max(+product.compare_at_price_min, +product.compare_at_price_max).toFixed(2);
}
function createProductSuggestionCard(product) {
    /*
   * This is temporary - see comment on getSearchSuggestions(). --GAD
   */ let compareAtPrice = getCompareAtPrice(product);
    let price = product.price;
    let onSale = !!compareAtPrice;
    const promoTag = ThemeVars.site_wide_sale.promotion_tag;
    if (ThemeVars.site_wide_sale.activated == true) {
        const tags = product.tags;
        const discount = (100 - ThemeVars.site_wide_sale.promotion_percentage) / 100.0;
        tags.map((tag)=>{
            if (tag === promoTag) {
                compareAtPrice = price;
                price = (Number(price) * discount).toFixed(2);
            }
        });
    }
    const isNew = false;
    const card = document.createElement('div');
    card.classList.add('prod-card');
    card.innerHTML = `
    <div class="prod-card__image-container">
      <div class="prod-card__rollover-images">
        <div class="prod-card__original-image">
          <a href="${window.location.origin}/products/${product.handle}">
            <img width="295" height="443" src="${product.featured_image.url}&width=400" alt="${product.featured_image.alt}" class="prod-card__image" />
          </a>
        </div>
      </div>
      <div class="prod-card__badges">
        ${isNew ? `
        <div class="prod-card__tag">
          <span class="prod-card__tag__text">{{- new_tag_text -}}</span>
        </div>` : ''}
      </div>
      
    </div>
    <div class="prod-card__banner">
      ${ThemeVars.site_wide_sale.activated === true && product.tags.includes(ThemeVars.site_wide_sale.promotion_tag) ? `<div class="prod-card__sale-banner" style="background: ${ThemeVars.site_wide_sale.banner_color}">
        <span class="prod-card__banner__text">${ThemeVars.site_wide_sale.banner_text}</span>
      </div>` : onSale ? `<div class="prod-card__sale-banner" style="background-color: #CE0E2D !important;">
        <span class="prod-card__banner__text">SALE</span>
      </div>` : ''}
    </div>
    <div class="prod-card__info">
      <div class="prod-card__info__details">
        <a href="${window.location.origin}/products/${product.handle}">
          <h3 class="prod-card__title">
            ${product.title}
          </h3>
        </a>
      </div>
      <div class="prod-card__info__price">
        <div class="prod-card__price__container">
          ${compareAtPrice && ThemeVars.site_wide_sale.activated || onSale && parseInt(compareAtPrice) > parseInt(price) ? `
          <div class="prod-card__compare-at-price">
          ${currencySymbol}${compareAtPrice}
          </div>` : ''}
          <div class="prod-card__price ${compareAtPrice && ThemeVars.site_wide_sale.activated || onSale && parseInt(compareAtPrice) > parseInt(price) ? 'prod-card__price__sale' : ''}">
          ${currencySymbol}${price}
          </div>
        </div>
      </div>
      <div class="prod-card__vendor">
        ${product.vendor}
      </div>
    </div>
  `;
    const renderInParent = (parent)=>{
        parent.appendChild(card);
    };
    return renderInParent;
}
function createArticleSuggestionCard(article) {
    // This is temporary - see comment on getSearchSuggestions(). --GAD
    const card = document.createElement('div');
    card.classList.add('prod-card');
    card.innerHTML = `
    <div class="prod-card__image-container">
      <div class="prod-card__slider-${article.handle} prod-card__slider swiper" id="ProductCardSwiper-${article.handle}">
        <div class="swiper-wrapper">
          <div class="swiper-slide prod-card__slider__slide swiper-no-swiping">
            <a href="${article.url}">
              <img width="295" height="443" src="${article.image}" loading="lazy" alt="${article.title}" class="prod-card__image" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="prod-card__info">
      <div class="prod-card__info__details">
        <a href="products/${article.handle}">
          <h3 class="prod-card__title">
            ${article.title}
          </h3>
        </a>
      </div>
    </div>
  `;
    const renderInParent = (parent)=>{
        parent.appendChild(card);
    };
    return renderInParent;
}
function createCollectionSuggestionCard(collection) {
    // This is temporary - see comment on getSearchSuggestions(). --GAD
    const card = document.createElement('div');
    card.classList.add('prod-card');
    card.innerHTML = `
    <div class="prod-card__info">
      <div class="prod-card__info__details">
        <a href="${collection.url}">
          <h3 class="prod-card__title">
            ${collection.title}
          </h3>
        </a>
      </div>
    </div>
  `;
    const renderInParent = (parent)=>{
        parent.appendChild(card);
    };
    return renderInParent;
}
document.addEventListener('DOMContentLoaded', ()=>{
    const searchForms = document.querySelectorAll(queries.quickSearchForm);
    searchForms.forEach((f)=>{
        //f.addEventListener('submit', e => e.preventDefault());
        f.addEventListener('focusin', handleSearchFocusIn);
        f.querySelectorAll(queries.quickSearchInput).forEach((i)=>{
            i.addEventListener('input', handleSearchInput);
        });
    });
});

},{}],"abkBw":[function(require,module,exports,__globalThis) {
const ThemeVars = window.ThemeVars;
const FaqFilters = {
    config: {
        filtersList: 'faq-filters__list',
        faqAccordionSection: 'faq-accordion',
        faqFilterButton: 'faq-filters__button',
        faqPageTitle: 'faq-main__title'
    },
    init: function() {
        const filtersList = document.querySelector(`.${this.config.filtersList}`);
        const faqSections = document.querySelectorAll(`.${this.config.faqAccordionSection}`);
        const filterButtons = document.querySelectorAll(`.${this.config.faqFilterButton}`);
        // If any of the elements above does not exist, throw an error and exit the function
        if (!filtersList) return console.error('FaqFilters: Filters list element not found');
        else if (faqSections.length === 0) return console.error('FaqFilters: FAQ sections elements not found');
        else if (filterButtons.length === 0) return console.error('FaqFilters: Filter buttons elements not found');
        // Toggle FAQ sections
        let activeFilter = filtersList.dataset.activeFilterHandle;
        let urlActiveFilter = this.getActiveFilterFromUrl();
        if (urlActiveFilter) activeFilter = urlActiveFilter;
        this.toggleFaqSections(activeFilter, faqSections);
        this.handleButtons(filterButtons);
    },
    /**
   * Returns the filters from the URL as an object.
   * @returns {Object} The filters from the URL.
   */ getActiveFilterFromUrl: function() {
        const urlParams = new URLSearchParams(window.location.search);
        const activeFilter = urlParams.get('filter');
        return activeFilter;
    },
    /**
   * Toggles visibility of FAQ accordion sections depending on the current active filter
   * @param {String} activeFilter - The current active filter
   * @param {NodeList} sections - A nodelist containing all FAQ accordion sections
   */ toggleFaqSections: function(activeFilter, sections) {
        for(let i = 0; i < sections.length; i++)if (sections[i].dataset.filterHandle != activeFilter) sections[i].classList.add('hide');
        else sections[i].classList.remove('hide');
    },
    /**
   * Adds event listeners to all filter buttons
   * @param {NodeList} buttons  - A nodelist containing all fitler buttons for handling the click event
   */ handleButtons: function(buttons) {
        const faqSections = document.querySelectorAll(`.${this.config.faqAccordionSection}`);
        let urlActiveFilter = this.getActiveFilterFromUrl();
        buttons.forEach((button)=>{
            // If the URL has a filter parameter, toggle active state of the buttons
            if (urlActiveFilter) {
                if (button.dataset.filterHandle === urlActiveFilter) button.classList.add('faq-filters__button--active');
                else button.classList.remove('faq-filters__button--active');
            }
            button.addEventListener('click', (event)=>{
                const clickedButton = event.currentTarget;
                const activeFilter = clickedButton.dataset.filterHandle;
                // Toggle buttons active state
                clickedButton.classList.add('faq-filters__button--active');
                for(let i = 0; i < buttons.length; i++)if (buttons[i] !== clickedButton) buttons[i].classList.remove('faq-filters__button--active');
                // Change title
                const faqTitle = document.querySelector(`.${this.config.faqPageTitle}`);
                if (faqTitle) faqTitle.innerText = clickedButton.innerText.trim();
                else console.error('faqFilters: No page title found');
                // Toggle FAQ sections
                this.toggleFaqSections(activeFilter, faqSections);
                //scroll down
                console.log('scrolling down');
                const faqAccordion = document.querySelector('#FAQAccordion');
                if (!faqAccordion) return;
                const megaMenu = document.querySelector('#shopify-section-mega-menu');
                const scrollDistance = faqAccordion.getBoundingClientRect().top - ((megaMenu === null || megaMenu === void 0 ? void 0 : megaMenu.getBoundingClientRect().bottom) || 0) - 10;
                window.scrollBy({
                    top: scrollDistance,
                    behavior: 'smooth'
                });
            });
        });
    }
};
window.FaqFilters = FaqFilters;
if (ThemeVars && ThemeVars.template.suffix === 'faq') FaqFilters.init();

},{}],"5IgLD":[function(require,module,exports,__globalThis) {
(()=>{
    if (window.storePage !== 'pdp') return;
    const classes = {
        activateZoom: 'product__slideshow__slide',
        closeButton: 'product__slideshow__close',
        imageWrapper: 'product__slideshow__slide',
        placeholder: 'product__slideshow__placeholder',
        slideshow: 'product__slideshow__wrapper',
        slideshowModal: 'product__slideshow__modal-container',
        slideshowModalZoomed: 'product__slideshow__modal-container--zoomed',
        slideshowSwiper: 'product__slideshow',
        slideshowSwiperNext: 'product__slideshow__navigation__button--next',
        slideshowSwiperPrev: 'product__slideshow__navigation__button--prev',
        thumbsSwiper: 'product__thumbnails__slideshow',
        slideshowModalInner: 'product__slideshow__modal'
    };
    function getElement(key, multiple = false) {
        return document[multiple ? 'querySelectorAll' : 'querySelector'](`.${classes[key]}`);
    }
    function applyDimensions(element, { top, left, width, height }) {
        element.style.top = top + 'px';
        element.style.left = left + 'px';
    // element.style.width = width + 'px';
    // element.style.height = height + 'px';
    }
    function handleSwiperReady() {
        const thumbsSwiper = new Swiper(`.${classes.thumbsSwiper}`, {
            spaceBetween: 5,
            slidesPerView: 4,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                    spaceBetween: 10
                }
            }
        });
        const pdpSwiper = new Swiper(`.${classes.slideshowSwiper}`, {
            spaceBetween: 5,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 10
                }
            },
            navigation: {
                nextEl: `.${classes.slideshowSwiperNext}`,
                prevEl: `.${classes.slideshowSwiperPrev}`
            },
            thumbs: {
                swiper: thumbsSwiper
            }
        });
        const slideshow = getElement('slideshow');
        if (!slideshow) return;
        function getModalTargetDimensions() {
            const tmpTarget = document.createElement('div');
            tmpTarget.style.opacity = 0;
            tmpTarget.style.pointerEvents = 'none';
            tmpTarget.classList.add(classes.slideshowModalZoomed);
            document.body.append(tmpTarget);
            const targetDimensions = tmpTarget.getBoundingClientRect();
            tmpTarget.remove();
            return targetDimensions;
        }
        function handleImageMouseLeave(e) {
            e.currentTarget.children[0].style.transform = '';
        }
        function getTargetSlideWidth(slideElement) {
            const parentDimensions = visualViewport;
            const slideDimensions = slideElement.getBoundingClientRect();
            const aspectRatio = slideDimensions.width / slideDimensions.height;
            const targetWidth = aspectRatio * parentDimensions.height;
            return targetWidth;
        }
        let zoomActive = false;
        function handleZoomSlideshow(e) {
            if (zoomActive) return;
            zoomActive = true;
            if (zoomActive) e.stopPropagation();
            document.body.style.overflow = 'hidden';
            const previousSlidesPerView = pdpSwiper.params.slidesPerView;
            pdpSwiper.params.slidesPerView = 1;
            pdpSwiper.update();
            getElement('placeholder', true).forEach((p)=>p.remove());
            const modal = getElement('slideshowModal');
            const originalDimensions = modal.getBoundingClientRect();
            const targetDimensions = getModalTargetDimensions();
            const placeholder = document.createElement('div');
            placeholder.classList.add(classes.placeholder);
            applyDimensions(placeholder, originalDimensions);
            modal.after(placeholder);
            applyDimensions(modal, originalDimensions);
            modal.classList.add(classes.slideshowModalZoomed);
            const closeButton = document.createElement('button');
            closeButton.innerHTML = `
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="17" fill="white" fill-opacity="0.7"/>
        <line x1="0.75" y1="-0.75" x2="22.9448" y2="-0.75" transform="matrix(0.708581 0.705629 -0.708581 0.705629 8.20996 9.09497)" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="0.75" y1="-0.75" x2="22.9448" y2="-0.75" transform="matrix(-0.708581 0.705629 -0.708581 -0.705629 25 8.1853)" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      `;
            closeButton.classList.add(classes.closeButton);
            document.querySelector('.product__slideshow__modal').appendChild(closeButton);
            const activeSlide = pdpSwiper.slides[pdpSwiper.activeIndex];
            const targetWidth = getTargetSlideWidth(activeSlide);
            setTimeout(()=>{
                applyDimensions(modal, targetDimensions);
            // modal.children[0].style.width = targetWidth + 'px';
            });
            const imageWrappers = getElement('imageWrapper', true);
            imageWrappers.forEach((w)=>{
                w.addEventListener('mouseleave', handleImageMouseLeave);
                w.addEventListener('mousemove', handleImageMouseMove);
            });
            function handleImageMouseMove(e) {
                const { clientX, clientY } = e;
                const { x: imageX, y: imageY } = e.currentTarget.getBoundingClientRect();
                const xPos = clientX - imageX;
                const yPos = clientY - imageY;
                const img = e.currentTarget.children[0];
                img.style.transformOrigin = `${xPos}px ${yPos}px`;
                img.style.transform = 'scale(3)';
            }
            function handleClose(e) {
                if (e.target !== e.currentTarget) return;
                e.stopPropagation();
                modal.style = '';
                modal.classList.remove(classes.slideshowModalZoomed);
                pdpSwiper.params.slidesPerView = previousSlidesPerView;
                pdpSwiper.update();
                closeButton.remove();
                imageWrappers.forEach((w)=>{
                    w.removeEventListener('mouseleave', handleImageMouseLeave);
                    w.removeEventListener('mousemove', handleImageMouseMove);
                });
                placeholder.remove();
                document.body.style.overflow = null;
                zoomActive = false;
            }
            modal.addEventListener('click', handleClose);
            closeButton.addEventListener('click', handleClose);
        }
        getElement('activateZoom', true).forEach((el)=>el.addEventListener('click', handleZoomSlideshow));
        const slideShowLoader = document.querySelector('.product__slideshow__loader');
        const slideShowModalContainer = document.querySelector('.product__slideshow__modal-container');
        if (slideShowLoader) slideShowLoader.style.display = 'none';
        if (slideShowModalContainer) slideShowModalContainer.style.display = 'block';
    }
    document.addEventListener('swiperReady', ()=>{
        setTimeout(handleSwiperReady, 100);
    });
})();

},{}],"o81LV":[function(require,module,exports,__globalThis) {
(()=>{
    const searchInputs = document.querySelectorAll('[name="q"]');
    searchInputs.forEach(typeInPlaceholders);
    function typeInPlaceholders(input) {
        if (!input.dataset.placeholderOne) return;
        const typingSpeed = input.dataset.typingSpeed || 100;
        const deletingSpeed = input.dataset.deletingSpeed || 60;
        const delayAfterDeleting = input.dataset.delayAfterDeleting || 500;
        const delayBeforeFirstDelete = input.dataset.delayBeforeFirstDelete || 2000;
        const delayAfterWordTyped = input.dataset.delayAfterWordTyped || 2400;
        const placeholders = [];
        if (input.placeholder) placeholders.push(input.placeholder);
        if (input.dataset.placeholderTwo) placeholders.push(input.dataset.placeholderTwo);
        if (input.dataset.placeholderThree) placeholders.push(input.dataset.placeholderThree);
        const typeInNextPlaceholder = async (placeholder)=>{
            await new Promise((resolve)=>{
                let currentPlaceholder = input.getAttribute('placeholder');
                /*
         * If necessary remove the start of the word to type in if it already exists in the
         * placeholder
         */ let nextPlaceholder = currentPlaceholder.length >= 3 && placeholder.startsWith(currentPlaceholder) ? placeholder.replace(currentPlaceholder, '') : placeholder;
                const typingIntervalId = setInterval(()=>{
                    currentPlaceholder = input.getAttribute('placeholder');
                    input.setAttribute('placeholder', currentPlaceholder + nextPlaceholder.charAt(0));
                    if (nextPlaceholder.length === 1) {
                        resolve();
                        clearInterval(typingIntervalId); // Stop typing
                    } else nextPlaceholder = nextPlaceholder.substring(1);
                }, typingSpeed);
            });
        };
        const deleteCurrentPlaceholder = async (nextPlaceholder)=>{
            await new Promise((resolve)=>{
                let prevPlaceholder = input.getAttribute('placeholder');
                const deletionIntervalId = setInterval(()=>{
                    const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
                    input.setAttribute('placeholder', newPlaceholder);
                    prevPlaceholder = newPlaceholder;
                    if (prevPlaceholder.length === 0 || prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder)) {
                        resolve();
                        clearInterval(deletionIntervalId);
                    }
                }, deletingSpeed);
            });
        };
        let startIndex = 0;
        const showNextPlaceholder = ()=>{
            startIndex = (startIndex + 1) % placeholders.length;
            const nextPlaceholder = placeholders[startIndex];
            deleteCurrentPlaceholder.call(this, nextPlaceholder).then(()=>{
                setTimeout(()=>{
                    typeInNextPlaceholder.call(this, nextPlaceholder).then(()=>{
                        setTimeout(showNextPlaceholder.bind(this), delayAfterWordTyped);
                    });
                }, delayAfterDeleting);
            });
        };
        setTimeout(showNextPlaceholder.bind(this), delayBeforeFirstDelete);
    }
})();

},{}],"4Csm5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const productRedirect = (()=>{
    function init() {
        var ThemeVars = window.ThemeVars;
        if (ThemeVars && ThemeVars.freeGiftProducts) {
            let freeGiftProducts = ThemeVars.freeGiftProducts;
            let productId = document.querySelector('input.product_id').value;
            if (!productId) return;
            if (!Array.isArray(freeGiftProducts)) freeGiftProducts = [
                freeGiftProducts
            ];
            let isFreeGift = freeGiftProducts.some((freeGiftProducts)=>freeGiftProducts.id === parseInt(productId));
            if (isFreeGift) {
                window.location.href = '/';
                return;
            }
        }
    }
    return {
        init: init
    };
})();
exports.default = productRedirect;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"gts0w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const cart = (()=>{
    function init() {
        let cartPage = document.querySelector(".main-cart-template");
        if (cartPage) {
            cartQuantity();
            document.addEventListener('cartDataUpdated', ()=>{
                renderCartPage();
            });
        }
    }
    function cartQuantity() {
        let decrementBtns = document.querySelectorAll('.cart__item__decrement');
        let incrementBtns = document.querySelectorAll('.cart__item__increment');
        let qtyInputs = document.querySelectorAll('.cart__item__quantity');
        if (incrementBtns.length > 0) incrementBtns.forEach((incrementer)=>{
            incrementer.addEventListener('click', (event)=>{
                const quantityInput = event.currentTarget.parentElement.querySelector('.cart__item__quantity');
                if (!quantityInput) return false;
                if (quantityInput.value == quantityInput.max) return console.error("Minicart incrementor: Cannot increment past max quantity.");
                quantityInput.value++;
                const changeBody = {
                    'line': quantityInput.dataset.id.toString(),
                    'quantity': parseInt(quantityInput.value)
                };
                Cart.sendCartChange(changeBody);
            });
        });
        if (qtyInputs.length > 0) qtyInputs.forEach((quantityInput)=>{
            quantityInput.addEventListener('input', (event)=>{
                if (parseInt(event.target.value) && event.target.value != "") {
                    if (parseInt(event.target.value) > parseInt(event.target.max)) event.target.value = event.target.max;
                    const changeBody = {
                        'line': quantityInput.dataset.id.toString(),
                        'quantity': parseInt(quantityInput.value)
                    };
                    Cart.sendCartChange(changeBody);
                }
            });
        });
        if (decrementBtns.length > 0) decrementBtns.forEach((decrementer)=>{
            decrementer.addEventListener('click', (event)=>{
                const quantityInput = event.currentTarget.parentElement.querySelector('.cart__item__quantity');
                if (!quantityInput) return false;
                quantityInput.value--;
                const changeBody = {
                    'line': quantityInput.dataset.id.toString(),
                    'quantity': parseInt(quantityInput.value)
                };
                Cart.sendCartChange(changeBody);
            });
        });
    }
    function renderCartPage() {
        let section_request = '/?section_id=cart';
        fetch(section_request).then((response)=>response.text()).then((text)=>{
            let newElement = document.createElement('div');
            newElement.innerHTML = text;
            let newSummaryContent = newElement.querySelector('.summary-content');
            let summaryContentContainer = document.querySelector('.summary-content');
            if (newSummaryContent && summaryContentContainer) summaryContentContainer.innerHTML = newSummaryContent.innerHTML;
            let newFreeShipping = newElement.querySelector('.main-cart-summary .cart__free-shipping');
            let freeShippingContainer = document.querySelector('.main-cart-summary .cart__free-shipping');
            if (newFreeShipping && freeShippingContainer) freeShippingContainer.innerHTML = newFreeShipping.innerHTML;
            let newCartItemsList = newElement.querySelector('.main-cart-items-list');
            let cartItemsListContainer = document.querySelector('.main-cart-items-list');
            if (newCartItemsList && cartItemsListContainer) {
                cartItemsListContainer.innerHTML = newCartItemsList.innerHTML;
                cartQuantity();
                let newListItems = newCartItemsList.querySelectorAll('.cart__item');
                if (newListItems.length < 1) {
                    let emptyCart = document.querySelector('.main-cart-empty');
                    if (emptyCart) emptyCart.classList.remove('hidden');
                    let form = document.querySelector('#cart-form');
                    if (form) form.classList.add('hidden');
                }
            }
        }).catch((e)=>{
            console.error(e);
        });
    }
    return {
        init: init
    };
})();
exports.default = cart;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"4RK03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const findInStore = (()=>{
    function init() {
        const modal = document.querySelector('.js-find-in-store-modal');
        if (modal) toggleModal();
    }
    function toggleModal() {
        const openModalBtn = document.querySelector('.js-open-find-in-store-modal');
        const closeModalBtns = document.querySelectorAll('.js-find-in-store-close-modal');
        if (openModalBtn) openModalBtn.addEventListener('click', showModal);
        closeModalBtns.forEach((closeModalBtn)=>{
            closeModalBtn.addEventListener('click', hideModal);
        });
    }
    function showModal() {
        const modal = document.querySelector('.js-find-in-store-modal');
        if (modal) {
            const productId = modal.getAttribute("data-product-id");
            if (!productId) return false;
            const variantSelect = document.querySelector(`.ProductForm #variant-selector-${productId}`);
            if (!variantSelect) return false;
            const selectedOption = variantSelect.options[variantSelect.selectedIndex];
            const sku = selectedOption.getAttribute("data-sku");
            renderStoreList(sku);
            modal.classList.add('visible');
            document.querySelector("body").classList.add('find-in-store-modal-open');
        }
    }
    function hideModal() {
        const modal = document.querySelector('.js-find-in-store-modal');
        if (modal) {
            modal.classList.remove('visible');
            document.querySelector("body").classList.remove('find-in-store-modal-open');
        }
    }
    async function getStoresData(sku) {
        const fisError = document.querySelector('.js-find-in-store-error');
        try {
            const response = await fetch('https://carraig-donn.lerp.sf9dev.com/findinstore/branches', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                mode: 'cors',
                body: JSON.stringify({
                    sku
                })
            });
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const data = await response.json();
            if (!data[0].title) {
                if (fisError) fisError.classList.remove("hidden");
            }
            return data;
        } catch (error) {
            console.error('Error fetching store data:', error);
            if (fisError) fisError.classList.remove("hidden");
            return [];
        }
    }
    async function renderStoreList(sku) {
        const storeListContainer = document.querySelector('.find-in-store-list');
        const fisError = document.querySelector('.js-find-in-store-error');
        if (!storeListContainer) return false;
        if (fisError) fisError.classList.add("hidden");
        const stores = await getStoresData(sku);
        stores.sort((a, b)=>a.title.localeCompare(b.title));
        const lowStock = parseInt(storeListContainer.getAttribute("data-low-in-stock"));
        const locatorPage = storeListContainer.getAttribute("data-locator-page");
        const showStock = storeListContainer.getAttribute("data-show-stock");
        storeListContainer.innerHTML = '';
        stores.forEach((store)=>{
            if (!store.title) return false;
            const stockLabelClass = store.qty > lowStock ? 'stock-label-in-store' : store.qty > 0 && store.qty <= lowStock ? 'stock-label-low-in-stock' : 'stock-label-out-of-stock';
            const stockLabelText = store.qty > lowStock ? 'In Stock' : store.qty > 0 && store.qty <= lowStock ? 'Low In Stock' : 'Out Of Stock';
            let stock = "";
            if (showStock == "true") stock = `<p class="find-in-store-list-stock-qty">${store.qty}</p>`;
            const storeItem = `
                <div class="find-in-store-list-item">
                    <a href="${locatorPage}" class="find-in-store-list-store">${store.title}</a>
                    <p class="find-in-store-list-stock-label ${stockLabelClass}">${stockLabelText}</p>
                    ${stock}
                </div>
            `;
            if (storeMetaobjects.deliveryPoints && storeMetaobjects.deliveryPoints.length > 0) {
                for (const deliveryPoint of storeMetaobjects.deliveryPoints)if (deliveryPoint.pointLocationId === store.location) {
                    if (deliveryPoint.active_store === true) storeListContainer.insertAdjacentHTML('beforeend', storeItem);
                    break;
                }
            } else storeListContainer.insertAdjacentHTML('beforeend', storeItem);
        });
        searchStore();
    }
    function searchStore() {
        const searchInput = document.querySelector('.js-find-in-store-search');
        const storeItems = document.querySelectorAll('.find-in-store-list-item');
        if (searchInput) searchInput.addEventListener('input', ()=>{
            const query = searchInput.value.toLowerCase();
            storeItems.forEach((item)=>{
                const storeName = item.querySelector('.find-in-store-list-store').textContent.toLowerCase();
                if (storeName.includes(query)) item.style.display = '';
                else item.style.display = 'none';
            });
        });
    }
    return {
        init: init
    };
})();
exports.default = findInStore;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"2CjGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class GiftCardForm extends HTMLElement {
    connectedCallback() {
        // Get the parent form and disable native validation
        this.productForm = this.closest('form');
        if (this.productForm) {
            var _this_productForm_querySelector;
            this.productForm.setAttribute('novalidate', 'true');
            this.productForm.addEventListener('submit', (event)=>{
                if (!this.validateForm()) event.preventDefault();
            });
            (_this_productForm_querySelector = this.productForm.querySelector('button[type="submit"]')) === null || _this_productForm_querySelector === void 0 ? void 0 : _this_productForm_querySelector.addEventListener('click', (event)=>{
                if (!this.validateForm()) event.preventDefault();
            });
        }
        this.toggleCheckbox = this.querySelector('#toggle-gift-card-form');
        this.container = this.querySelector('#giftCardContainer');
        // Listen for checkbox changes to toggle the gift card form
        this.toggleCheckbox.addEventListener('change', ()=>this.toggleGiftCardForm());
    }
    get isFormVisible() {
        return this._isFormVisible;
    }
    toggleGiftCardForm() {
        const template = document.querySelector('#giftCardTemplate');
        if (this.toggleCheckbox.checked && template) {
            // Clone and append the gift card form fields
            const formClone = template.content.cloneNode(true);
            this.container.appendChild(formClone);
            this._isFormVisible = true;
            // Update references to the newly added elements
            this.scheduleOptions = this.container.querySelector('#scheduleOptions');
            this.radioButtons = this.container.querySelectorAll('input[name="properties[giftee-sendOption]"]');
            this.emailField = this.container.querySelector('input[name="properties[giftee-recipientEmail]"]');
            this.confirmEmailField = this.container.querySelector('input[name="properties[giftee-confirmRecipientEmail]"]');
            this.inputFields = this.container.querySelectorAll('.form__input');
            this.requiredInputFields = this.container.querySelectorAll('.form__input[required]');
            this.dateTimeField = this.container.querySelector('input[name="properties[giftee-sendDateTime]"]');
            // Set min date/time for the datetime-local input
            const now = new Date();
            const minDateTime = now.toISOString().slice(0, 16);
            if (this.dateTimeField) this.dateTimeField.setAttribute('min', minDateTime);
            // Attach listeners for radio buttons to toggle schedule options
            this.radioButtons.forEach((radio)=>{
                radio.addEventListener('change', ()=>this.toggleScheduleOptions());
            });
        } else {
            this.container.innerHTML = ''; // Remove the gift card fields
            this._isFormVisible = false;
        }
    }
    toggleScheduleOptions() {
        const selectedOption = this.container.querySelector('input[name="properties[giftee-sendOption]"]:checked');
        const sendLaterSelected = selectedOption && selectedOption.value === 'later';
        if (this.scheduleOptions) this.scheduleOptions.style.display = sendLaterSelected ? 'block' : 'none';
        if (this.dateTimeField) {
            if (sendLaterSelected) this.dateTimeField.setAttribute('required', 'true');
            else {
                this.dateTimeField.removeAttribute('required');
                this.dateTimeField.value = '';
            }
        }
    }
    validateForm() {
        let isValid = true;
        this.clearErrors();
        // If gift card section is not active, skip validation
        if (!this.toggleCheckbox.checked) return true;
        // Check that all required fields are filled
        this.requiredInputFields.forEach((field)=>{
            if (!field.value.trim()) {
                this.showError(field, 'This field is required');
                isValid = false;
            }
        });
        // Validate recipient email
        if (this.emailField && !this.validateEmail(this.emailField.value)) {
            this.showError(this.emailField, 'Enter a valid email');
            isValid = false;
        }
        // Check that the email and confirmation match
        if (this.emailField && this.confirmEmailField && this.emailField.value !== this.confirmEmailField.value) {
            this.showError(this.confirmEmailField, 'Emails must match');
            isValid = false;
        }
        // If schedule options are visible, validate the date/time field
        if (this.scheduleOptions && this.scheduleOptions.style.display === 'block') {
            const selectedDateTime = this.dateTimeField.value;
            if (!selectedDateTime) {
                this.showError(this.dateTimeField, 'Please select a date and time');
                isValid = false;
            } else {
                const now = new Date();
                const selectedDateTimeObj = new Date(selectedDateTime);
                if (selectedDateTimeObj < now) {
                    this.showError(this.dateTimeField, 'Date and time cannot be in the past');
                    isValid = false;
                }
            }
        }
        return isValid;
    }
    validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    showError(field, message) {
        const fieldContainer = field.parentElement;
        fieldContainer.classList.add('has-error');
        let errorSpan = fieldContainer.querySelector('.error');
        if (!errorSpan) {
            errorSpan = document.createElement('span');
            errorSpan.classList.add('error');
            fieldContainer.appendChild(errorSpan);
        }
        errorSpan.textContent = message;
    }
    clearErrors() {
        this.querySelectorAll('.has-error').forEach((el)=>el.classList.remove('has-error'));
        this.querySelectorAll('.error').forEach((span)=>span.textContent = '');
    }
    reset() {
        if (this.container) {
            this.container.querySelectorAll('.form__input').forEach((field)=>field.value = '');
            const sendNowRadio = this.container.querySelector('input[name="properties[giftee-sendOption]"][value="now"]');
            if (sendNowRadio) sendNowRadio.checked = true;
            this.toggleScheduleOptions();
            this.clearErrors();
        }
    }
    constructor(){
        super();
    }
}
class GiftCardTheme extends HTMLElement {
    connectedCallback() {
        if (this.data) document.addEventListener('variantChanged', this.handleVariantChange);
    }
    disconnectedCallback() {
        if (this.data) document.removeEventListener('variantChanged', this.handleVariantChange);
    }
    updateInputs(variantID) {
        let innerHTML = '';
        const match = this.data.find((item)=>item.variant_id == variantID);
        if (match === null || match === void 0 ? void 0 : match.header_image) innerHTML += `<input type="hidden" name="properties[_header_image]" value="https:${match.header_image}" />`;
        if (match === null || match === void 0 ? void 0 : match.footer_image) innerHTML += `<input type="hidden" name="properties[_footer_image]" value="https:${match.footer_image}" />`;
        this.innerHTML = innerHTML;
    }
    handleVariantChange(e) {
        const variantID = e.detail.variant;
        this.updateInputs(variantID);
    }
    constructor(){
        var _this_querySelector;
        super();
        this.updateInputs = this.updateInputs.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.data = JSON.parse(((_this_querySelector = this.querySelector('script')) === null || _this_querySelector === void 0 ? void 0 : _this_querySelector.textContent) || 'null');
        const form = this.closest('form.ProductForm');
        if (this.data && form) {
            var _form_querySelector;
            const selectedVariantID = (_form_querySelector = form.querySelector('[name="id"]')) === null || _form_querySelector === void 0 ? void 0 : _form_querySelector.value;
            this.updateInputs(selectedVariantID);
        }
    }
}
const initEGiftCardForm = ()=>{
    customElements.define('gift-card-form', GiftCardForm);
    customElements.define('gift-card-theme', GiftCardTheme);
};
exports.default = initEGiftCardForm;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"erudU":[function(require,module,exports,__globalThis) {
(()=>{
    if (!window.location.pathname.includes('/products/')) return;
    const milliseconds = 100;
    let elapsed = 0;
    const interval = setInterval(()=>{
        const klarnaPlacement = document.querySelector('.product__block-wrapper klarna-placement');
        if (klarnaPlacement) {
            const styleTag = document.createElement('style');
            styleTag.innerText = `
                .credit-promotion-badge > .container {
                    padding: 0;
                    border: none;
                    column-gap: 14px;
                }

                .credit-promotion-badge > .container > .text-wrapper {
                    margin-left: 0;
                }
            `;
            klarnaPlacement.shadowRoot.appendChild(styleTag);
        }
        if (klarnaPlacement || elapsed >= 5000) clearInterval(interval);
        elapsed += milliseconds;
    }, milliseconds);
})();

},{}],"8onRr":[function(require,module,exports,__globalThis) {
/**
 * Swiper 7.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2021 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: December 24, 2021
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", ()=>(0, _coreJsDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _coreJsDefault.default));
parcelHelpers.export(exports, "Virtual", ()=>(0, _virtualJsDefault.default));
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboardJsDefault.default));
parcelHelpers.export(exports, "Mousewheel", ()=>(0, _mousewheelJsDefault.default));
parcelHelpers.export(exports, "Navigation", ()=>(0, _navigationJsDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationJsDefault.default));
parcelHelpers.export(exports, "Scrollbar", ()=>(0, _scrollbarJsDefault.default));
parcelHelpers.export(exports, "Parallax", ()=>(0, _parallaxJsDefault.default));
parcelHelpers.export(exports, "Zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "Lazy", ()=>(0, _lazyJsDefault.default));
parcelHelpers.export(exports, "Controller", ()=>(0, _controllerJsDefault.default));
parcelHelpers.export(exports, "A11y", ()=>(0, _a11YJsDefault.default));
parcelHelpers.export(exports, "History", ()=>(0, _historyJsDefault.default));
parcelHelpers.export(exports, "HashNavigation", ()=>(0, _hashNavigationJsDefault.default));
parcelHelpers.export(exports, "Autoplay", ()=>(0, _autoplayJsDefault.default));
parcelHelpers.export(exports, "Thumbs", ()=>(0, _thumbsJsDefault.default));
parcelHelpers.export(exports, "FreeMode", ()=>(0, _freeModeJsDefault.default));
parcelHelpers.export(exports, "Grid", ()=>(0, _gridJsDefault.default));
parcelHelpers.export(exports, "Manipulation", ()=>(0, _manipulationJsDefault.default));
parcelHelpers.export(exports, "EffectFade", ()=>(0, _effectFadeJsDefault.default));
parcelHelpers.export(exports, "EffectCube", ()=>(0, _effectCubeJsDefault.default));
parcelHelpers.export(exports, "EffectFlip", ()=>(0, _effectFlipJsDefault.default));
parcelHelpers.export(exports, "EffectCoverflow", ()=>(0, _effectCoverflowJsDefault.default));
parcelHelpers.export(exports, "EffectCreative", ()=>(0, _effectCreativeJsDefault.default));
parcelHelpers.export(exports, "EffectCards", ()=>(0, _effectCardsJsDefault.default));
var _coreJs = require("./core/core.js");
var _coreJsDefault = parcelHelpers.interopDefault(_coreJs);
var _virtualJs = require("./modules/virtual/virtual.js");
var _virtualJsDefault = parcelHelpers.interopDefault(_virtualJs);
var _keyboardJs = require("./modules/keyboard/keyboard.js");
var _keyboardJsDefault = parcelHelpers.interopDefault(_keyboardJs);
var _mousewheelJs = require("./modules/mousewheel/mousewheel.js");
var _mousewheelJsDefault = parcelHelpers.interopDefault(_mousewheelJs);
var _navigationJs = require("./modules/navigation/navigation.js");
var _navigationJsDefault = parcelHelpers.interopDefault(_navigationJs);
var _paginationJs = require("./modules/pagination/pagination.js");
var _paginationJsDefault = parcelHelpers.interopDefault(_paginationJs);
var _scrollbarJs = require("./modules/scrollbar/scrollbar.js");
var _scrollbarJsDefault = parcelHelpers.interopDefault(_scrollbarJs);
var _parallaxJs = require("./modules/parallax/parallax.js");
var _parallaxJsDefault = parcelHelpers.interopDefault(_parallaxJs);
var _zoomJs = require("./modules/zoom/zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _lazyJs = require("./modules/lazy/lazy.js");
var _lazyJsDefault = parcelHelpers.interopDefault(_lazyJs);
var _controllerJs = require("./modules/controller/controller.js");
var _controllerJsDefault = parcelHelpers.interopDefault(_controllerJs);
var _a11YJs = require("./modules/a11y/a11y.js");
var _a11YJsDefault = parcelHelpers.interopDefault(_a11YJs);
var _historyJs = require("./modules/history/history.js");
var _historyJsDefault = parcelHelpers.interopDefault(_historyJs);
var _hashNavigationJs = require("./modules/hash-navigation/hash-navigation.js");
var _hashNavigationJsDefault = parcelHelpers.interopDefault(_hashNavigationJs);
var _autoplayJs = require("./modules/autoplay/autoplay.js");
var _autoplayJsDefault = parcelHelpers.interopDefault(_autoplayJs);
var _thumbsJs = require("./modules/thumbs/thumbs.js");
var _thumbsJsDefault = parcelHelpers.interopDefault(_thumbsJs);
var _freeModeJs = require("./modules/free-mode/free-mode.js");
var _freeModeJsDefault = parcelHelpers.interopDefault(_freeModeJs);
var _gridJs = require("./modules/grid/grid.js");
var _gridJsDefault = parcelHelpers.interopDefault(_gridJs);
var _manipulationJs = require("./modules/manipulation/manipulation.js");
var _manipulationJsDefault = parcelHelpers.interopDefault(_manipulationJs);
var _effectFadeJs = require("./modules/effect-fade/effect-fade.js");
var _effectFadeJsDefault = parcelHelpers.interopDefault(_effectFadeJs);
var _effectCubeJs = require("./modules/effect-cube/effect-cube.js");
var _effectCubeJsDefault = parcelHelpers.interopDefault(_effectCubeJs);
var _effectFlipJs = require("./modules/effect-flip/effect-flip.js");
var _effectFlipJsDefault = parcelHelpers.interopDefault(_effectFlipJs);
var _effectCoverflowJs = require("./modules/effect-coverflow/effect-coverflow.js");
var _effectCoverflowJsDefault = parcelHelpers.interopDefault(_effectCoverflowJs);
var _effectCreativeJs = require("./modules/effect-creative/effect-creative.js");
var _effectCreativeJsDefault = parcelHelpers.interopDefault(_effectCreativeJs);
var _effectCardsJs = require("./modules/effect-cards/effect-cards.js");
var _effectCardsJsDefault = parcelHelpers.interopDefault(_effectCardsJs);

},{"./core/core.js":"7ryyG","./modules/virtual/virtual.js":"hO4h8","./modules/keyboard/keyboard.js":"cVcXJ","./modules/mousewheel/mousewheel.js":"KV7cJ","./modules/navigation/navigation.js":"eiPAO","./modules/pagination/pagination.js":"6u9ur","./modules/scrollbar/scrollbar.js":"4e3mA","./modules/parallax/parallax.js":"ennVV","./modules/zoom/zoom.js":"cfHcT","./modules/lazy/lazy.js":"kqovA","./modules/controller/controller.js":"9ISrA","./modules/a11y/a11y.js":"iKs0P","./modules/history/history.js":"h6otf","./modules/hash-navigation/hash-navigation.js":"7J5qQ","./modules/autoplay/autoplay.js":"8YLMd","./modules/thumbs/thumbs.js":"hDaOk","./modules/free-mode/free-mode.js":"eg74p","./modules/grid/grid.js":"ircbM","./modules/manipulation/manipulation.js":"01UaZ","./modules/effect-fade/effect-fade.js":"6rXyC","./modules/effect-cube/effect-cube.js":"DoWxt","./modules/effect-flip/effect-flip.js":"LZDHM","./modules/effect-coverflow/effect-coverflow.js":"dMss6","./modules/effect-creative/effect-creative.js":"1y4KG","./modules/effect-cards/effect-cards.js":"78y2m","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"7ryyG":[function(require,module,exports,__globalThis) {
/* eslint no-param-reassign: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _domJs = require("../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../shared/utils.js");
var _getSupportJs = require("../shared/get-support.js");
var _getDeviceJs = require("../shared/get-device.js");
var _getBrowserJs = require("../shared/get-browser.js");
var _resizeJs = require("./modules/resize/resize.js");
var _resizeJsDefault = parcelHelpers.interopDefault(_resizeJs);
var _observerJs = require("./modules/observer/observer.js");
var _observerJsDefault = parcelHelpers.interopDefault(_observerJs);
var _eventsEmitterJs = require("./events-emitter.js");
var _eventsEmitterJsDefault = parcelHelpers.interopDefault(_eventsEmitterJs);
var _indexJs = require("./update/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./translate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./transition/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./slide/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./loop/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./grab-cursor/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./events/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./breakpoints/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./classes/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./images/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./check-overflow/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _defaultsJs = require("./defaults.js");
var _defaultsJsDefault = parcelHelpers.interopDefault(_defaultsJs);
var _moduleExtendParamsJs = require("./moduleExtendParams.js");
var _moduleExtendParamsJsDefault = parcelHelpers.interopDefault(_moduleExtendParamsJs);
const prototypes = {
    eventsEmitter: (0, _eventsEmitterJsDefault.default),
    update: (0, _indexJsDefault.default),
    translate: (0, _indexJsDefault1.default),
    transition: (0, _indexJsDefault2.default),
    slide: (0, _indexJsDefault3.default),
    loop: (0, _indexJsDefault4.default),
    grabCursor: (0, _indexJsDefault5.default),
    events: (0, _indexJsDefault6.default),
    breakpoints: (0, _indexJsDefault7.default),
    checkOverflow: (0, _indexJsDefault10.default),
    classes: (0, _indexJsDefault8.default),
    images: (0, _indexJsDefault9.default)
};
const extendedDefaults = {};
class Swiper {
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl,
                classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params, slides, slidesGrid, slidesSizesGrid, size: swiperSize, activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid, params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, _domJsDefault.default)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, _domJsDefault.default)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, _ssrWindow.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, _domJsDefault.default)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el,
            el,
            $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params, $el, $wrapperEl, slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, _utilsJs.deleteProps)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, _utilsJs.extend)(extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return extendedDefaults;
    }
    static get defaults() {
        return 0, _defaultsJsDefault.default;
    }
    static installModule(mod) {
        if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>Swiper.installModule(m));
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    }
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, _utilsJs.extend)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, _domJsDefault.default)(params.el).length > 1) {
            const swipers = [];
            (0, _domJsDefault.default)(params.el).each((containerEl)=>{
                const newParams = (0, _utilsJs.extend)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, _getSupportJs.getSupport)();
        swiper.device = (0, _getDeviceJs.getDevice)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, _getBrowserJs.getBrowser)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper,
                extendParams: (0, _moduleExtendParamsJsDefault.default)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, _utilsJs.extend)({}, (0, _defaultsJsDefault.default), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, _utilsJs.extend)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0, _utilsJs.extend)({}, swiper.params);
        swiper.passedParams = (0, _utilsJs.extend)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, _domJsDefault.default); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, _domJsDefault.default)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, _utilsJs.now)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
}
Object.keys(prototypes).forEach((prototypeGroup)=>{
    Object.keys(prototypes[prototypeGroup]).forEach((protoMethod)=>{
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
});
Swiper.use([
    (0, _resizeJsDefault.default),
    (0, _observerJsDefault.default)
]);
exports.default = Swiper;

},{"ssr-window":"4FRMt","../shared/dom.js":"8kTLp","../shared/utils.js":"ehMKF","../shared/get-support.js":"aUCGE","../shared/get-device.js":"hudfe","../shared/get-browser.js":"fkuxX","./modules/resize/resize.js":"1rLUt","./modules/observer/observer.js":"jxMPk","./events-emitter.js":"fe1db","./update/index.js":"EVemk","./translate/index.js":"9cCVr","./transition/index.js":"8RtsE","./slide/index.js":"6LVvu","./loop/index.js":"39jlk","./grab-cursor/index.js":"ednVb","./events/index.js":"bbTdl","./breakpoints/index.js":"58WxA","./classes/index.js":"k0e9K","./images/index.js":"95mEo","./check-overflow/index.js":"2eP2F","./defaults.js":"k3KJv","./moduleExtendParams.js":"cXBwk","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"4FRMt":[function(require,module,exports,__globalThis) {
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "getDocument", ()=>getDocument);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "ssrDocument", ()=>ssrDocument);
parcelHelpers.export(exports, "ssrWindow", ()=>ssrWindow);
function isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) extend(target[key], src[key]);
    });
}
const ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}
const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8kTLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dom7 = require("dom7");
const Methods = {
    addClass: (0, _dom7.addClass),
    removeClass: (0, _dom7.removeClass),
    hasClass: (0, _dom7.hasClass),
    toggleClass: (0, _dom7.toggleClass),
    attr: (0, _dom7.attr),
    removeAttr: (0, _dom7.removeAttr),
    transform: (0, _dom7.transform),
    transition: (0, _dom7.transition),
    on: (0, _dom7.on),
    off: (0, _dom7.off),
    trigger: (0, _dom7.trigger),
    transitionEnd: (0, _dom7.transitionEnd),
    outerWidth: (0, _dom7.outerWidth),
    outerHeight: (0, _dom7.outerHeight),
    styles: (0, _dom7.styles),
    offset: (0, _dom7.offset),
    css: (0, _dom7.css),
    each: (0, _dom7.each),
    html: (0, _dom7.html),
    text: (0, _dom7.text),
    is: (0, _dom7.is),
    index: (0, _dom7.index),
    eq: (0, _dom7.eq),
    append: (0, _dom7.append),
    prepend: (0, _dom7.prepend),
    next: (0, _dom7.next),
    nextAll: (0, _dom7.nextAll),
    prev: (0, _dom7.prev),
    prevAll: (0, _dom7.prevAll),
    parent: (0, _dom7.parent),
    parents: (0, _dom7.parents),
    closest: (0, _dom7.closest),
    find: (0, _dom7.find),
    children: (0, _dom7.children),
    filter: (0, _dom7.filter),
    remove: (0, _dom7.remove)
};
Object.keys(Methods).forEach((methodName)=>{
    Object.defineProperty((0, _dom7.$).fn, methodName, {
        value: Methods[methodName],
        writable: true
    });
});
exports.default = (0, _dom7.$);

},{"dom7":"igour","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"igour":[function(require,module,exports,__globalThis) {
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>$);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "addClass", ()=>addClass);
parcelHelpers.export(exports, "animate", ()=>animate);
parcelHelpers.export(exports, "animationEnd", ()=>animationEnd);
parcelHelpers.export(exports, "append", ()=>append);
parcelHelpers.export(exports, "appendTo", ()=>appendTo);
parcelHelpers.export(exports, "attr", ()=>attr);
parcelHelpers.export(exports, "blur", ()=>blur);
parcelHelpers.export(exports, "change", ()=>change);
parcelHelpers.export(exports, "children", ()=>children);
parcelHelpers.export(exports, "click", ()=>click);
parcelHelpers.export(exports, "closest", ()=>closest);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "dataset", ()=>dataset);
parcelHelpers.export(exports, "detach", ()=>detach);
parcelHelpers.export(exports, "each", ()=>each);
parcelHelpers.export(exports, "empty", ()=>empty);
parcelHelpers.export(exports, "eq", ()=>eq);
parcelHelpers.export(exports, "filter", ()=>filter);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "focus", ()=>focus);
parcelHelpers.export(exports, "focusin", ()=>focusin);
parcelHelpers.export(exports, "focusout", ()=>focusout);
parcelHelpers.export(exports, "hasClass", ()=>hasClass);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "index", ()=>index);
parcelHelpers.export(exports, "insertAfter", ()=>insertAfter);
parcelHelpers.export(exports, "insertBefore", ()=>insertBefore);
parcelHelpers.export(exports, "is", ()=>is);
parcelHelpers.export(exports, "keydown", ()=>keydown);
parcelHelpers.export(exports, "keypress", ()=>keypress);
parcelHelpers.export(exports, "keyup", ()=>keyup);
parcelHelpers.export(exports, "mousedown", ()=>mousedown);
parcelHelpers.export(exports, "mouseenter", ()=>mouseenter);
parcelHelpers.export(exports, "mouseleave", ()=>mouseleave);
parcelHelpers.export(exports, "mousemove", ()=>mousemove);
parcelHelpers.export(exports, "mouseout", ()=>mouseout);
parcelHelpers.export(exports, "mouseover", ()=>mouseover);
parcelHelpers.export(exports, "mouseup", ()=>mouseup);
parcelHelpers.export(exports, "next", ()=>next);
parcelHelpers.export(exports, "nextAll", ()=>nextAll);
parcelHelpers.export(exports, "off", ()=>off);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "on", ()=>on);
parcelHelpers.export(exports, "once", ()=>once);
parcelHelpers.export(exports, "outerHeight", ()=>outerHeight);
parcelHelpers.export(exports, "outerWidth", ()=>outerWidth);
parcelHelpers.export(exports, "parent", ()=>parent);
parcelHelpers.export(exports, "parents", ()=>parents);
parcelHelpers.export(exports, "prepend", ()=>prepend);
parcelHelpers.export(exports, "prependTo", ()=>prependTo);
parcelHelpers.export(exports, "prev", ()=>prev);
parcelHelpers.export(exports, "prevAll", ()=>prevAll);
parcelHelpers.export(exports, "prop", ()=>prop);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "removeAttr", ()=>removeAttr);
parcelHelpers.export(exports, "removeClass", ()=>removeClass);
parcelHelpers.export(exports, "removeData", ()=>removeData);
parcelHelpers.export(exports, "resize", ()=>resize);
parcelHelpers.export(exports, "scroll", ()=>scroll);
parcelHelpers.export(exports, "scrollLeft", ()=>scrollLeft);
parcelHelpers.export(exports, "scrollTo", ()=>scrollTo);
parcelHelpers.export(exports, "scrollTop", ()=>scrollTop);
parcelHelpers.export(exports, "show", ()=>show);
parcelHelpers.export(exports, "siblings", ()=>siblings);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "styles", ()=>styles);
parcelHelpers.export(exports, "submit", ()=>submit);
parcelHelpers.export(exports, "text", ()=>text);
parcelHelpers.export(exports, "toggleClass", ()=>toggleClass);
parcelHelpers.export(exports, "touchend", ()=>touchend);
parcelHelpers.export(exports, "touchmove", ()=>touchmove);
parcelHelpers.export(exports, "touchstart", ()=>touchstart);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transition", ()=>transition);
parcelHelpers.export(exports, "transitionEnd", ()=>transitionEnd);
parcelHelpers.export(exports, "transitionStart", ()=>transitionStart);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "val", ()=>val);
parcelHelpers.export(exports, "value", ()=>value);
parcelHelpers.export(exports, "width", ()=>width);
var _ssrWindow = require("ssr-window");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, _ssrWindow.getWindow)();
    const document = (0, _ssrWindow.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, _ssrWindow.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, _ssrWindow.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, _ssrWindow.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, _ssrWindow.getWindow)();
        const document = (0, _ssrWindow.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, _ssrWindow.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, _ssrWindow.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, _ssrWindow.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, _ssrWindow.getWindow)();
    const document = (0, _ssrWindow.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, _ssrWindow.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, _ssrWindow.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, _ssrWindow.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, _ssrWindow.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue,
                        initialValue,
                        unit,
                        finalValue,
                        finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
exports.default = $;

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"ehMKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateCSSModeScroll", ()=>animateCSSModeScroll);
parcelHelpers.export(exports, "deleteProps", ()=>deleteProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "getTranslate", ()=>getTranslate);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "setCSSProperty", ()=>setCSSProperty);
var _ssrWindow = require("ssr-window");
function deleteProps(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function nextTick(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    const window1 = (0, _ssrWindow.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function getTranslate(el, axis = 'x') {
    const window1 = (0, _ssrWindow.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = getComputedStyle(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll({ swiper, targetPosition, side }) {
    const window1 = (0, _ssrWindow.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"aUCGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSupport", ()=>getSupport);
var _ssrWindow = require("ssr-window");
let support;
function calcSupport() {
    const window = (0, _ssrWindow.getWindow)();
    const document = (0, _ssrWindow.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function getSupport() {
    if (!support) support = calcSupport();
    return support;
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hudfe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDevice", ()=>getDevice);
var _ssrWindow = require("ssr-window");
var _getSupportJs = require("./get-support.js");
let deviceCached;
function calcDevice({ userAgent } = {}) {
    const support = (0, _getSupportJs.getSupport)();
    const window = (0, _ssrWindow.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function getDevice(overrides = {}) {
    if (!deviceCached) deviceCached = calcDevice(overrides);
    return deviceCached;
}

},{"ssr-window":"4FRMt","./get-support.js":"aUCGE","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"fkuxX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBrowser", ()=>getBrowser);
var _ssrWindow = require("ssr-window");
let browser;
function calcBrowser() {
    const window = (0, _ssrWindow.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function getBrowser() {
    if (!browser) browser = calcBrowser();
    return browser;
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"1rLUt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Resize);
var _ssrWindow = require("ssr-window");
function Resize({ swiper, on, emit }) {
    const window = (0, _ssrWindow.getWindow)();
    let observer = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            const { width, height } = swiper;
            let newWidth = width;
            let newHeight = height;
            entries.forEach(({ contentBoxSize, contentRect, target })=>{
                if (target && target !== swiper.el) return;
                newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
            });
            if (newWidth !== width || newHeight !== height) resizeHandler();
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"jxMPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Observer);
var _ssrWindow = require("ssr-window");
function Observer({ swiper, extendParams, on, emit }) {
    const observers = [];
    const window = (0, _ssrWindow.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"fe1db":[function(require,module,exports,__globalThis) {
/* eslint-disable no-underscore-dangle */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    on (events, handler, priority) {
        const self = this;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"EVemk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _updateSizeJs = require("./updateSize.js");
var _updateSizeJsDefault = parcelHelpers.interopDefault(_updateSizeJs);
var _updateSlidesJs = require("./updateSlides.js");
var _updateSlidesJsDefault = parcelHelpers.interopDefault(_updateSlidesJs);
var _updateAutoHeightJs = require("./updateAutoHeight.js");
var _updateAutoHeightJsDefault = parcelHelpers.interopDefault(_updateAutoHeightJs);
var _updateSlidesOffsetJs = require("./updateSlidesOffset.js");
var _updateSlidesOffsetJsDefault = parcelHelpers.interopDefault(_updateSlidesOffsetJs);
var _updateSlidesProgressJs = require("./updateSlidesProgress.js");
var _updateSlidesProgressJsDefault = parcelHelpers.interopDefault(_updateSlidesProgressJs);
var _updateProgressJs = require("./updateProgress.js");
var _updateProgressJsDefault = parcelHelpers.interopDefault(_updateProgressJs);
var _updateSlidesClassesJs = require("./updateSlidesClasses.js");
var _updateSlidesClassesJsDefault = parcelHelpers.interopDefault(_updateSlidesClassesJs);
var _updateActiveIndexJs = require("./updateActiveIndex.js");
var _updateActiveIndexJsDefault = parcelHelpers.interopDefault(_updateActiveIndexJs);
var _updateClickedSlideJs = require("./updateClickedSlide.js");
var _updateClickedSlideJsDefault = parcelHelpers.interopDefault(_updateClickedSlideJs);
exports.default = {
    updateSize: (0, _updateSizeJsDefault.default),
    updateSlides: (0, _updateSlidesJsDefault.default),
    updateAutoHeight: (0, _updateAutoHeightJsDefault.default),
    updateSlidesOffset: (0, _updateSlidesOffsetJsDefault.default),
    updateSlidesProgress: (0, _updateSlidesProgressJsDefault.default),
    updateProgress: (0, _updateProgressJsDefault.default),
    updateSlidesClasses: (0, _updateSlidesClassesJsDefault.default),
    updateActiveIndex: (0, _updateActiveIndexJsDefault.default),
    updateClickedSlide: (0, _updateClickedSlideJsDefault.default)
};

},{"./updateSize.js":"pURKg","./updateSlides.js":"upWBw","./updateAutoHeight.js":"hjXdH","./updateSlidesOffset.js":"2hNp8","./updateSlidesProgress.js":"eypSk","./updateProgress.js":"5JwnO","./updateSlidesClasses.js":"9z5E8","./updateActiveIndex.js":"QtQaD","./updateClickedSlide.js":"bfGB7","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"pURKg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSize);
function updateSize() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"upWBw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSlides);
var _utilsJs = require("../../shared/utils.js");
function updateSlides() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth, offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hjXdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateAutoHeight);
function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"2hNp8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSlidesOffset);
function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"eypSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSlidesProgress);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides, rtlTranslate: rtl, snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, _domJsDefault.default)(swiper.visibleSlides);
}

},{"../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"5JwnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateProgress);
function updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress, isBeginning, isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress,
        isBeginning,
        isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9z5E8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateSlidesClasses);
function updateSlidesClasses() {
    const swiper = this;
    const { slides, params, $wrapperEl, activeIndex, realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"QtQaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateActiveIndex);
function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid, snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex,
        realIndex,
        previousIndex,
        activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"bfGB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateClickedSlide);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function updateClickedSlide(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, _domJsDefault.default)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, _domJsDefault.default)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}

},{"../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9cCVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getTranslateJs = require("./getTranslate.js");
var _getTranslateJsDefault = parcelHelpers.interopDefault(_getTranslateJs);
var _setTranslateJs = require("./setTranslate.js");
var _setTranslateJsDefault = parcelHelpers.interopDefault(_setTranslateJs);
var _minTranslateJs = require("./minTranslate.js");
var _minTranslateJsDefault = parcelHelpers.interopDefault(_minTranslateJs);
var _maxTranslateJs = require("./maxTranslate.js");
var _maxTranslateJsDefault = parcelHelpers.interopDefault(_maxTranslateJs);
var _translateToJs = require("./translateTo.js");
var _translateToJsDefault = parcelHelpers.interopDefault(_translateToJs);
exports.default = {
    getTranslate: (0, _getTranslateJsDefault.default),
    setTranslate: (0, _setTranslateJsDefault.default),
    minTranslate: (0, _minTranslateJsDefault.default),
    maxTranslate: (0, _maxTranslateJsDefault.default),
    translateTo: (0, _translateToJsDefault.default)
};

},{"./getTranslate.js":"c4PsN","./setTranslate.js":"68Bwg","./minTranslate.js":"azvXz","./maxTranslate.js":"8ibAw","./translateTo.js":"erZ4j","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"c4PsN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSwiperTranslate);
var _utilsJs = require("../../shared/utils.js");
function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params, rtlTranslate: rtl, translate, $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, _utilsJs.getTranslate)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"68Bwg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setTranslate);
function setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params, $wrapperEl, wrapperEl, progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"azvXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>minTranslate);
function minTranslate() {
    return -this.snapGrid[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8ibAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>maxTranslate);
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"erZ4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>translateTo);
var _utilsJs = require("../../shared/utils.js");
function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params, wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsJs.animateCSSModeScroll)({
                    swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8RtsE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setTransitionJs = require("./setTransition.js");
var _setTransitionJsDefault = parcelHelpers.interopDefault(_setTransitionJs);
var _transitionStartJs = require("./transitionStart.js");
var _transitionStartJsDefault = parcelHelpers.interopDefault(_transitionStartJs);
var _transitionEndJs = require("./transitionEnd.js");
var _transitionEndJsDefault = parcelHelpers.interopDefault(_transitionEndJs);
exports.default = {
    setTransition: (0, _setTransitionJsDefault.default),
    transitionStart: (0, _transitionStartJsDefault.default),
    transitionEnd: (0, _transitionEndJsDefault.default)
};

},{"./setTransition.js":"gwbpP","./transitionStart.js":"45S4e","./transitionEnd.js":"4uQCN","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"gwbpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setTransition);
function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"45S4e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionStart);
var _transitionEmitJs = require("./transitionEmit.js");
var _transitionEmitJsDefault = parcelHelpers.interopDefault(_transitionEmitJs);
function transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, _transitionEmitJsDefault.default)({
        swiper,
        runCallbacks,
        direction,
        step: 'Start'
    });
}

},{"./transitionEmit.js":"6APeZ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6APeZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEmit);
function transitionEmit({ swiper, runCallbacks, direction, step }) {
    const { activeIndex, previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"4uQCN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transitionEnd);
var _transitionEmitJs = require("./transitionEmit.js");
var _transitionEmitJsDefault = parcelHelpers.interopDefault(_transitionEmitJs);
function transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, _transitionEmitJsDefault.default)({
        swiper,
        runCallbacks,
        direction,
        step: 'End'
    });
}

},{"./transitionEmit.js":"6APeZ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6LVvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slideToJs = require("./slideTo.js");
var _slideToJsDefault = parcelHelpers.interopDefault(_slideToJs);
var _slideToLoopJs = require("./slideToLoop.js");
var _slideToLoopJsDefault = parcelHelpers.interopDefault(_slideToLoopJs);
var _slideNextJs = require("./slideNext.js");
var _slideNextJsDefault = parcelHelpers.interopDefault(_slideNextJs);
var _slidePrevJs = require("./slidePrev.js");
var _slidePrevJsDefault = parcelHelpers.interopDefault(_slidePrevJs);
var _slideResetJs = require("./slideReset.js");
var _slideResetJsDefault = parcelHelpers.interopDefault(_slideResetJs);
var _slideToClosestJs = require("./slideToClosest.js");
var _slideToClosestJsDefault = parcelHelpers.interopDefault(_slideToClosestJs);
var _slideToClickedSlideJs = require("./slideToClickedSlide.js");
var _slideToClickedSlideJsDefault = parcelHelpers.interopDefault(_slideToClickedSlideJs);
exports.default = {
    slideTo: (0, _slideToJsDefault.default),
    slideToLoop: (0, _slideToLoopJsDefault.default),
    slideNext: (0, _slideNextJsDefault.default),
    slidePrev: (0, _slidePrevJsDefault.default),
    slideReset: (0, _slideResetJsDefault.default),
    slideToClosest: (0, _slideToClosestJsDefault.default),
    slideToClickedSlide: (0, _slideToClickedSlideJsDefault.default)
};

},{"./slideTo.js":"bohEz","./slideToLoop.js":"3JnKl","./slideNext.js":"f2M8r","./slidePrev.js":"1hyck","./slideReset.js":"38gN1","./slideToClosest.js":"a9KBp","./slideToClickedSlide.js":"fGRsG","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"bohEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideTo);
var _utilsJs = require("../../shared/utils.js");
function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl, enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    const translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsJs.animateCSSModeScroll)({
                    swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"3JnKl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideToLoop);
function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"f2M8r":[function(require,module,exports,__globalThis) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideNext);
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating, enabled, params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"1hyck":[function(require,module,exports,__globalThis) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slidePrev);
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params, animating, snapGrid, slidesGrid, rtlTranslate, enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) return swiper.slideTo(swiper.slides.length - 1, speed, runCallbacks, internal);
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"38gN1":[function(require,module,exports,__globalThis) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideReset);
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"a9KBp":[function(require,module,exports,__globalThis) {
/* eslint no-unused-vars: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideToClosest);
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"fGRsG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>slideToClickedSlide);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function slideToClickedSlide() {
    const swiper = this;
    const { params, $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, _domJsDefault.default)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, _utilsJs.nextTick)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, _utilsJs.nextTick)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}

},{"../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"39jlk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loopCreateJs = require("./loopCreate.js");
var _loopCreateJsDefault = parcelHelpers.interopDefault(_loopCreateJs);
var _loopFixJs = require("./loopFix.js");
var _loopFixJsDefault = parcelHelpers.interopDefault(_loopFixJs);
var _loopDestroyJs = require("./loopDestroy.js");
var _loopDestroyJsDefault = parcelHelpers.interopDefault(_loopDestroyJs);
exports.default = {
    loopCreate: (0, _loopCreateJsDefault.default),
    loopFix: (0, _loopFixJsDefault.default),
    loopDestroy: (0, _loopDestroyJsDefault.default)
};

},{"./loopCreate.js":"j8XA0","./loopFix.js":"cZkYv","./loopDestroy.js":"7Vaqm","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"j8XA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>loopCreate);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function loopCreate() {
    const swiper = this;
    const document = (0, _ssrWindow.getDocument)();
    const { params, $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, _domJsDefault.default)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, _domJsDefault.default)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, _domJsDefault.default)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, _domJsDefault.default)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, _domJsDefault.default)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"cZkYv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>loopFix);
function loopFix() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex, slides, loopedSlides, allowSlidePrev, allowSlideNext, snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"7Vaqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>loopDestroy);
function loopDestroy() {
    const swiper = this;
    const { $wrapperEl, params, slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"ednVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setGrabCursorJs = require("./setGrabCursor.js");
var _setGrabCursorJsDefault = parcelHelpers.interopDefault(_setGrabCursorJs);
var _unsetGrabCursorJs = require("./unsetGrabCursor.js");
var _unsetGrabCursorJsDefault = parcelHelpers.interopDefault(_unsetGrabCursorJs);
exports.default = {
    setGrabCursor: (0, _setGrabCursorJsDefault.default),
    unsetGrabCursor: (0, _unsetGrabCursorJsDefault.default)
};

},{"./setGrabCursor.js":"9x6Ar","./unsetGrabCursor.js":"ezPv9","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9x6Ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setGrabCursor);
function setGrabCursor(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"ezPv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unsetGrabCursor);
function unsetGrabCursor() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"bbTdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ssrWindow = require("ssr-window");
var _onTouchStartJs = require("./onTouchStart.js");
var _onTouchStartJsDefault = parcelHelpers.interopDefault(_onTouchStartJs);
var _onTouchMoveJs = require("./onTouchMove.js");
var _onTouchMoveJsDefault = parcelHelpers.interopDefault(_onTouchMoveJs);
var _onTouchEndJs = require("./onTouchEnd.js");
var _onTouchEndJsDefault = parcelHelpers.interopDefault(_onTouchEndJs);
var _onResizeJs = require("./onResize.js");
var _onResizeJsDefault = parcelHelpers.interopDefault(_onResizeJs);
var _onClickJs = require("./onClick.js");
var _onClickJsDefault = parcelHelpers.interopDefault(_onClickJs);
var _onScrollJs = require("./onScroll.js");
var _onScrollJsDefault = parcelHelpers.interopDefault(_onScrollJs);
let dummyEventAttached = false;
function dummyEventListener() {}
const events = (swiper, method)=>{
    const document = (0, _ssrWindow.getDocument)();
    const { params, touchEvents, el, wrapperEl, device, support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, _onResizeJsDefault.default), true);
    else swiper[swiperMethod]('observerUpdate', (0, _onResizeJsDefault.default), true);
};
function attachEvents() {
    const swiper = this;
    const document = (0, _ssrWindow.getDocument)();
    const { params, support } = swiper;
    swiper.onTouchStart = (0, _onTouchStartJsDefault.default).bind(swiper);
    swiper.onTouchMove = (0, _onTouchMoveJsDefault.default).bind(swiper);
    swiper.onTouchEnd = (0, _onTouchEndJsDefault.default).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, _onScrollJsDefault.default).bind(swiper);
    swiper.onClick = (0, _onClickJsDefault.default).bind(swiper);
    if (support.touch && !dummyEventAttached) {
        document.addEventListener('touchstart', dummyEventListener);
        dummyEventAttached = true;
    }
    events(swiper, 'on');
}
function detachEvents() {
    const swiper = this;
    events(swiper, 'off');
}
exports.default = {
    attachEvents,
    detachEvents
};

},{"ssr-window":"4FRMt","./onTouchStart.js":"8FFQd","./onTouchMove.js":"jb15i","./onTouchEnd.js":"8bvvB","./onResize.js":"95iVc","./onClick.js":"evaIr","./onScroll.js":"9ZJuc","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8FFQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onTouchStart);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js"); // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, _ssrWindow.getDocument)() || el === (0, _ssrWindow.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function onTouchStart(event) {
    const swiper = this;
    const document = (0, _ssrWindow.getDocument)();
    const window = (0, _ssrWindow.getWindow)();
    const data = swiper.touchEventsData;
    const { params, touches, enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, _domJsDefault.default)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, _domJsDefault.default)(event.path[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, _utilsJs.now)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, _domJsDefault.default)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit('touchStart', e);
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"jb15i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onTouchMove);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function onTouchMove(event) {
    const document = (0, _ssrWindow.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params, touches, rtlTranslate: rtl, enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, _utilsJs.now)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, _domJsDefault.default)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8bvvB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onTouchEnd);
var _utilsJs = require("../../shared/utils.js");
function onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params, touches, rtlTranslate: rtl, slidesGrid, enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, _utilsJs.now)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, _utilsJs.now)();
    (0, _utilsJs.nextTick)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"95iVc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onResize);
function onResize() {
    const swiper = this;
    const { params, el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext, allowSlidePrev, snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"evaIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onClick);
function onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9ZJuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>onScroll);
function onScroll() {
    const swiper = this;
    const { wrapperEl, rtlTranslate, enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"58WxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setBreakpointJs = require("./setBreakpoint.js");
var _setBreakpointJsDefault = parcelHelpers.interopDefault(_setBreakpointJs);
var _getBreakpointJs = require("./getBreakpoint.js");
var _getBreakpointJsDefault = parcelHelpers.interopDefault(_getBreakpointJs);
exports.default = {
    setBreakpoint: (0, _setBreakpointJsDefault.default),
    getBreakpoint: (0, _getBreakpointJsDefault.default)
};

},{"./setBreakpoint.js":"8Rv1C","./getBreakpoint.js":"dAkeH","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8Rv1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setBreakpoint);
var _utilsJs = require("../../shared/utils.js");
const isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
    const swiper = this;
    const { activeIndex, initialized, loopedSlides = 0, params, $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, _utilsJs.extend)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"dAkeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBreakpoint);
var _ssrWindow = require("ssr-window");
function getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, _ssrWindow.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value,
                point
            };
        }
        return {
            value: point,
            point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point, value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"k0e9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addClassesJs = require("./addClasses.js");
var _addClassesJsDefault = parcelHelpers.interopDefault(_addClassesJs);
var _removeClassesJs = require("./removeClasses.js");
var _removeClassesJsDefault = parcelHelpers.interopDefault(_removeClassesJs);
exports.default = {
    addClasses: (0, _addClassesJsDefault.default),
    removeClasses: (0, _removeClassesJsDefault.default)
};

},{"./addClasses.js":"dfP6d","./removeClasses.js":"lpNfp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"dfP6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClasses);
function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function addClasses() {
    const swiper = this;
    const { classNames, params, rtl, $el, device, support } = swiper; // prettier-ignore
    const suffixes = prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"lpNfp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClasses);
function removeClasses() {
    const swiper = this;
    const { $el, classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"95mEo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loadImageJs = require("./loadImage.js");
var _loadImageJsDefault = parcelHelpers.interopDefault(_loadImageJs);
var _preloadImagesJs = require("./preloadImages.js");
var _preloadImagesJsDefault = parcelHelpers.interopDefault(_preloadImagesJs);
exports.default = {
    loadImage: (0, _loadImageJsDefault.default),
    preloadImages: (0, _preloadImagesJsDefault.default)
};

},{"./loadImage.js":"c1p8h","./preloadImages.js":"12apv","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"c1p8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>loadImage);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, _ssrWindow.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, _domJsDefault.default)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"12apv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>preloadImages);
function preloadImages() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"2eP2F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params } = swiper;
    const { slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
exports.default = {
    checkOverflow
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"k3KJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"cXBwk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>moduleExtendParams);
var _utilsJs = require("../shared/utils.js");
function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, _utilsJs.extend)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, _utilsJs.extend)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, _utilsJs.extend)(allModulesParams, obj);
    };
}

},{"../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hO4h8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Virtual);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Virtual({ swiper, extendParams, on }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, _domJsDefault.default)(params.renderSlide.call(swiper, slide, index)) : (0, _domJsDefault.default)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView, slidesPerGroup, centeredSlides } = swiper.params;
        const { addSlidesBefore, addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from,
            to,
            offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset,
                from,
                to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, _utilsJs.setCSSProperty)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide,
        prependSlide,
        removeSlide,
        removeAllSlides,
        update
    });
}

},{"../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"cVcXJ":[function(require,module,exports,__globalThis) {
/* eslint-disable consistent-return */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Keyboard);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Keyboard({ swiper, extendParams, on, emit }) {
    const document = (0, _ssrWindow.getDocument)();
    const window = (0, _ssrWindow.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, _domJsDefault.default)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, _domJsDefault.default)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable,
        disable
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"KV7cJ":[function(require,module,exports,__globalThis) {
/* eslint-disable consistent-return */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Mousewheel);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Mousewheel({ swiper, extendParams, on, emit }) {
    const window = (0, _ssrWindow.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, _utilsJs.now)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, _utilsJs.now)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, _utilsJs.now)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, _domJsDefault.default)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, _utilsJs.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, _utilsJs.now)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, _utilsJs.nextTick)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, _utilsJs.nextTick)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, _domJsDefault.default)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable,
        disable
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"eiPAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Navigation({ swiper, extendParams, on, emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, _domJsDefault.default)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl, $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        init();
        update();
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl, $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, _domJsDefault.default)(targetEl).is($prevEl) && !(0, _domJsDefault.default)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    Object.assign(swiper.navigation, {
        update,
        init,
        destroy
    });
}

},{"../../shared/create-element-if-not-defined.js":"fvJGj","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"fvJGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createElementIfNotDefined);
var _ssrWindow = require("ssr-window");
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    const document = (0, _ssrWindow.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6u9ur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Pagination);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _classesToSelectorJs = require("../../shared/classes-to-selector.js");
var _classesToSelectorJsDefault = parcelHelpers.interopDefault(_classesToSelectorJs);
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
function Pagination({ swiper, extendParams, on, emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, _domJsDefault.default)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, _classesToSelectorJsDefault.default)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, _classesToSelectorJsDefault.default)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, _classesToSelectorJsDefault.default)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, _classesToSelectorJsDefault.default)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, _domJsDefault.default)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, _domJsDefault.default)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(params.modifierClass + swiper.params.direction);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, _classesToSelectorJsDefault.default)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, _domJsDefault.default)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(params.modifierClass + swiper.params.direction);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, _classesToSelectorJsDefault.default)(params.bulletClass));
    }
    on('init', ()=>{
        init();
        render();
        update();
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el.length > 0 && !(0, _domJsDefault.default)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    Object.assign(swiper.pagination, {
        render,
        update,
        init,
        destroy
    });
}

},{"../../shared/dom.js":"8kTLp","../../shared/classes-to-selector.js":"gmbRR","../../shared/create-element-if-not-defined.js":"fvJGj","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"gmbRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>classesToSelector);
function classesToSelector(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"4e3mA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Scrollbar);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
var _createElementIfNotDefinedJs = require("../../shared/create-element-if-not-defined.js");
var _createElementIfNotDefinedJsDefault = parcelHelpers.interopDefault(_createElementIfNotDefinedJs);
function Scrollbar({ swiper, extendParams, on, emit }) {
    const document = (0, _ssrWindow.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag'
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar, rtlTranslate: rtl, progress } = swiper;
        const { $dragEl, $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar } = swiper;
        const { $dragEl, $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar, $wrapperEl } = swiper;
        const { $el, $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar, $wrapperEl } = swiper;
        const { $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, _utilsJs.nextTick)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar, touchEventsTouch, touchEventsDesktop, params, support } = swiper;
        const $el = scrollbar.$el;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, _createElementIfNotDefinedJsDefault.default)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, _domJsDefault.default)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, _domJsDefault.default)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el,
            el: $el[0],
            $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        disableDraggable();
    }
    on('init', ()=>{
        init();
        updateSize();
        setTranslate();
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    Object.assign(swiper.scrollbar, {
        updateSize,
        setTranslate,
        init,
        destroy
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","../../shared/create-element-if-not-defined.js":"fvJGj","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"ennVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Parallax);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Parallax({ swiper, extendParams, on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl } = swiper;
        const $el = (0, _domJsDefault.default)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el, slides, progress, snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, _domJsDefault.default)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, _domJsDefault.default)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

},{"../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"cfHcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Zoom);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _utilsJs = require("../../shared/utils.js");
function Zoom({ swiper, extendParams, on, emit }) {
    const window = (0, _ssrWindow.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, _domJsDefault.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, _utilsJs.getTranslate)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, _utilsJs.getTranslate)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, _domJsDefault.default)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener,
            activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable,
        disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"kqovA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Lazy);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Lazy({ swiper, extendParams, on, emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, _domJsDefault.default)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, _domJsDefault.default)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl, params: swiperParams, slides, activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, _domJsDefault.default)(slideEl).attr('data-swiper-slide-index');
            return (0, _domJsDefault.default)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, _domJsDefault.default)(slideEl).attr('data-swiper-slide-index') : (0, _domJsDefault.default)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = slidesPerView;
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + slidesPerView; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, _ssrWindow.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, _domJsDefault.default)(swiper.params.lazy.scrollingElement) : (0, _domJsDefault.default)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy, cssMode, watchSlidesProgress, touchReleaseOnEdges, resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    Object.assign(swiper.lazy, {
        load,
        loadInSlide
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9ISrA":[function(require,module,exports,__globalThis) {
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Controller);
var _utilsJs = require("../../shared/utils.js");
function Controller({ swiper, extendParams, on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, _utilsJs.nextTick)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate,
        setTransition
    });
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"iKs0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>A11y);
var _classesToSelectorJs = require("../../shared/classes-to-selector.js");
var _classesToSelectorJsDefault = parcelHelpers.interopDefault(_classesToSelectorJs);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function A11y({ swiper, extendParams, on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group'
        }
    });
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, _domJsDefault.default)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl, $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, _domJsDefault.default)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    function init() {
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, _domJsDefault.default)(swiper.slides), params.itemRoleDescriptionMessage);
        addElRole((0, _domJsDefault.default)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, _domJsDefault.default)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        }); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, _classesToSelectorJsDefault.default)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, _domJsDefault.default)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
        updateNavigation();
    });
    on('toEdge', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('fromEdge', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

},{"../../shared/classes-to-selector.js":"gmbRR","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"h6otf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>History);
var _ssrWindow = require("ssr-window");
function History({ swiper, extendParams, on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides'
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, _ssrWindow.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key,
            value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, _ssrWindow.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value
        }, null, value);
        else window.history.pushState({
            value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, swiper.paths.value, false);
    };
    const init = ()=>{
        const window = (0, _ssrWindow.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, _ssrWindow.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

},{"ssr-window":"4FRMt","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"7J5qQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HashNavigation);
var _ssrWindow = require("ssr-window");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function HashNavigation({ swiper, extendParams, emit, on }) {
    let initialized = false;
    const document = (0, _ssrWindow.getDocument)();
    const window = (0, _ssrWindow.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, _domJsDefault.default)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, _domJsDefault.default)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}

},{"ssr-window":"4FRMt","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"8YLMd":[function(require,module,exports,__globalThis) {
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Autoplay);
var _ssrWindow = require("ssr-window");
var _utilsJs = require("../../shared/utils.js");
function Autoplay({ swiper, extendParams, on, emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, _utilsJs.nextTick)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, _ssrWindow.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else pause();
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, _ssrWindow.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, _ssrWindow.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause,
        run,
        start,
        stop
    });
}

},{"ssr-window":"4FRMt","../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hDaOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Thumb);
var _utilsJs = require("../../shared/utils.js");
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function Thumb({ swiper, extendParams, on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, _domJsDefault.default)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, _domJsDefault.default)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, _utilsJs.isObject)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        } // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
    }
    on('beforeInit', ()=>{
        const { thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        if (!swiper.thumbs.swiper) return;
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) return;
        if (swiperCreated && thumbsSwiper) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init,
        update
    });
}

},{"../../shared/utils.js":"ehMKF","../../shared/dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"eg74p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>freeMode);
var _utilsJs = require("../../shared/utils.js");
function freeMode({ swiper, extendParams, emit, once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchMove() {
        const { touchEventsData: data, touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, _utilsJs.now)()
        });
    }
    function onTouchEnd({ currentPos }) {
        const { params, $wrapperEl, rtlTranslate: rtl, snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, _utilsJs.now)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, _utilsJs.now)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchMove,
            onTouchEnd
        }
    });
}

},{"../../shared/utils.js":"ehMKF","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"ircbM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Grid);
function Grid({ swiper, extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView } = swiper.params;
        const { rows, fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup, spaceBetween } = swiper.params;
        const { rows, fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween, centeredSlides, roundLengths } = swiper.params;
        const { rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides,
        updateSlide,
        updateWrapperSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"01UaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Manipulation);
var _appendSlideJs = require("./methods/appendSlide.js");
var _appendSlideJsDefault = parcelHelpers.interopDefault(_appendSlideJs);
var _prependSlideJs = require("./methods/prependSlide.js");
var _prependSlideJsDefault = parcelHelpers.interopDefault(_prependSlideJs);
var _addSlideJs = require("./methods/addSlide.js");
var _addSlideJsDefault = parcelHelpers.interopDefault(_addSlideJs);
var _removeSlideJs = require("./methods/removeSlide.js");
var _removeSlideJsDefault = parcelHelpers.interopDefault(_removeSlideJs);
var _removeAllSlidesJs = require("./methods/removeAllSlides.js");
var _removeAllSlidesJsDefault = parcelHelpers.interopDefault(_removeAllSlidesJs);
function Manipulation({ swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, _appendSlideJsDefault.default).bind(swiper),
        prependSlide: (0, _prependSlideJsDefault.default).bind(swiper),
        addSlide: (0, _addSlideJsDefault.default).bind(swiper),
        removeSlide: (0, _removeSlideJsDefault.default).bind(swiper),
        removeAllSlides: (0, _removeAllSlidesJsDefault.default).bind(swiper)
    });
}

},{"./methods/appendSlide.js":"9jbPM","./methods/prependSlide.js":"MWB0R","./methods/addSlide.js":"9KqBa","./methods/removeSlide.js":"3vypd","./methods/removeAllSlides.js":"l8EMm","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9jbPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>appendSlide);
function appendSlide(slides) {
    const swiper = this;
    const { $wrapperEl, params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"MWB0R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>prependSlide);
function prependSlide(slides) {
    const swiper = this;
    const { params, $wrapperEl, activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"9KqBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addSlide);
function addSlide(index, slides) {
    const swiper = this;
    const { $wrapperEl, params, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"3vypd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeSlide);
function removeSlide(slidesIndexes) {
    const swiper = this;
    const { params, $wrapperEl, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"l8EMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeAllSlides);
function removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6rXyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFade);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectFade({ swiper, extendParams, on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper,
            duration,
            transformEl,
            allSlides: true
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: 'fade',
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../../shared/effect-init.js":"g2QI3","../../shared/effect-target.js":"hmjiM","../../shared/effect-virtual-transition-end.js":"lMZoJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"g2QI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>effectInit);
function effectInit(params) {
    const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"hmjiM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>effectTarget);
function effectTarget(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"lMZoJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>effectVirtualTransitionEnd);
function effectVirtualTransitionEnd({ swiper, duration, transformEl, allSlides }) {
    const { slides, activeIndex, $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"DoWxt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCube);
var _domJs = require("../../shared/dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
function EffectCube({ swiper, extendParams, on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const setTranslate = ()=>{
        const { $el, $wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, _domJsDefault.default)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, _domJsDefault.default)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) {
                // Set shadows
                let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) {
                    shadowBefore = (0, _domJsDefault.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
                    $slideEl.append(shadowBefore);
                }
                if (shadowAfter.length === 0) {
                    shadowAfter = (0, _domJsDefault.default)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
                    $slideEl.append(shadowAfter);
                }
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
    };
    const setTransition = (duration)=>{
        const { $el, slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, _effectInitJsDefault.default)({
        effect: 'cube',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}

},{"../../shared/dom.js":"8kTLp","../../shared/effect-init.js":"g2QI3","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"LZDHM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectFlip);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectFlip({ swiper, extendParams, on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) {
                // Set shadows
                let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if (shadowBefore.length === 0) shadowBefore = (0, _createShadowJsDefault.default)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
                if (shadowAfter.length === 0) shadowAfter = (0, _createShadowJsDefault.default)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
                if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper,
            duration,
            transformEl
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: 'flip',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../../shared/create-shadow.js":"6Roh1","../../shared/effect-init.js":"g2QI3","../../shared/effect-target.js":"hmjiM","../../shared/effect-virtual-transition-end.js":"lMZoJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"6Roh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createShadow);
var _domJs = require("./dom.js");
var _domJsDefault = parcelHelpers.interopDefault(_domJs);
function createShadow(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, _domJsDefault.default)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}

},{"./dom.js":"8kTLp","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"dMss6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCoverflow);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
function EffectCoverflow({ swiper, extendParams, on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides, slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, _createShadowJsDefault.default)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, _createShadowJsDefault.default)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, _effectInitJsDefault.default)({
        effect: 'coverflow',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}

},{"../../shared/create-shadow.js":"6Roh1","../../shared/effect-init.js":"g2QI3","../../shared/effect-target.js":"hmjiM","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"1y4KG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCreative);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectCreative({ swiper, extendParams, on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides, $wrapperEl, slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, _createShadowJsDefault.default)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper,
            duration,
            transformEl,
            allSlides: true
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: 'creative',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../../shared/create-shadow.js":"6Roh1","../../shared/effect-init.js":"g2QI3","../../shared/effect-target.js":"hmjiM","../../shared/effect-virtual-transition-end.js":"lMZoJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"78y2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EffectCards);
var _createShadowJs = require("../../shared/create-shadow.js");
var _createShadowJsDefault = parcelHelpers.interopDefault(_createShadowJs);
var _effectInitJs = require("../../shared/effect-init.js");
var _effectInitJsDefault = parcelHelpers.interopDefault(_effectInitJs);
var _effectTargetJs = require("../../shared/effect-target.js");
var _effectTargetJsDefault = parcelHelpers.interopDefault(_effectTargetJs);
var _effectVirtualTransitionEndJs = require("../../shared/effect-virtual-transition-end.js");
var _effectVirtualTransitionEndJsDefault = parcelHelpers.interopDefault(_effectVirtualTransitionEndJs);
function EffectCards({ swiper, extendParams, on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides, activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate, isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -2 * progress;
            let tXAdd = 8 - Math.abs(progress) * 0.75;
            const isSwipeToNext = (i === activeIndex || i === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (i === activeIndex || i === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${rotate}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, _createShadowJsDefault.default)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, _effectTargetJsDefault.default)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, _effectVirtualTransitionEndJsDefault.default)({
            swiper,
            duration,
            transformEl
        });
    };
    (0, _effectInitJsDefault.default)({
        effect: 'cards',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}

},{"../../shared/create-shadow.js":"6Roh1","../../shared/effect-init.js":"g2QI3","../../shared/effect-target.js":"hmjiM","../../shared/effect-virtual-transition-end.js":"lMZoJ","@parcel/transformer-js/src/esmodule-helpers.js":"8mNUT"}],"lb26F":[function() {},{}]},["ljrb6"], "ljrb6", "parcelRequireb069", {})

